var vf = { exports: {} }, pu = {};
var xd;
function mv() {
  if (xd) return pu;
  xd = 1;
  var d = /* @__PURE__ */ Symbol.for("react.transitional.element"), _ = /* @__PURE__ */ Symbol.for("react.fragment");
  function D(r, C, Q) {
    var W = null;
    if (Q !== void 0 && (W = "" + Q), C.key !== void 0 && (W = "" + C.key), "key" in C) {
      Q = {};
      for (var Z in C)
        Z !== "key" && (Q[Z] = C[Z]);
    } else Q = C;
    return C = Q.ref, {
      $$typeof: d,
      type: r,
      key: W,
      ref: C !== void 0 ? C : null,
      props: Q
    };
  }
  return pu.Fragment = _, pu.jsx = D, pu.jsxs = D, pu;
}
var Md;
function hv() {
  return Md || (Md = 1, vf.exports = mv()), vf.exports;
}
var b = hv(), yf = { exports: {} }, Eu = {}, gf = { exports: {} }, bf = {};
var Od;
function vv() {
  return Od || (Od = 1, (function(d) {
    function _(E, O) {
      var G = E.length;
      E.push(O);
      l: for (; 0 < G; ) {
        var hl = G - 1 >>> 1, bl = E[hl];
        if (0 < C(bl, O))
          E[hl] = O, E[G] = bl, G = hl;
        else break l;
      }
    }
    function D(E) {
      return E.length === 0 ? null : E[0];
    }
    function r(E) {
      if (E.length === 0) return null;
      var O = E[0], G = E.pop();
      if (G !== O) {
        E[0] = G;
        l: for (var hl = 0, bl = E.length, o = bl >>> 1; hl < o; ) {
          var T = 2 * (hl + 1) - 1, N = E[T], j = T + 1, J = E[j];
          if (0 > C(N, G))
            j < bl && 0 > C(J, N) ? (E[hl] = J, E[j] = G, hl = j) : (E[hl] = N, E[T] = G, hl = T);
          else if (j < bl && 0 > C(J, G))
            E[hl] = J, E[j] = G, hl = j;
          else break l;
        }
      }
      return O;
    }
    function C(E, O) {
      var G = E.sortIndex - O.sortIndex;
      return G !== 0 ? G : E.id - O.id;
    }
    if (d.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var Q = performance;
      d.unstable_now = function() {
        return Q.now();
      };
    } else {
      var W = Date, Z = W.now();
      d.unstable_now = function() {
        return W.now() - Z;
      };
    }
    var x = [], S = [], B = 1, M = null, K = 3, X = !1, R = !1, ll = !1, fl = !1, ul = typeof setTimeout == "function" ? setTimeout : null, Rl = typeof clearTimeout == "function" ? clearTimeout : null, ml = typeof setImmediate < "u" ? setImmediate : null;
    function Xl(E) {
      for (var O = D(S); O !== null; ) {
        if (O.callback === null) r(S);
        else if (O.startTime <= E)
          r(S), O.sortIndex = O.expirationTime, _(x, O);
        else break;
        O = D(S);
      }
    }
    function $l(E) {
      if (ll = !1, Xl(E), !R)
        if (D(x) !== null)
          R = !0, Ql || (Ql = !0, ql());
        else {
          var O = D(S);
          O !== null && Tl($l, O.startTime - E);
        }
    }
    var Ql = !1, L = -1, zl = 5, vt = -1;
    function Ft() {
      return fl ? !0 : !(d.unstable_now() - vt < zl);
    }
    function Fl() {
      if (fl = !1, Ql) {
        var E = d.unstable_now();
        vt = E;
        var O = !0;
        try {
          l: {
            R = !1, ll && (ll = !1, Rl(L), L = -1), X = !0;
            var G = K;
            try {
              t: {
                for (Xl(E), M = D(x); M !== null && !(M.expirationTime > E && Ft()); ) {
                  var hl = M.callback;
                  if (typeof hl == "function") {
                    M.callback = null, K = M.priorityLevel;
                    var bl = hl(
                      M.expirationTime <= E
                    );
                    if (E = d.unstable_now(), typeof bl == "function") {
                      M.callback = bl, Xl(E), O = !0;
                      break t;
                    }
                    M === D(x) && r(x), Xl(E);
                  } else r(x);
                  M = D(x);
                }
                if (M !== null) O = !0;
                else {
                  var o = D(S);
                  o !== null && Tl(
                    $l,
                    o.startTime - E
                  ), O = !1;
                }
              }
              break l;
            } finally {
              M = null, K = G, X = !1;
            }
            O = void 0;
          }
        } finally {
          O ? ql() : Ql = !1;
        }
      }
    }
    var ql;
    if (typeof ml == "function")
      ql = function() {
        ml(Fl);
      };
    else if (typeof MessageChannel < "u") {
      var $ = new MessageChannel(), Bl = $.port2;
      $.port1.onmessage = Fl, ql = function() {
        Bl.postMessage(null);
      };
    } else
      ql = function() {
        ul(Fl, 0);
      };
    function Tl(E, O) {
      L = ul(function() {
        E(d.unstable_now());
      }, O);
    }
    d.unstable_IdlePriority = 5, d.unstable_ImmediatePriority = 1, d.unstable_LowPriority = 4, d.unstable_NormalPriority = 3, d.unstable_Profiling = null, d.unstable_UserBlockingPriority = 2, d.unstable_cancelCallback = function(E) {
      E.callback = null;
    }, d.unstable_forceFrameRate = function(E) {
      0 > E || 125 < E ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : zl = 0 < E ? Math.floor(1e3 / E) : 5;
    }, d.unstable_getCurrentPriorityLevel = function() {
      return K;
    }, d.unstable_next = function(E) {
      switch (K) {
        case 1:
        case 2:
        case 3:
          var O = 3;
          break;
        default:
          O = K;
      }
      var G = K;
      K = O;
      try {
        return E();
      } finally {
        K = G;
      }
    }, d.unstable_requestPaint = function() {
      fl = !0;
    }, d.unstable_runWithPriority = function(E, O) {
      switch (E) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          E = 3;
      }
      var G = K;
      K = E;
      try {
        return O();
      } finally {
        K = G;
      }
    }, d.unstable_scheduleCallback = function(E, O, G) {
      var hl = d.unstable_now();
      switch (typeof G == "object" && G !== null ? (G = G.delay, G = typeof G == "number" && 0 < G ? hl + G : hl) : G = hl, E) {
        case 1:
          var bl = -1;
          break;
        case 2:
          bl = 250;
          break;
        case 5:
          bl = 1073741823;
          break;
        case 4:
          bl = 1e4;
          break;
        default:
          bl = 5e3;
      }
      return bl = G + bl, E = {
        id: B++,
        callback: O,
        priorityLevel: E,
        startTime: G,
        expirationTime: bl,
        sortIndex: -1
      }, G > hl ? (E.sortIndex = G, _(S, E), D(x) === null && E === D(S) && (ll ? (Rl(L), L = -1) : ll = !0, Tl($l, G - hl))) : (E.sortIndex = bl, _(x, E), R || X || (R = !0, Ql || (Ql = !0, ql()))), E;
    }, d.unstable_shouldYield = Ft, d.unstable_wrapCallback = function(E) {
      var O = K;
      return function() {
        var G = K;
        K = O;
        try {
          return E.apply(this, arguments);
        } finally {
          K = G;
        }
      };
    };
  })(bf)), bf;
}
var Nd;
function yv() {
  return Nd || (Nd = 1, gf.exports = vv()), gf.exports;
}
var Sf = { exports: {} }, V = {};
var Dd;
function gv() {
  if (Dd) return V;
  Dd = 1;
  var d = /* @__PURE__ */ Symbol.for("react.transitional.element"), _ = /* @__PURE__ */ Symbol.for("react.portal"), D = /* @__PURE__ */ Symbol.for("react.fragment"), r = /* @__PURE__ */ Symbol.for("react.strict_mode"), C = /* @__PURE__ */ Symbol.for("react.profiler"), Q = /* @__PURE__ */ Symbol.for("react.consumer"), W = /* @__PURE__ */ Symbol.for("react.context"), Z = /* @__PURE__ */ Symbol.for("react.forward_ref"), x = /* @__PURE__ */ Symbol.for("react.suspense"), S = /* @__PURE__ */ Symbol.for("react.memo"), B = /* @__PURE__ */ Symbol.for("react.lazy"), M = /* @__PURE__ */ Symbol.for("react.activity"), K = Symbol.iterator;
  function X(o) {
    return o === null || typeof o != "object" ? null : (o = K && o[K] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var R = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, ll = Object.assign, fl = {};
  function ul(o, T, N) {
    this.props = o, this.context = T, this.refs = fl, this.updater = N || R;
  }
  ul.prototype.isReactComponent = {}, ul.prototype.setState = function(o, T) {
    if (typeof o != "object" && typeof o != "function" && o != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, o, T, "setState");
  }, ul.prototype.forceUpdate = function(o) {
    this.updater.enqueueForceUpdate(this, o, "forceUpdate");
  };
  function Rl() {
  }
  Rl.prototype = ul.prototype;
  function ml(o, T, N) {
    this.props = o, this.context = T, this.refs = fl, this.updater = N || R;
  }
  var Xl = ml.prototype = new Rl();
  Xl.constructor = ml, ll(Xl, ul.prototype), Xl.isPureReactComponent = !0;
  var $l = Array.isArray;
  function Ql() {
  }
  var L = { H: null, A: null, T: null, S: null }, zl = Object.prototype.hasOwnProperty;
  function vt(o, T, N) {
    var j = N.ref;
    return {
      $$typeof: d,
      type: o,
      key: T,
      ref: j !== void 0 ? j : null,
      props: N
    };
  }
  function Ft(o, T) {
    return vt(o.type, T, o.props);
  }
  function Fl(o) {
    return typeof o == "object" && o !== null && o.$$typeof === d;
  }
  function ql(o) {
    var T = { "=": "=0", ":": "=2" };
    return "$" + o.replace(/[=:]/g, function(N) {
      return T[N];
    });
  }
  var $ = /\/+/g;
  function Bl(o, T) {
    return typeof o == "object" && o !== null && o.key != null ? ql("" + o.key) : T.toString(36);
  }
  function Tl(o) {
    switch (o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw o.reason;
      default:
        switch (typeof o.status == "string" ? o.then(Ql, Ql) : (o.status = "pending", o.then(
          function(T) {
            o.status === "pending" && (o.status = "fulfilled", o.value = T);
          },
          function(T) {
            o.status === "pending" && (o.status = "rejected", o.reason = T);
          }
        )), o.status) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw o.reason;
        }
    }
    throw o;
  }
  function E(o, T, N, j, J) {
    var F = typeof o;
    (F === "undefined" || F === "boolean") && (o = null);
    var sl = !1;
    if (o === null) sl = !0;
    else
      switch (F) {
        case "bigint":
        case "string":
        case "number":
          sl = !0;
          break;
        case "object":
          switch (o.$$typeof) {
            case d:
            case _:
              sl = !0;
              break;
            case B:
              return sl = o._init, E(
                sl(o._payload),
                T,
                N,
                j,
                J
              );
          }
      }
    if (sl)
      return J = J(o), sl = j === "" ? "." + Bl(o, 0) : j, $l(J) ? (N = "", sl != null && (N = sl.replace($, "$&/") + "/"), E(J, T, N, "", function(Ma) {
        return Ma;
      })) : J != null && (Fl(J) && (J = Ft(
        J,
        N + (J.key == null || o && o.key === J.key ? "" : ("" + J.key).replace(
          $,
          "$&/"
        ) + "/") + sl
      )), T.push(J)), 1;
    sl = 0;
    var kl = j === "" ? "." : j + ":";
    if ($l(o))
      for (var Ml = 0; Ml < o.length; Ml++)
        j = o[Ml], F = kl + Bl(j, Ml), sl += E(
          j,
          T,
          N,
          F,
          J
        );
    else if (Ml = X(o), typeof Ml == "function")
      for (o = Ml.call(o), Ml = 0; !(j = o.next()).done; )
        j = j.value, F = kl + Bl(j, Ml++), sl += E(
          j,
          T,
          N,
          F,
          J
        );
    else if (F === "object") {
      if (typeof o.then == "function")
        return E(
          Tl(o),
          T,
          N,
          j,
          J
        );
      throw T = String(o), Error(
        "Objects are not valid as a React child (found: " + (T === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : T) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return sl;
  }
  function O(o, T, N) {
    if (o == null) return o;
    var j = [], J = 0;
    return E(o, j, "", "", function(F) {
      return T.call(N, F, J++);
    }), j;
  }
  function G(o) {
    if (o._status === -1) {
      var T = o._result;
      T = T(), T.then(
        function(N) {
          (o._status === 0 || o._status === -1) && (o._status = 1, o._result = N);
        },
        function(N) {
          (o._status === 0 || o._status === -1) && (o._status = 2, o._result = N);
        }
      ), o._status === -1 && (o._status = 0, o._result = T);
    }
    if (o._status === 1) return o._result.default;
    throw o._result;
  }
  var hl = typeof reportError == "function" ? reportError : function(o) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var T = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof o == "object" && o !== null && typeof o.message == "string" ? String(o.message) : String(o),
        error: o
      });
      if (!window.dispatchEvent(T)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", o);
      return;
    }
    console.error(o);
  }, bl = {
    map: O,
    forEach: function(o, T, N) {
      O(
        o,
        function() {
          T.apply(this, arguments);
        },
        N
      );
    },
    count: function(o) {
      var T = 0;
      return O(o, function() {
        T++;
      }), T;
    },
    toArray: function(o) {
      return O(o, function(T) {
        return T;
      }) || [];
    },
    only: function(o) {
      if (!Fl(o))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return o;
    }
  };
  return V.Activity = M, V.Children = bl, V.Component = ul, V.Fragment = D, V.Profiler = C, V.PureComponent = ml, V.StrictMode = r, V.Suspense = x, V.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = L, V.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(o) {
      return L.H.useMemoCache(o);
    }
  }, V.cache = function(o) {
    return function() {
      return o.apply(null, arguments);
    };
  }, V.cacheSignal = function() {
    return null;
  }, V.cloneElement = function(o, T, N) {
    if (o == null)
      throw Error(
        "The argument must be a React element, but you passed " + o + "."
      );
    var j = ll({}, o.props), J = o.key;
    if (T != null)
      for (F in T.key !== void 0 && (J = "" + T.key), T)
        !zl.call(T, F) || F === "key" || F === "__self" || F === "__source" || F === "ref" && T.ref === void 0 || (j[F] = T[F]);
    var F = arguments.length - 2;
    if (F === 1) j.children = N;
    else if (1 < F) {
      for (var sl = Array(F), kl = 0; kl < F; kl++)
        sl[kl] = arguments[kl + 2];
      j.children = sl;
    }
    return vt(o.type, J, j);
  }, V.createContext = function(o) {
    return o = {
      $$typeof: W,
      _currentValue: o,
      _currentValue2: o,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, o.Provider = o, o.Consumer = {
      $$typeof: Q,
      _context: o
    }, o;
  }, V.createElement = function(o, T, N) {
    var j, J = {}, F = null;
    if (T != null)
      for (j in T.key !== void 0 && (F = "" + T.key), T)
        zl.call(T, j) && j !== "key" && j !== "__self" && j !== "__source" && (J[j] = T[j]);
    var sl = arguments.length - 2;
    if (sl === 1) J.children = N;
    else if (1 < sl) {
      for (var kl = Array(sl), Ml = 0; Ml < sl; Ml++)
        kl[Ml] = arguments[Ml + 2];
      J.children = kl;
    }
    if (o && o.defaultProps)
      for (j in sl = o.defaultProps, sl)
        J[j] === void 0 && (J[j] = sl[j]);
    return vt(o, F, J);
  }, V.createRef = function() {
    return { current: null };
  }, V.forwardRef = function(o) {
    return { $$typeof: Z, render: o };
  }, V.isValidElement = Fl, V.lazy = function(o) {
    return {
      $$typeof: B,
      _payload: { _status: -1, _result: o },
      _init: G
    };
  }, V.memo = function(o, T) {
    return {
      $$typeof: S,
      type: o,
      compare: T === void 0 ? null : T
    };
  }, V.startTransition = function(o) {
    var T = L.T, N = {};
    L.T = N;
    try {
      var j = o(), J = L.S;
      J !== null && J(N, j), typeof j == "object" && j !== null && typeof j.then == "function" && j.then(Ql, hl);
    } catch (F) {
      hl(F);
    } finally {
      T !== null && N.types !== null && (T.types = N.types), L.T = T;
    }
  }, V.unstable_useCacheRefresh = function() {
    return L.H.useCacheRefresh();
  }, V.use = function(o) {
    return L.H.use(o);
  }, V.useActionState = function(o, T, N) {
    return L.H.useActionState(o, T, N);
  }, V.useCallback = function(o, T) {
    return L.H.useCallback(o, T);
  }, V.useContext = function(o) {
    return L.H.useContext(o);
  }, V.useDebugValue = function() {
  }, V.useDeferredValue = function(o, T) {
    return L.H.useDeferredValue(o, T);
  }, V.useEffect = function(o, T) {
    return L.H.useEffect(o, T);
  }, V.useEffectEvent = function(o) {
    return L.H.useEffectEvent(o);
  }, V.useId = function() {
    return L.H.useId();
  }, V.useImperativeHandle = function(o, T, N) {
    return L.H.useImperativeHandle(o, T, N);
  }, V.useInsertionEffect = function(o, T) {
    return L.H.useInsertionEffect(o, T);
  }, V.useLayoutEffect = function(o, T) {
    return L.H.useLayoutEffect(o, T);
  }, V.useMemo = function(o, T) {
    return L.H.useMemo(o, T);
  }, V.useOptimistic = function(o, T) {
    return L.H.useOptimistic(o, T);
  }, V.useReducer = function(o, T, N) {
    return L.H.useReducer(o, T, N);
  }, V.useRef = function(o) {
    return L.H.useRef(o);
  }, V.useState = function(o) {
    return L.H.useState(o);
  }, V.useSyncExternalStore = function(o, T, N) {
    return L.H.useSyncExternalStore(
      o,
      T,
      N
    );
  }, V.useTransition = function() {
    return L.H.useTransition();
  }, V.version = "19.2.8", V;
}
var Ud;
function Af() {
  return Ud || (Ud = 1, Sf.exports = gv()), Sf.exports;
}
var pf = { exports: {} }, wl = {};
var jd;
function bv() {
  if (jd) return wl;
  jd = 1;
  var d = Af();
  function _(x) {
    var S = "https://react.dev/errors/" + x;
    if (1 < arguments.length) {
      S += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var B = 2; B < arguments.length; B++)
        S += "&args[]=" + encodeURIComponent(arguments[B]);
    }
    return "Minified React error #" + x + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function D() {
  }
  var r = {
    d: {
      f: D,
      r: function() {
        throw Error(_(522));
      },
      D,
      C: D,
      L: D,
      m: D,
      X: D,
      S: D,
      M: D
    },
    p: 0,
    findDOMNode: null
  }, C = /* @__PURE__ */ Symbol.for("react.portal");
  function Q(x, S, B) {
    var M = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: C,
      key: M == null ? null : "" + M,
      children: x,
      containerInfo: S,
      implementation: B
    };
  }
  var W = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function Z(x, S) {
    if (x === "font") return "";
    if (typeof S == "string")
      return S === "use-credentials" ? S : "";
  }
  return wl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, wl.createPortal = function(x, S) {
    var B = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!S || S.nodeType !== 1 && S.nodeType !== 9 && S.nodeType !== 11)
      throw Error(_(299));
    return Q(x, S, null, B);
  }, wl.flushSync = function(x) {
    var S = W.T, B = r.p;
    try {
      if (W.T = null, r.p = 2, x) return x();
    } finally {
      W.T = S, r.p = B, r.d.f();
    }
  }, wl.preconnect = function(x, S) {
    typeof x == "string" && (S ? (S = S.crossOrigin, S = typeof S == "string" ? S === "use-credentials" ? S : "" : void 0) : S = null, r.d.C(x, S));
  }, wl.prefetchDNS = function(x) {
    typeof x == "string" && r.d.D(x);
  }, wl.preinit = function(x, S) {
    if (typeof x == "string" && S && typeof S.as == "string") {
      var B = S.as, M = Z(B, S.crossOrigin), K = typeof S.integrity == "string" ? S.integrity : void 0, X = typeof S.fetchPriority == "string" ? S.fetchPriority : void 0;
      B === "style" ? r.d.S(
        x,
        typeof S.precedence == "string" ? S.precedence : void 0,
        {
          crossOrigin: M,
          integrity: K,
          fetchPriority: X
        }
      ) : B === "script" && r.d.X(x, {
        crossOrigin: M,
        integrity: K,
        fetchPriority: X,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0
      });
    }
  }, wl.preinitModule = function(x, S) {
    if (typeof x == "string")
      if (typeof S == "object" && S !== null) {
        if (S.as == null || S.as === "script") {
          var B = Z(
            S.as,
            S.crossOrigin
          );
          r.d.M(x, {
            crossOrigin: B,
            integrity: typeof S.integrity == "string" ? S.integrity : void 0,
            nonce: typeof S.nonce == "string" ? S.nonce : void 0
          });
        }
      } else S == null && r.d.M(x);
  }, wl.preload = function(x, S) {
    if (typeof x == "string" && typeof S == "object" && S !== null && typeof S.as == "string") {
      var B = S.as, M = Z(B, S.crossOrigin);
      r.d.L(x, B, {
        crossOrigin: M,
        integrity: typeof S.integrity == "string" ? S.integrity : void 0,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0,
        type: typeof S.type == "string" ? S.type : void 0,
        fetchPriority: typeof S.fetchPriority == "string" ? S.fetchPriority : void 0,
        referrerPolicy: typeof S.referrerPolicy == "string" ? S.referrerPolicy : void 0,
        imageSrcSet: typeof S.imageSrcSet == "string" ? S.imageSrcSet : void 0,
        imageSizes: typeof S.imageSizes == "string" ? S.imageSizes : void 0,
        media: typeof S.media == "string" ? S.media : void 0
      });
    }
  }, wl.preloadModule = function(x, S) {
    if (typeof x == "string")
      if (S) {
        var B = Z(S.as, S.crossOrigin);
        r.d.m(x, {
          as: typeof S.as == "string" && S.as !== "script" ? S.as : void 0,
          crossOrigin: B,
          integrity: typeof S.integrity == "string" ? S.integrity : void 0
        });
      } else r.d.m(x);
  }, wl.requestFormReset = function(x) {
    r.d.r(x);
  }, wl.unstable_batchedUpdates = function(x, S) {
    return x(S);
  }, wl.useFormState = function(x, S, B) {
    return W.H.useFormState(x, S, B);
  }, wl.useFormStatus = function() {
    return W.H.useHostTransitionStatus();
  }, wl.version = "19.2.8", wl;
}
var Cd;
function Sv() {
  if (Cd) return pf.exports;
  Cd = 1;
  function d() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(d);
      } catch (_) {
        console.error(_);
      }
  }
  return d(), pf.exports = bv(), pf.exports;
}
var Hd;
function pv() {
  if (Hd) return Eu;
  Hd = 1;
  var d = yv(), _ = Af(), D = Sv();
  function r(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var e = 2; e < arguments.length; e++)
        t += "&args[]=" + encodeURIComponent(arguments[e]);
    }
    return "Minified React error #" + l + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function C(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function Q(l) {
    var t = l, e = l;
    if (l.alternate) for (; t.return; ) t = t.return;
    else {
      l = t;
      do
        t = l, (t.flags & 4098) !== 0 && (e = t.return), l = t.return;
      while (l);
    }
    return t.tag === 3 ? e : null;
  }
  function W(l) {
    if (l.tag === 13) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function Z(l) {
    if (l.tag === 31) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function x(l) {
    if (Q(l) !== l)
      throw Error(r(188));
  }
  function S(l) {
    var t = l.alternate;
    if (!t) {
      if (t = Q(l), t === null) throw Error(r(188));
      return t !== l ? null : l;
    }
    for (var e = l, a = t; ; ) {
      var u = e.return;
      if (u === null) break;
      var n = u.alternate;
      if (n === null) {
        if (a = u.return, a !== null) {
          e = a;
          continue;
        }
        break;
      }
      if (u.child === n.child) {
        for (n = u.child; n; ) {
          if (n === e) return x(u), l;
          if (n === a) return x(u), t;
          n = n.sibling;
        }
        throw Error(r(188));
      }
      if (e.return !== a.return) e = u, a = n;
      else {
        for (var c = !1, i = u.child; i; ) {
          if (i === e) {
            c = !0, e = u, a = n;
            break;
          }
          if (i === a) {
            c = !0, a = u, e = n;
            break;
          }
          i = i.sibling;
        }
        if (!c) {
          for (i = n.child; i; ) {
            if (i === e) {
              c = !0, e = n, a = u;
              break;
            }
            if (i === a) {
              c = !0, a = n, e = u;
              break;
            }
            i = i.sibling;
          }
          if (!c) throw Error(r(189));
        }
      }
      if (e.alternate !== a) throw Error(r(190));
    }
    if (e.tag !== 3) throw Error(r(188));
    return e.stateNode.current === e ? l : t;
  }
  function B(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l;
    for (l = l.child; l !== null; ) {
      if (t = B(l), t !== null) return t;
      l = l.sibling;
    }
    return null;
  }
  var M = Object.assign, K = /* @__PURE__ */ Symbol.for("react.element"), X = /* @__PURE__ */ Symbol.for("react.transitional.element"), R = /* @__PURE__ */ Symbol.for("react.portal"), ll = /* @__PURE__ */ Symbol.for("react.fragment"), fl = /* @__PURE__ */ Symbol.for("react.strict_mode"), ul = /* @__PURE__ */ Symbol.for("react.profiler"), Rl = /* @__PURE__ */ Symbol.for("react.consumer"), ml = /* @__PURE__ */ Symbol.for("react.context"), Xl = /* @__PURE__ */ Symbol.for("react.forward_ref"), $l = /* @__PURE__ */ Symbol.for("react.suspense"), Ql = /* @__PURE__ */ Symbol.for("react.suspense_list"), L = /* @__PURE__ */ Symbol.for("react.memo"), zl = /* @__PURE__ */ Symbol.for("react.lazy"), vt = /* @__PURE__ */ Symbol.for("react.activity"), Ft = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), Fl = Symbol.iterator;
  function ql(l) {
    return l === null || typeof l != "object" ? null : (l = Fl && l[Fl] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var $ = /* @__PURE__ */ Symbol.for("react.client.reference");
  function Bl(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === $ ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case ll:
        return "Fragment";
      case ul:
        return "Profiler";
      case fl:
        return "StrictMode";
      case $l:
        return "Suspense";
      case Ql:
        return "SuspenseList";
      case vt:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case R:
          return "Portal";
        case ml:
          return l.displayName || "Context";
        case Rl:
          return (l._context.displayName || "Context") + ".Consumer";
        case Xl:
          var t = l.render;
          return l = l.displayName, l || (l = t.displayName || t.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case L:
          return t = l.displayName || null, t !== null ? t : Bl(l.type) || "Memo";
        case zl:
          t = l._payload, l = l._init;
          try {
            return Bl(l(t));
          } catch {
          }
      }
    return null;
  }
  var Tl = Array.isArray, E = _.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, O = D.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, G = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, hl = [], bl = -1;
  function o(l) {
    return { current: l };
  }
  function T(l) {
    0 > bl || (l.current = hl[bl], hl[bl] = null, bl--);
  }
  function N(l, t) {
    bl++, hl[bl] = l.current, l.current = t;
  }
  var j = o(null), J = o(null), F = o(null), sl = o(null);
  function kl(l, t) {
    switch (N(F, t), N(J, l), N(j, null), t.nodeType) {
      case 9:
      case 11:
        l = (l = t.documentElement) && (l = l.namespaceURI) ? kr(l) : 0;
        break;
      default:
        if (l = t.tagName, t = t.namespaceURI)
          t = kr(t), l = Wr(t, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    T(j), N(j, l);
  }
  function Ml() {
    T(j), T(J), T(F);
  }
  function Ma(l) {
    l.memoizedState !== null && N(sl, l);
    var t = j.current, e = Wr(t, l.type);
    t !== e && (N(J, l), N(j, e));
  }
  function xu(l) {
    J.current === l && (T(j), T(J)), sl.current === l && (T(sl), yu._currentValue = G);
  }
  var Wn, Tf;
  function Ae(l) {
    if (Wn === void 0)
      try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        Wn = t && t[1] || "", Tf = -1 < e.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Wn + l + Tf;
  }
  var Fn = !1;
  function In(l, t) {
    if (!l || Fn) return "";
    Fn = !0;
    var e = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var A = function() {
                throw Error();
              };
              if (Object.defineProperty(A.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(A, []);
                } catch (g) {
                  var y = g;
                }
                Reflect.construct(l, [], A);
              } else {
                try {
                  A.call();
                } catch (g) {
                  y = g;
                }
                l.call(A.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (g) {
                y = g;
              }
              (A = l()) && typeof A.catch == "function" && A.catch(function() {
              });
            }
          } catch (g) {
            if (g && y && typeof g.stack == "string")
              return [g.stack, y.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var u = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      u && u.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var n = a.DetermineComponentFrameRoot(), c = n[0], i = n[1];
      if (c && i) {
        var f = c.split(`
`), v = i.split(`
`);
        for (u = a = 0; a < f.length && !f[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; u < v.length && !v[u].includes(
          "DetermineComponentFrameRoot"
        ); )
          u++;
        if (a === f.length || u === v.length)
          for (a = f.length - 1, u = v.length - 1; 1 <= a && 0 <= u && f[a] !== v[u]; )
            u--;
        for (; 1 <= a && 0 <= u; a--, u--)
          if (f[a] !== v[u]) {
            if (a !== 1 || u !== 1)
              do
                if (a--, u--, 0 > u || f[a] !== v[u]) {
                  var p = `
` + f[a].replace(" at new ", " at ");
                  return l.displayName && p.includes("<anonymous>") && (p = p.replace("<anonymous>", l.displayName)), p;
                }
              while (1 <= a && 0 <= u);
            break;
          }
      }
    } finally {
      Fn = !1, Error.prepareStackTrace = e;
    }
    return (e = l ? l.displayName || l.name : "") ? Ae(e) : "";
  }
  function Vd(l, t) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return Ae(l.type);
      case 16:
        return Ae("Lazy");
      case 13:
        return l.child !== t && t !== null ? Ae("Suspense Fallback") : Ae("Suspense");
      case 19:
        return Ae("SuspenseList");
      case 0:
      case 15:
        return In(l.type, !1);
      case 11:
        return In(l.type.render, !1);
      case 1:
        return In(l.type, !0);
      case 31:
        return Ae("Activity");
      default:
        return "";
    }
  }
  function _f(l) {
    try {
      var t = "", e = null;
      do
        t += Vd(l, e), e = l, l = l.return;
      while (l);
      return t;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var Pn = Object.prototype.hasOwnProperty, lc = d.unstable_scheduleCallback, tc = d.unstable_cancelCallback, Kd = d.unstable_shouldYield, Jd = d.unstable_requestPaint, nt = d.unstable_now, wd = d.unstable_getCurrentPriorityLevel, xf = d.unstable_ImmediatePriority, Mf = d.unstable_UserBlockingPriority, Mu = d.unstable_NormalPriority, $d = d.unstable_LowPriority, Of = d.unstable_IdlePriority, kd = d.log, Wd = d.unstable_setDisableYieldValue, Oa = null, ct = null;
  function It(l) {
    if (typeof kd == "function" && Wd(l), ct && typeof ct.setStrictMode == "function")
      try {
        ct.setStrictMode(Oa, l);
      } catch {
      }
  }
  var it = Math.clz32 ? Math.clz32 : Pd, Fd = Math.log, Id = Math.LN2;
  function Pd(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (Fd(l) / Id | 0) | 0;
  }
  var Ou = 256, Nu = 262144, Du = 4194304;
  function Te(l) {
    var t = l & 42;
    if (t !== 0) return t;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Uu(l, t, e) {
    var a = l.pendingLanes;
    if (a === 0) return 0;
    var u = 0, n = l.suspendedLanes, c = l.pingedLanes;
    l = l.warmLanes;
    var i = a & 134217727;
    return i !== 0 ? (a = i & ~n, a !== 0 ? u = Te(a) : (c &= i, c !== 0 ? u = Te(c) : e || (e = i & ~l, e !== 0 && (u = Te(e))))) : (i = a & ~n, i !== 0 ? u = Te(i) : c !== 0 ? u = Te(c) : e || (e = a & ~l, e !== 0 && (u = Te(e)))), u === 0 ? 0 : t !== 0 && t !== u && (t & n) === 0 && (n = u & -u, e = t & -t, n >= e || n === 32 && (e & 4194048) !== 0) ? t : u;
  }
  function Na(l, t) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & t) === 0;
  }
  function lm(l, t) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Nf() {
    var l = Du;
    return Du <<= 1, (Du & 62914560) === 0 && (Du = 4194304), l;
  }
  function ec(l) {
    for (var t = [], e = 0; 31 > e; e++) t.push(l);
    return t;
  }
  function Da(l, t) {
    l.pendingLanes |= t, t !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function tm(l, t, e, a, u, n) {
    var c = l.pendingLanes;
    l.pendingLanes = e, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= e, l.entangledLanes &= e, l.errorRecoveryDisabledLanes &= e, l.shellSuspendCounter = 0;
    var i = l.entanglements, f = l.expirationTimes, v = l.hiddenUpdates;
    for (e = c & ~e; 0 < e; ) {
      var p = 31 - it(e), A = 1 << p;
      i[p] = 0, f[p] = -1;
      var y = v[p];
      if (y !== null)
        for (v[p] = null, p = 0; p < y.length; p++) {
          var g = y[p];
          g !== null && (g.lane &= -536870913);
        }
      e &= ~A;
    }
    a !== 0 && Df(l, a, 0), n !== 0 && u === 0 && l.tag !== 0 && (l.suspendedLanes |= n & ~(c & ~t));
  }
  function Df(l, t, e) {
    l.pendingLanes |= t, l.suspendedLanes &= ~t;
    var a = 31 - it(t);
    l.entangledLanes |= t, l.entanglements[a] = l.entanglements[a] | 1073741824 | e & 261930;
  }
  function Uf(l, t) {
    var e = l.entangledLanes |= t;
    for (l = l.entanglements; e; ) {
      var a = 31 - it(e), u = 1 << a;
      u & t | l[a] & t && (l[a] |= t), e &= ~u;
    }
  }
  function jf(l, t) {
    var e = t & -t;
    return e = (e & 42) !== 0 ? 1 : ac(e), (e & (l.suspendedLanes | t)) !== 0 ? 0 : e;
  }
  function ac(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function uc(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Cf() {
    var l = O.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : Sd(l.type));
  }
  function Hf(l, t) {
    var e = O.p;
    try {
      return O.p = l, t();
    } finally {
      O.p = e;
    }
  }
  var Pt = Math.random().toString(36).slice(2), Zl = "__reactFiber$" + Pt, Il = "__reactProps$" + Pt, Le = "__reactContainer$" + Pt, nc = "__reactEvents$" + Pt, em = "__reactListeners$" + Pt, am = "__reactHandles$" + Pt, Rf = "__reactResources$" + Pt, Ua = "__reactMarker$" + Pt;
  function cc(l) {
    delete l[Zl], delete l[Il], delete l[nc], delete l[em], delete l[am];
  }
  function Ve(l) {
    var t = l[Zl];
    if (t) return t;
    for (var e = l.parentNode; e; ) {
      if (t = e[Le] || e[Zl]) {
        if (e = t.alternate, t.child !== null || e !== null && e.child !== null)
          for (l = ad(l); l !== null; ) {
            if (e = l[Zl]) return e;
            l = ad(l);
          }
        return t;
      }
      l = e, e = l.parentNode;
    }
    return null;
  }
  function Ke(l) {
    if (l = l[Zl] || l[Le]) {
      var t = l.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return l;
    }
    return null;
  }
  function ja(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l.stateNode;
    throw Error(r(33));
  }
  function Je(l) {
    var t = l[Rf];
    return t || (t = l[Rf] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function Yl(l) {
    l[Ua] = !0;
  }
  var qf = /* @__PURE__ */ new Set(), Bf = {};
  function _e(l, t) {
    we(l, t), we(l + "Capture", t);
  }
  function we(l, t) {
    for (Bf[l] = t, l = 0; l < t.length; l++)
      qf.add(t[l]);
  }
  var um = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Yf = {}, Gf = {};
  function nm(l) {
    return Pn.call(Gf, l) ? !0 : Pn.call(Yf, l) ? !1 : um.test(l) ? Gf[l] = !0 : (Yf[l] = !0, !1);
  }
  function ju(l, t, e) {
    if (nm(t))
      if (e === null) l.removeAttribute(t);
      else {
        switch (typeof e) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(t);
            return;
          case "boolean":
            var a = t.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              l.removeAttribute(t);
              return;
            }
        }
        l.setAttribute(t, "" + e);
      }
  }
  function Cu(l, t, e) {
    if (e === null) l.removeAttribute(t);
    else {
      switch (typeof e) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(t);
          return;
      }
      l.setAttribute(t, "" + e);
    }
  }
  function Ct(l, t, e, a) {
    if (a === null) l.removeAttribute(e);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(e);
          return;
      }
      l.setAttributeNS(t, e, "" + a);
    }
  }
  function yt(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Xf(l) {
    var t = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function cm(l, t, e) {
    var a = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      t
    );
    if (!l.hasOwnProperty(t) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var u = a.get, n = a.set;
      return Object.defineProperty(l, t, {
        configurable: !0,
        get: function() {
          return u.call(this);
        },
        set: function(c) {
          e = "" + c, n.call(this, c);
        }
      }), Object.defineProperty(l, t, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return e;
        },
        setValue: function(c) {
          e = "" + c;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[t];
        }
      };
    }
  }
  function ic(l) {
    if (!l._valueTracker) {
      var t = Xf(l) ? "checked" : "value";
      l._valueTracker = cm(
        l,
        t,
        "" + l[t]
      );
    }
  }
  function Qf(l) {
    if (!l) return !1;
    var t = l._valueTracker;
    if (!t) return !0;
    var e = t.getValue(), a = "";
    return l && (a = Xf(l) ? l.checked ? "true" : "false" : l.value), l = a, l !== e ? (t.setValue(l), !0) : !1;
  }
  function Hu(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var im = /[\n"\\]/g;
  function gt(l) {
    return l.replace(
      im,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function fc(l, t, e, a, u, n, c, i) {
    l.name = "", c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? l.type = c : l.removeAttribute("type"), t != null ? c === "number" ? (t === 0 && l.value === "" || l.value != t) && (l.value = "" + yt(t)) : l.value !== "" + yt(t) && (l.value = "" + yt(t)) : c !== "submit" && c !== "reset" || l.removeAttribute("value"), t != null ? sc(l, c, yt(t)) : e != null ? sc(l, c, yt(e)) : a != null && l.removeAttribute("value"), u == null && n != null && (l.defaultChecked = !!n), u != null && (l.checked = u && typeof u != "function" && typeof u != "symbol"), i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? l.name = "" + yt(i) : l.removeAttribute("name");
  }
  function Zf(l, t, e, a, u, n, c, i) {
    if (n != null && typeof n != "function" && typeof n != "symbol" && typeof n != "boolean" && (l.type = n), t != null || e != null) {
      if (!(n !== "submit" && n !== "reset" || t != null)) {
        ic(l);
        return;
      }
      e = e != null ? "" + yt(e) : "", t = t != null ? "" + yt(t) : e, i || t === l.value || (l.value = t), l.defaultValue = t;
    }
    a = a ?? u, a = typeof a != "function" && typeof a != "symbol" && !!a, l.checked = i ? l.checked : !!a, l.defaultChecked = !!a, c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" && (l.name = c), ic(l);
  }
  function sc(l, t, e) {
    t === "number" && Hu(l.ownerDocument) === l || l.defaultValue === "" + e || (l.defaultValue = "" + e);
  }
  function $e(l, t, e, a) {
    if (l = l.options, t) {
      t = {};
      for (var u = 0; u < e.length; u++)
        t["$" + e[u]] = !0;
      for (e = 0; e < l.length; e++)
        u = t.hasOwnProperty("$" + l[e].value), l[e].selected !== u && (l[e].selected = u), u && a && (l[e].defaultSelected = !0);
    } else {
      for (e = "" + yt(e), t = null, u = 0; u < l.length; u++) {
        if (l[u].value === e) {
          l[u].selected = !0, a && (l[u].defaultSelected = !0);
          return;
        }
        t !== null || l[u].disabled || (t = l[u]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function Lf(l, t, e) {
    if (t != null && (t = "" + yt(t), t !== l.value && (l.value = t), e == null)) {
      l.defaultValue !== t && (l.defaultValue = t);
      return;
    }
    l.defaultValue = e != null ? "" + yt(e) : "";
  }
  function Vf(l, t, e, a) {
    if (t == null) {
      if (a != null) {
        if (e != null) throw Error(r(92));
        if (Tl(a)) {
          if (1 < a.length) throw Error(r(93));
          a = a[0];
        }
        e = a;
      }
      e == null && (e = ""), t = e;
    }
    e = yt(t), l.defaultValue = e, a = l.textContent, a === e && a !== "" && a !== null && (l.value = a), ic(l);
  }
  function ke(l, t) {
    if (t) {
      var e = l.firstChild;
      if (e && e === l.lastChild && e.nodeType === 3) {
        e.nodeValue = t;
        return;
      }
    }
    l.textContent = t;
  }
  var fm = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Kf(l, t, e) {
    var a = t.indexOf("--") === 0;
    e == null || typeof e == "boolean" || e === "" ? a ? l.setProperty(t, "") : t === "float" ? l.cssFloat = "" : l[t] = "" : a ? l.setProperty(t, e) : typeof e != "number" || e === 0 || fm.has(t) ? t === "float" ? l.cssFloat = e : l[t] = ("" + e).trim() : l[t] = e + "px";
  }
  function Jf(l, t, e) {
    if (t != null && typeof t != "object")
      throw Error(r(62));
    if (l = l.style, e != null) {
      for (var a in e)
        !e.hasOwnProperty(a) || t != null && t.hasOwnProperty(a) || (a.indexOf("--") === 0 ? l.setProperty(a, "") : a === "float" ? l.cssFloat = "" : l[a] = "");
      for (var u in t)
        a = t[u], t.hasOwnProperty(u) && e[u] !== a && Kf(l, u, a);
    } else
      for (var n in t)
        t.hasOwnProperty(n) && Kf(l, n, t[n]);
  }
  function oc(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var sm = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), om = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ru(l) {
    return om.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Ht() {
  }
  var rc = null;
  function dc(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var We = null, Fe = null;
  function wf(l) {
    var t = Ke(l);
    if (t && (l = t.stateNode)) {
      var e = l[Il] || null;
      l: switch (l = t.stateNode, t.type) {
        case "input":
          if (fc(
            l,
            e.value,
            e.defaultValue,
            e.defaultValue,
            e.checked,
            e.defaultChecked,
            e.type,
            e.name
          ), t = e.name, e.type === "radio" && t != null) {
            for (e = l; e.parentNode; ) e = e.parentNode;
            for (e = e.querySelectorAll(
              'input[name="' + gt(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < e.length; t++) {
              var a = e[t];
              if (a !== l && a.form === l.form) {
                var u = a[Il] || null;
                if (!u) throw Error(r(90));
                fc(
                  a,
                  u.value,
                  u.defaultValue,
                  u.defaultValue,
                  u.checked,
                  u.defaultChecked,
                  u.type,
                  u.name
                );
              }
            }
            for (t = 0; t < e.length; t++)
              a = e[t], a.form === l.form && Qf(a);
          }
          break l;
        case "textarea":
          Lf(l, e.value, e.defaultValue);
          break l;
        case "select":
          t = e.value, t != null && $e(l, !!e.multiple, t, !1);
      }
    }
  }
  var mc = !1;
  function $f(l, t, e) {
    if (mc) return l(t, e);
    mc = !0;
    try {
      var a = l(t);
      return a;
    } finally {
      if (mc = !1, (We !== null || Fe !== null) && (An(), We && (t = We, l = Fe, Fe = We = null, wf(t), l)))
        for (t = 0; t < l.length; t++) wf(l[t]);
    }
  }
  function Ca(l, t) {
    var e = l.stateNode;
    if (e === null) return null;
    var a = e[Il] || null;
    if (a === null) return null;
    e = a[t];
    l: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (l = l.type, a = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !a;
        break l;
      default:
        l = !1;
    }
    if (l) return null;
    if (e && typeof e != "function")
      throw Error(
        r(231, t, typeof e)
      );
    return e;
  }
  var Rt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), hc = !1;
  if (Rt)
    try {
      var Ha = {};
      Object.defineProperty(Ha, "passive", {
        get: function() {
          hc = !0;
        }
      }), window.addEventListener("test", Ha, Ha), window.removeEventListener("test", Ha, Ha);
    } catch {
      hc = !1;
    }
  var le = null, vc = null, qu = null;
  function kf() {
    if (qu) return qu;
    var l, t = vc, e = t.length, a, u = "value" in le ? le.value : le.textContent, n = u.length;
    for (l = 0; l < e && t[l] === u[l]; l++) ;
    var c = e - l;
    for (a = 1; a <= c && t[e - a] === u[n - a]; a++) ;
    return qu = u.slice(l, 1 < a ? 1 - a : void 0);
  }
  function Bu(l) {
    var t = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && t === 13 && (l = 13)) : l = t, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Yu() {
    return !0;
  }
  function Wf() {
    return !1;
  }
  function Pl(l) {
    function t(e, a, u, n, c) {
      this._reactName = e, this._targetInst = u, this.type = a, this.nativeEvent = n, this.target = c, this.currentTarget = null;
      for (var i in l)
        l.hasOwnProperty(i) && (e = l[i], this[i] = e ? e(n) : n[i]);
      return this.isDefaultPrevented = (n.defaultPrevented != null ? n.defaultPrevented : n.returnValue === !1) ? Yu : Wf, this.isPropagationStopped = Wf, this;
    }
    return M(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Yu);
      },
      stopPropagation: function() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Yu);
      },
      persist: function() {
      },
      isPersistent: Yu
    }), t;
  }
  var xe = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Gu = Pl(xe), Ra = M({}, xe, { view: 0, detail: 0 }), rm = Pl(Ra), yc, gc, qa, Xu = M({}, Ra, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Sc,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== qa && (qa && l.type === "mousemove" ? (yc = l.screenX - qa.screenX, gc = l.screenY - qa.screenY) : gc = yc = 0, qa = l), yc);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : gc;
    }
  }), Ff = Pl(Xu), dm = M({}, Xu, { dataTransfer: 0 }), mm = Pl(dm), hm = M({}, Ra, { relatedTarget: 0 }), bc = Pl(hm), vm = M({}, xe, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), ym = Pl(vm), gm = M({}, xe, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), bm = Pl(gm), Sm = M({}, xe, { data: 0 }), If = Pl(Sm), pm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Em = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, zm = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Am(l) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(l) : (l = zm[l]) ? !!t[l] : !1;
  }
  function Sc() {
    return Am;
  }
  var Tm = M({}, Ra, {
    key: function(l) {
      if (l.key) {
        var t = pm[l.key] || l.key;
        if (t !== "Unidentified") return t;
      }
      return l.type === "keypress" ? (l = Bu(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? Em[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Sc,
    charCode: function(l) {
      return l.type === "keypress" ? Bu(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? Bu(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), _m = Pl(Tm), xm = M({}, Xu, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Pf = Pl(xm), Mm = M({}, Ra, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Sc
  }), Om = Pl(Mm), Nm = M({}, xe, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Dm = Pl(Nm), Um = M({}, Xu, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), jm = Pl(Um), Cm = M({}, xe, {
    newState: 0,
    oldState: 0
  }), Hm = Pl(Cm), Rm = [9, 13, 27, 32], pc = Rt && "CompositionEvent" in window, Ba = null;
  Rt && "documentMode" in document && (Ba = document.documentMode);
  var qm = Rt && "TextEvent" in window && !Ba, ls = Rt && (!pc || Ba && 8 < Ba && 11 >= Ba), ts = " ", es = !1;
  function as(l, t) {
    switch (l) {
      case "keyup":
        return Rm.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function us(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var Ie = !1;
  function Bm(l, t) {
    switch (l) {
      case "compositionend":
        return us(t);
      case "keypress":
        return t.which !== 32 ? null : (es = !0, ts);
      case "textInput":
        return l = t.data, l === ts && es ? null : l;
      default:
        return null;
    }
  }
  function Ym(l, t) {
    if (Ie)
      return l === "compositionend" || !pc && as(l, t) ? (l = kf(), qu = vc = le = null, Ie = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return ls && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Gm = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function ns(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t === "input" ? !!Gm[l.type] : t === "textarea";
  }
  function cs(l, t, e, a) {
    We ? Fe ? Fe.push(a) : Fe = [a] : We = a, t = Dn(t, "onChange"), 0 < t.length && (e = new Gu(
      "onChange",
      "change",
      null,
      e,
      a
    ), l.push({ event: e, listeners: t }));
  }
  var Ya = null, Ga = null;
  function Xm(l) {
    Lr(l, 0);
  }
  function Qu(l) {
    var t = ja(l);
    if (Qf(t)) return l;
  }
  function is(l, t) {
    if (l === "change") return t;
  }
  var fs = !1;
  if (Rt) {
    var Ec;
    if (Rt) {
      var zc = "oninput" in document;
      if (!zc) {
        var ss = document.createElement("div");
        ss.setAttribute("oninput", "return;"), zc = typeof ss.oninput == "function";
      }
      Ec = zc;
    } else Ec = !1;
    fs = Ec && (!document.documentMode || 9 < document.documentMode);
  }
  function os() {
    Ya && (Ya.detachEvent("onpropertychange", rs), Ga = Ya = null);
  }
  function rs(l) {
    if (l.propertyName === "value" && Qu(Ga)) {
      var t = [];
      cs(
        t,
        Ga,
        l,
        dc(l)
      ), $f(Xm, t);
    }
  }
  function Qm(l, t, e) {
    l === "focusin" ? (os(), Ya = t, Ga = e, Ya.attachEvent("onpropertychange", rs)) : l === "focusout" && os();
  }
  function Zm(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return Qu(Ga);
  }
  function Lm(l, t) {
    if (l === "click") return Qu(t);
  }
  function Vm(l, t) {
    if (l === "input" || l === "change")
      return Qu(t);
  }
  function Km(l, t) {
    return l === t && (l !== 0 || 1 / l === 1 / t) || l !== l && t !== t;
  }
  var ft = typeof Object.is == "function" ? Object.is : Km;
  function Xa(l, t) {
    if (ft(l, t)) return !0;
    if (typeof l != "object" || l === null || typeof t != "object" || t === null)
      return !1;
    var e = Object.keys(l), a = Object.keys(t);
    if (e.length !== a.length) return !1;
    for (a = 0; a < e.length; a++) {
      var u = e[a];
      if (!Pn.call(t, u) || !ft(l[u], t[u]))
        return !1;
    }
    return !0;
  }
  function ds(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function ms(l, t) {
    var e = ds(l);
    l = 0;
    for (var a; e; ) {
      if (e.nodeType === 3) {
        if (a = l + e.textContent.length, l <= t && a >= t)
          return { node: e, offset: t - l };
        l = a;
      }
      l: {
        for (; e; ) {
          if (e.nextSibling) {
            e = e.nextSibling;
            break l;
          }
          e = e.parentNode;
        }
        e = void 0;
      }
      e = ds(e);
    }
  }
  function hs(l, t) {
    return l && t ? l === t ? !0 : l && l.nodeType === 3 ? !1 : t && t.nodeType === 3 ? hs(l, t.parentNode) : "contains" in l ? l.contains(t) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function vs(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var t = Hu(l.document); t instanceof l.HTMLIFrameElement; ) {
      try {
        var e = typeof t.contentWindow.location.href == "string";
      } catch {
        e = !1;
      }
      if (e) l = t.contentWindow;
      else break;
      t = Hu(l.document);
    }
    return t;
  }
  function Ac(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t && (t === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || t === "textarea" || l.contentEditable === "true");
  }
  var Jm = Rt && "documentMode" in document && 11 >= document.documentMode, Pe = null, Tc = null, Qa = null, _c = !1;
  function ys(l, t, e) {
    var a = e.window === e ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
    _c || Pe == null || Pe !== Hu(a) || (a = Pe, "selectionStart" in a && Ac(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), Qa && Xa(Qa, a) || (Qa = a, a = Dn(Tc, "onSelect"), 0 < a.length && (t = new Gu(
      "onSelect",
      "select",
      null,
      t,
      e
    ), l.push({ event: t, listeners: a }), t.target = Pe)));
  }
  function Me(l, t) {
    var e = {};
    return e[l.toLowerCase()] = t.toLowerCase(), e["Webkit" + l] = "webkit" + t, e["Moz" + l] = "moz" + t, e;
  }
  var la = {
    animationend: Me("Animation", "AnimationEnd"),
    animationiteration: Me("Animation", "AnimationIteration"),
    animationstart: Me("Animation", "AnimationStart"),
    transitionrun: Me("Transition", "TransitionRun"),
    transitionstart: Me("Transition", "TransitionStart"),
    transitioncancel: Me("Transition", "TransitionCancel"),
    transitionend: Me("Transition", "TransitionEnd")
  }, xc = {}, gs = {};
  Rt && (gs = document.createElement("div").style, "AnimationEvent" in window || (delete la.animationend.animation, delete la.animationiteration.animation, delete la.animationstart.animation), "TransitionEvent" in window || delete la.transitionend.transition);
  function Oe(l) {
    if (xc[l]) return xc[l];
    if (!la[l]) return l;
    var t = la[l], e;
    for (e in t)
      if (t.hasOwnProperty(e) && e in gs)
        return xc[l] = t[e];
    return l;
  }
  var bs = Oe("animationend"), Ss = Oe("animationiteration"), ps = Oe("animationstart"), wm = Oe("transitionrun"), $m = Oe("transitionstart"), km = Oe("transitioncancel"), Es = Oe("transitionend"), zs = /* @__PURE__ */ new Map(), Mc = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Mc.push("scrollEnd");
  function xt(l, t) {
    zs.set(l, t), _e(t, [l]);
  }
  var Zu = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, bt = [], ta = 0, Oc = 0;
  function Lu() {
    for (var l = ta, t = Oc = ta = 0; t < l; ) {
      var e = bt[t];
      bt[t++] = null;
      var a = bt[t];
      bt[t++] = null;
      var u = bt[t];
      bt[t++] = null;
      var n = bt[t];
      if (bt[t++] = null, a !== null && u !== null) {
        var c = a.pending;
        c === null ? u.next = u : (u.next = c.next, c.next = u), a.pending = u;
      }
      n !== 0 && As(e, u, n);
    }
  }
  function Vu(l, t, e, a) {
    bt[ta++] = l, bt[ta++] = t, bt[ta++] = e, bt[ta++] = a, Oc |= a, l.lanes |= a, l = l.alternate, l !== null && (l.lanes |= a);
  }
  function Nc(l, t, e, a) {
    return Vu(l, t, e, a), Ku(l);
  }
  function Ne(l, t) {
    return Vu(l, null, null, t), Ku(l);
  }
  function As(l, t, e) {
    l.lanes |= e;
    var a = l.alternate;
    a !== null && (a.lanes |= e);
    for (var u = !1, n = l.return; n !== null; )
      n.childLanes |= e, a = n.alternate, a !== null && (a.childLanes |= e), n.tag === 22 && (l = n.stateNode, l === null || l._visibility & 1 || (u = !0)), l = n, n = n.return;
    return l.tag === 3 ? (n = l.stateNode, u && t !== null && (u = 31 - it(e), l = n.hiddenUpdates, a = l[u], a === null ? l[u] = [t] : a.push(t), t.lane = e | 536870912), n) : null;
  }
  function Ku(l) {
    if (50 < su)
      throw su = 0, Yi = null, Error(r(185));
    for (var t = l.return; t !== null; )
      l = t, t = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var ea = {};
  function Wm(l, t, e, a) {
    this.tag = l, this.key = e, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function st(l, t, e, a) {
    return new Wm(l, t, e, a);
  }
  function Dc(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function qt(l, t) {
    var e = l.alternate;
    return e === null ? (e = st(
      l.tag,
      t,
      l.key,
      l.mode
    ), e.elementType = l.elementType, e.type = l.type, e.stateNode = l.stateNode, e.alternate = l, l.alternate = e) : (e.pendingProps = t, e.type = l.type, e.flags = 0, e.subtreeFlags = 0, e.deletions = null), e.flags = l.flags & 65011712, e.childLanes = l.childLanes, e.lanes = l.lanes, e.child = l.child, e.memoizedProps = l.memoizedProps, e.memoizedState = l.memoizedState, e.updateQueue = l.updateQueue, t = l.dependencies, e.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, e.sibling = l.sibling, e.index = l.index, e.ref = l.ref, e.refCleanup = l.refCleanup, e;
  }
  function Ts(l, t) {
    l.flags &= 65011714;
    var e = l.alternate;
    return e === null ? (l.childLanes = 0, l.lanes = t, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = e.childLanes, l.lanes = e.lanes, l.child = e.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = e.memoizedProps, l.memoizedState = e.memoizedState, l.updateQueue = e.updateQueue, l.type = e.type, t = e.dependencies, l.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), l;
  }
  function Ju(l, t, e, a, u, n) {
    var c = 0;
    if (a = l, typeof l == "function") Dc(l) && (c = 1);
    else if (typeof l == "string")
      c = tv(
        l,
        e,
        j.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      l: switch (l) {
        case vt:
          return l = st(31, e, t, u), l.elementType = vt, l.lanes = n, l;
        case ll:
          return De(e.children, u, n, t);
        case fl:
          c = 8, u |= 24;
          break;
        case ul:
          return l = st(12, e, t, u | 2), l.elementType = ul, l.lanes = n, l;
        case $l:
          return l = st(13, e, t, u), l.elementType = $l, l.lanes = n, l;
        case Ql:
          return l = st(19, e, t, u), l.elementType = Ql, l.lanes = n, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case ml:
                c = 10;
                break l;
              case Rl:
                c = 9;
                break l;
              case Xl:
                c = 11;
                break l;
              case L:
                c = 14;
                break l;
              case zl:
                c = 16, a = null;
                break l;
            }
          c = 29, e = Error(
            r(130, l === null ? "null" : typeof l, "")
          ), a = null;
      }
    return t = st(c, e, t, u), t.elementType = l, t.type = a, t.lanes = n, t;
  }
  function De(l, t, e, a) {
    return l = st(7, l, a, t), l.lanes = e, l;
  }
  function Uc(l, t, e) {
    return l = st(6, l, null, t), l.lanes = e, l;
  }
  function _s(l) {
    var t = st(18, null, null, 0);
    return t.stateNode = l, t;
  }
  function jc(l, t, e) {
    return t = st(
      4,
      l.children !== null ? l.children : [],
      l.key,
      t
    ), t.lanes = e, t.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, t;
  }
  var xs = /* @__PURE__ */ new WeakMap();
  function St(l, t) {
    if (typeof l == "object" && l !== null) {
      var e = xs.get(l);
      return e !== void 0 ? e : (t = {
        value: l,
        source: t,
        stack: _f(t)
      }, xs.set(l, t), t);
    }
    return {
      value: l,
      source: t,
      stack: _f(t)
    };
  }
  var aa = [], ua = 0, wu = null, Za = 0, pt = [], Et = 0, te = null, Nt = 1, Dt = "";
  function Bt(l, t) {
    aa[ua++] = Za, aa[ua++] = wu, wu = l, Za = t;
  }
  function Ms(l, t, e) {
    pt[Et++] = Nt, pt[Et++] = Dt, pt[Et++] = te, te = l;
    var a = Nt;
    l = Dt;
    var u = 32 - it(a) - 1;
    a &= ~(1 << u), e += 1;
    var n = 32 - it(t) + u;
    if (30 < n) {
      var c = u - u % 5;
      n = (a & (1 << c) - 1).toString(32), a >>= c, u -= c, Nt = 1 << 32 - it(t) + u | e << u | a, Dt = n + l;
    } else
      Nt = 1 << n | e << u | a, Dt = l;
  }
  function Cc(l) {
    l.return !== null && (Bt(l, 1), Ms(l, 1, 0));
  }
  function Hc(l) {
    for (; l === wu; )
      wu = aa[--ua], aa[ua] = null, Za = aa[--ua], aa[ua] = null;
    for (; l === te; )
      te = pt[--Et], pt[Et] = null, Dt = pt[--Et], pt[Et] = null, Nt = pt[--Et], pt[Et] = null;
  }
  function Os(l, t) {
    pt[Et++] = Nt, pt[Et++] = Dt, pt[Et++] = te, Nt = t.id, Dt = t.overflow, te = l;
  }
  var Ll = null, pl = null, al = !1, ee = null, zt = !1, Rc = Error(r(519));
  function ae(l) {
    var t = Error(
      r(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw La(St(t, l)), Rc;
  }
  function Ns(l) {
    var t = l.stateNode, e = l.type, a = l.memoizedProps;
    switch (t[Zl] = l, t[Il] = a, e) {
      case "dialog":
        P("cancel", t), P("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        P("load", t);
        break;
      case "video":
      case "audio":
        for (e = 0; e < ru.length; e++)
          P(ru[e], t);
        break;
      case "source":
        P("error", t);
        break;
      case "img":
      case "image":
      case "link":
        P("error", t), P("load", t);
        break;
      case "details":
        P("toggle", t);
        break;
      case "input":
        P("invalid", t), Zf(
          t,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        P("invalid", t);
        break;
      case "textarea":
        P("invalid", t), Vf(t, a.value, a.defaultValue, a.children);
    }
    e = a.children, typeof e != "string" && typeof e != "number" && typeof e != "bigint" || t.textContent === "" + e || a.suppressHydrationWarning === !0 || wr(t.textContent, e) ? (a.popover != null && (P("beforetoggle", t), P("toggle", t)), a.onScroll != null && P("scroll", t), a.onScrollEnd != null && P("scrollend", t), a.onClick != null && (t.onclick = Ht), t = !0) : t = !1, t || ae(l, !0);
  }
  function Ds(l) {
    for (Ll = l.return; Ll; )
      switch (Ll.tag) {
        case 5:
        case 31:
        case 13:
          zt = !1;
          return;
        case 27:
        case 3:
          zt = !0;
          return;
        default:
          Ll = Ll.return;
      }
  }
  function na(l) {
    if (l !== Ll) return !1;
    if (!al) return Ds(l), al = !0, !1;
    var t = l.tag, e;
    if ((e = t !== 3 && t !== 27) && ((e = t === 5) && (e = l.type, e = !(e !== "form" && e !== "button") || Pi(l.type, l.memoizedProps)), e = !e), e && pl && ae(l), Ds(l), t === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
      pl = ed(l);
    } else if (t === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
      pl = ed(l);
    } else
      t === 27 ? (t = pl, ge(l.type) ? (l = uf, uf = null, pl = l) : pl = t) : pl = Ll ? Tt(l.stateNode.nextSibling) : null;
    return !0;
  }
  function Ue() {
    pl = Ll = null, al = !1;
  }
  function qc() {
    var l = ee;
    return l !== null && (at === null ? at = l : at.push.apply(
      at,
      l
    ), ee = null), l;
  }
  function La(l) {
    ee === null ? ee = [l] : ee.push(l);
  }
  var Bc = o(null), je = null, Yt = null;
  function ue(l, t, e) {
    N(Bc, t._currentValue), t._currentValue = e;
  }
  function Gt(l) {
    l._currentValue = Bc.current, T(Bc);
  }
  function Yc(l, t, e) {
    for (; l !== null; ) {
      var a = l.alternate;
      if ((l.childLanes & t) !== t ? (l.childLanes |= t, a !== null && (a.childLanes |= t)) : a !== null && (a.childLanes & t) !== t && (a.childLanes |= t), l === e) break;
      l = l.return;
    }
  }
  function Gc(l, t, e, a) {
    var u = l.child;
    for (u !== null && (u.return = l); u !== null; ) {
      var n = u.dependencies;
      if (n !== null) {
        var c = u.child;
        n = n.firstContext;
        l: for (; n !== null; ) {
          var i = n;
          n = u;
          for (var f = 0; f < t.length; f++)
            if (i.context === t[f]) {
              n.lanes |= e, i = n.alternate, i !== null && (i.lanes |= e), Yc(
                n.return,
                e,
                l
              ), a || (c = null);
              break l;
            }
          n = i.next;
        }
      } else if (u.tag === 18) {
        if (c = u.return, c === null) throw Error(r(341));
        c.lanes |= e, n = c.alternate, n !== null && (n.lanes |= e), Yc(c, e, l), c = null;
      } else c = u.child;
      if (c !== null) c.return = u;
      else
        for (c = u; c !== null; ) {
          if (c === l) {
            c = null;
            break;
          }
          if (u = c.sibling, u !== null) {
            u.return = c.return, c = u;
            break;
          }
          c = c.return;
        }
      u = c;
    }
  }
  function ca(l, t, e, a) {
    l = null;
    for (var u = t, n = !1; u !== null; ) {
      if (!n) {
        if ((u.flags & 524288) !== 0) n = !0;
        else if ((u.flags & 262144) !== 0) break;
      }
      if (u.tag === 10) {
        var c = u.alternate;
        if (c === null) throw Error(r(387));
        if (c = c.memoizedProps, c !== null) {
          var i = u.type;
          ft(u.pendingProps.value, c.value) || (l !== null ? l.push(i) : l = [i]);
        }
      } else if (u === sl.current) {
        if (c = u.alternate, c === null) throw Error(r(387));
        c.memoizedState.memoizedState !== u.memoizedState.memoizedState && (l !== null ? l.push(yu) : l = [yu]);
      }
      u = u.return;
    }
    l !== null && Gc(
      t,
      l,
      e,
      a
    ), t.flags |= 262144;
  }
  function $u(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!ft(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function Ce(l) {
    je = l, Yt = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function Vl(l) {
    return Us(je, l);
  }
  function ku(l, t) {
    return je === null && Ce(l), Us(l, t);
  }
  function Us(l, t) {
    var e = t._currentValue;
    if (t = { context: t, memoizedValue: e, next: null }, Yt === null) {
      if (l === null) throw Error(r(308));
      Yt = t, l.dependencies = { lanes: 0, firstContext: t }, l.flags |= 524288;
    } else Yt = Yt.next = t;
    return e;
  }
  var Fm = typeof AbortController < "u" ? AbortController : function() {
    var l = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(e, a) {
        l.push(a);
      }
    };
    this.abort = function() {
      t.aborted = !0, l.forEach(function(e) {
        return e();
      });
    };
  }, Im = d.unstable_scheduleCallback, Pm = d.unstable_NormalPriority, Dl = {
    $$typeof: ml,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Xc() {
    return {
      controller: new Fm(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Va(l) {
    l.refCount--, l.refCount === 0 && Im(Pm, function() {
      l.controller.abort();
    });
  }
  var Ka = null, Qc = 0, ia = 0, fa = null;
  function lh(l, t) {
    if (Ka === null) {
      var e = Ka = [];
      Qc = 0, ia = Vi(), fa = {
        status: "pending",
        value: void 0,
        then: function(a) {
          e.push(a);
        }
      };
    }
    return Qc++, t.then(js, js), t;
  }
  function js() {
    if (--Qc === 0 && Ka !== null) {
      fa !== null && (fa.status = "fulfilled");
      var l = Ka;
      Ka = null, ia = 0, fa = null;
      for (var t = 0; t < l.length; t++) (0, l[t])();
    }
  }
  function th(l, t) {
    var e = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(u) {
        e.push(u);
      }
    };
    return l.then(
      function() {
        a.status = "fulfilled", a.value = t;
        for (var u = 0; u < e.length; u++) (0, e[u])(t);
      },
      function(u) {
        for (a.status = "rejected", a.reason = u, u = 0; u < e.length; u++)
          (0, e[u])(void 0);
      }
    ), a;
  }
  var Cs = E.S;
  E.S = function(l, t) {
    gr = nt(), typeof t == "object" && t !== null && typeof t.then == "function" && lh(l, t), Cs !== null && Cs(l, t);
  };
  var He = o(null);
  function Zc() {
    var l = He.current;
    return l !== null ? l : Sl.pooledCache;
  }
  function Wu(l, t) {
    t === null ? N(He, He.current) : N(He, t.pool);
  }
  function Hs() {
    var l = Zc();
    return l === null ? null : { parent: Dl._currentValue, pool: l };
  }
  var sa = Error(r(460)), Lc = Error(r(474)), Fu = Error(r(542)), Iu = { then: function() {
  } };
  function Rs(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function qs(l, t, e) {
    switch (e = l[e], e === void 0 ? l.push(t) : e !== t && (t.then(Ht, Ht), t = e), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw l = t.reason, Ys(l), l;
      default:
        if (typeof t.status == "string") t.then(Ht, Ht);
        else {
          if (l = Sl, l !== null && 100 < l.shellSuspendCounter)
            throw Error(r(482));
          l = t, l.status = "pending", l.then(
            function(a) {
              if (t.status === "pending") {
                var u = t;
                u.status = "fulfilled", u.value = a;
              }
            },
            function(a) {
              if (t.status === "pending") {
                var u = t;
                u.status = "rejected", u.reason = a;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw l = t.reason, Ys(l), l;
        }
        throw qe = t, sa;
    }
  }
  function Re(l) {
    try {
      var t = l._init;
      return t(l._payload);
    } catch (e) {
      throw e !== null && typeof e == "object" && typeof e.then == "function" ? (qe = e, sa) : e;
    }
  }
  var qe = null;
  function Bs() {
    if (qe === null) throw Error(r(459));
    var l = qe;
    return qe = null, l;
  }
  function Ys(l) {
    if (l === sa || l === Fu)
      throw Error(r(483));
  }
  var oa = null, Ja = 0;
  function Pu(l) {
    var t = Ja;
    return Ja += 1, oa === null && (oa = []), qs(oa, l, t);
  }
  function wa(l, t) {
    t = t.props.ref, l.ref = t !== void 0 ? t : null;
  }
  function ln(l, t) {
    throw t.$$typeof === K ? Error(r(525)) : (l = Object.prototype.toString.call(t), Error(
      r(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : l
      )
    ));
  }
  function Gs(l) {
    function t(m, s) {
      if (l) {
        var h = m.deletions;
        h === null ? (m.deletions = [s], m.flags |= 16) : h.push(s);
      }
    }
    function e(m, s) {
      if (!l) return null;
      for (; s !== null; )
        t(m, s), s = s.sibling;
      return null;
    }
    function a(m) {
      for (var s = /* @__PURE__ */ new Map(); m !== null; )
        m.key !== null ? s.set(m.key, m) : s.set(m.index, m), m = m.sibling;
      return s;
    }
    function u(m, s) {
      return m = qt(m, s), m.index = 0, m.sibling = null, m;
    }
    function n(m, s, h) {
      return m.index = h, l ? (h = m.alternate, h !== null ? (h = h.index, h < s ? (m.flags |= 67108866, s) : h) : (m.flags |= 67108866, s)) : (m.flags |= 1048576, s);
    }
    function c(m) {
      return l && m.alternate === null && (m.flags |= 67108866), m;
    }
    function i(m, s, h, z) {
      return s === null || s.tag !== 6 ? (s = Uc(h, m.mode, z), s.return = m, s) : (s = u(s, h), s.return = m, s);
    }
    function f(m, s, h, z) {
      var q = h.type;
      return q === ll ? p(
        m,
        s,
        h.props.children,
        z,
        h.key
      ) : s !== null && (s.elementType === q || typeof q == "object" && q !== null && q.$$typeof === zl && Re(q) === s.type) ? (s = u(s, h.props), wa(s, h), s.return = m, s) : (s = Ju(
        h.type,
        h.key,
        h.props,
        null,
        m.mode,
        z
      ), wa(s, h), s.return = m, s);
    }
    function v(m, s, h, z) {
      return s === null || s.tag !== 4 || s.stateNode.containerInfo !== h.containerInfo || s.stateNode.implementation !== h.implementation ? (s = jc(h, m.mode, z), s.return = m, s) : (s = u(s, h.children || []), s.return = m, s);
    }
    function p(m, s, h, z, q) {
      return s === null || s.tag !== 7 ? (s = De(
        h,
        m.mode,
        z,
        q
      ), s.return = m, s) : (s = u(s, h), s.return = m, s);
    }
    function A(m, s, h) {
      if (typeof s == "string" && s !== "" || typeof s == "number" || typeof s == "bigint")
        return s = Uc(
          "" + s,
          m.mode,
          h
        ), s.return = m, s;
      if (typeof s == "object" && s !== null) {
        switch (s.$$typeof) {
          case X:
            return h = Ju(
              s.type,
              s.key,
              s.props,
              null,
              m.mode,
              h
            ), wa(h, s), h.return = m, h;
          case R:
            return s = jc(
              s,
              m.mode,
              h
            ), s.return = m, s;
          case zl:
            return s = Re(s), A(m, s, h);
        }
        if (Tl(s) || ql(s))
          return s = De(
            s,
            m.mode,
            h,
            null
          ), s.return = m, s;
        if (typeof s.then == "function")
          return A(m, Pu(s), h);
        if (s.$$typeof === ml)
          return A(
            m,
            ku(m, s),
            h
          );
        ln(m, s);
      }
      return null;
    }
    function y(m, s, h, z) {
      var q = s !== null ? s.key : null;
      if (typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint")
        return q !== null ? null : i(m, s, "" + h, z);
      if (typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case X:
            return h.key === q ? f(m, s, h, z) : null;
          case R:
            return h.key === q ? v(m, s, h, z) : null;
          case zl:
            return h = Re(h), y(m, s, h, z);
        }
        if (Tl(h) || ql(h))
          return q !== null ? null : p(m, s, h, z, null);
        if (typeof h.then == "function")
          return y(
            m,
            s,
            Pu(h),
            z
          );
        if (h.$$typeof === ml)
          return y(
            m,
            s,
            ku(m, h),
            z
          );
        ln(m, h);
      }
      return null;
    }
    function g(m, s, h, z, q) {
      if (typeof z == "string" && z !== "" || typeof z == "number" || typeof z == "bigint")
        return m = m.get(h) || null, i(s, m, "" + z, q);
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case X:
            return m = m.get(
              z.key === null ? h : z.key
            ) || null, f(s, m, z, q);
          case R:
            return m = m.get(
              z.key === null ? h : z.key
            ) || null, v(s, m, z, q);
          case zl:
            return z = Re(z), g(
              m,
              s,
              h,
              z,
              q
            );
        }
        if (Tl(z) || ql(z))
          return m = m.get(h) || null, p(s, m, z, q, null);
        if (typeof z.then == "function")
          return g(
            m,
            s,
            h,
            Pu(z),
            q
          );
        if (z.$$typeof === ml)
          return g(
            m,
            s,
            h,
            ku(s, z),
            q
          );
        ln(s, z);
      }
      return null;
    }
    function U(m, s, h, z) {
      for (var q = null, nl = null, H = s, k = s = 0, el = null; H !== null && k < h.length; k++) {
        H.index > k ? (el = H, H = null) : el = H.sibling;
        var cl = y(
          m,
          H,
          h[k],
          z
        );
        if (cl === null) {
          H === null && (H = el);
          break;
        }
        l && H && cl.alternate === null && t(m, H), s = n(cl, s, k), nl === null ? q = cl : nl.sibling = cl, nl = cl, H = el;
      }
      if (k === h.length)
        return e(m, H), al && Bt(m, k), q;
      if (H === null) {
        for (; k < h.length; k++)
          H = A(m, h[k], z), H !== null && (s = n(
            H,
            s,
            k
          ), nl === null ? q = H : nl.sibling = H, nl = H);
        return al && Bt(m, k), q;
      }
      for (H = a(H); k < h.length; k++)
        el = g(
          H,
          m,
          k,
          h[k],
          z
        ), el !== null && (l && el.alternate !== null && H.delete(
          el.key === null ? k : el.key
        ), s = n(
          el,
          s,
          k
        ), nl === null ? q = el : nl.sibling = el, nl = el);
      return l && H.forEach(function(ze) {
        return t(m, ze);
      }), al && Bt(m, k), q;
    }
    function Y(m, s, h, z) {
      if (h == null) throw Error(r(151));
      for (var q = null, nl = null, H = s, k = s = 0, el = null, cl = h.next(); H !== null && !cl.done; k++, cl = h.next()) {
        H.index > k ? (el = H, H = null) : el = H.sibling;
        var ze = y(m, H, cl.value, z);
        if (ze === null) {
          H === null && (H = el);
          break;
        }
        l && H && ze.alternate === null && t(m, H), s = n(ze, s, k), nl === null ? q = ze : nl.sibling = ze, nl = ze, H = el;
      }
      if (cl.done)
        return e(m, H), al && Bt(m, k), q;
      if (H === null) {
        for (; !cl.done; k++, cl = h.next())
          cl = A(m, cl.value, z), cl !== null && (s = n(cl, s, k), nl === null ? q = cl : nl.sibling = cl, nl = cl);
        return al && Bt(m, k), q;
      }
      for (H = a(H); !cl.done; k++, cl = h.next())
        cl = g(H, m, k, cl.value, z), cl !== null && (l && cl.alternate !== null && H.delete(cl.key === null ? k : cl.key), s = n(cl, s, k), nl === null ? q = cl : nl.sibling = cl, nl = cl);
      return l && H.forEach(function(dv) {
        return t(m, dv);
      }), al && Bt(m, k), q;
    }
    function gl(m, s, h, z) {
      if (typeof h == "object" && h !== null && h.type === ll && h.key === null && (h = h.props.children), typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case X:
            l: {
              for (var q = h.key; s !== null; ) {
                if (s.key === q) {
                  if (q = h.type, q === ll) {
                    if (s.tag === 7) {
                      e(
                        m,
                        s.sibling
                      ), z = u(
                        s,
                        h.props.children
                      ), z.return = m, m = z;
                      break l;
                    }
                  } else if (s.elementType === q || typeof q == "object" && q !== null && q.$$typeof === zl && Re(q) === s.type) {
                    e(
                      m,
                      s.sibling
                    ), z = u(s, h.props), wa(z, h), z.return = m, m = z;
                    break l;
                  }
                  e(m, s);
                  break;
                } else t(m, s);
                s = s.sibling;
              }
              h.type === ll ? (z = De(
                h.props.children,
                m.mode,
                z,
                h.key
              ), z.return = m, m = z) : (z = Ju(
                h.type,
                h.key,
                h.props,
                null,
                m.mode,
                z
              ), wa(z, h), z.return = m, m = z);
            }
            return c(m);
          case R:
            l: {
              for (q = h.key; s !== null; ) {
                if (s.key === q)
                  if (s.tag === 4 && s.stateNode.containerInfo === h.containerInfo && s.stateNode.implementation === h.implementation) {
                    e(
                      m,
                      s.sibling
                    ), z = u(s, h.children || []), z.return = m, m = z;
                    break l;
                  } else {
                    e(m, s);
                    break;
                  }
                else t(m, s);
                s = s.sibling;
              }
              z = jc(h, m.mode, z), z.return = m, m = z;
            }
            return c(m);
          case zl:
            return h = Re(h), gl(
              m,
              s,
              h,
              z
            );
        }
        if (Tl(h))
          return U(
            m,
            s,
            h,
            z
          );
        if (ql(h)) {
          if (q = ql(h), typeof q != "function") throw Error(r(150));
          return h = q.call(h), Y(
            m,
            s,
            h,
            z
          );
        }
        if (typeof h.then == "function")
          return gl(
            m,
            s,
            Pu(h),
            z
          );
        if (h.$$typeof === ml)
          return gl(
            m,
            s,
            ku(m, h),
            z
          );
        ln(m, h);
      }
      return typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint" ? (h = "" + h, s !== null && s.tag === 6 ? (e(m, s.sibling), z = u(s, h), z.return = m, m = z) : (e(m, s), z = Uc(h, m.mode, z), z.return = m, m = z), c(m)) : e(m, s);
    }
    return function(m, s, h, z) {
      try {
        Ja = 0;
        var q = gl(
          m,
          s,
          h,
          z
        );
        return oa = null, q;
      } catch (H) {
        if (H === sa || H === Fu) throw H;
        var nl = st(29, H, null, m.mode);
        return nl.lanes = z, nl.return = m, nl;
      }
    };
  }
  var Be = Gs(!0), Xs = Gs(!1), ne = !1;
  function Vc(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Kc(l, t) {
    l = l.updateQueue, t.updateQueue === l && (t.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function ce(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function ie(l, t, e) {
    var a = l.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (il & 2) !== 0) {
      var u = a.pending;
      return u === null ? t.next = t : (t.next = u.next, u.next = t), a.pending = t, t = Ku(l), As(l, null, e), t;
    }
    return Vu(l, a, t, e), Ku(l);
  }
  function $a(l, t, e) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (e & 4194048) !== 0)) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Uf(l, e);
    }
  }
  function Jc(l, t) {
    var e = l.updateQueue, a = l.alternate;
    if (a !== null && (a = a.updateQueue, e === a)) {
      var u = null, n = null;
      if (e = e.firstBaseUpdate, e !== null) {
        do {
          var c = {
            lane: e.lane,
            tag: e.tag,
            payload: e.payload,
            callback: null,
            next: null
          };
          n === null ? u = n = c : n = n.next = c, e = e.next;
        } while (e !== null);
        n === null ? u = n = t : n = n.next = t;
      } else u = n = t;
      e = {
        baseState: a.baseState,
        firstBaseUpdate: u,
        lastBaseUpdate: n,
        shared: a.shared,
        callbacks: a.callbacks
      }, l.updateQueue = e;
      return;
    }
    l = e.lastBaseUpdate, l === null ? e.firstBaseUpdate = t : l.next = t, e.lastBaseUpdate = t;
  }
  var wc = !1;
  function ka() {
    if (wc) {
      var l = fa;
      if (l !== null) throw l;
    }
  }
  function Wa(l, t, e, a) {
    wc = !1;
    var u = l.updateQueue;
    ne = !1;
    var n = u.firstBaseUpdate, c = u.lastBaseUpdate, i = u.shared.pending;
    if (i !== null) {
      u.shared.pending = null;
      var f = i, v = f.next;
      f.next = null, c === null ? n = v : c.next = v, c = f;
      var p = l.alternate;
      p !== null && (p = p.updateQueue, i = p.lastBaseUpdate, i !== c && (i === null ? p.firstBaseUpdate = v : i.next = v, p.lastBaseUpdate = f));
    }
    if (n !== null) {
      var A = u.baseState;
      c = 0, p = v = f = null, i = n;
      do {
        var y = i.lane & -536870913, g = y !== i.lane;
        if (g ? (tl & y) === y : (a & y) === y) {
          y !== 0 && y === ia && (wc = !0), p !== null && (p = p.next = {
            lane: 0,
            tag: i.tag,
            payload: i.payload,
            callback: null,
            next: null
          });
          l: {
            var U = l, Y = i;
            y = t;
            var gl = e;
            switch (Y.tag) {
              case 1:
                if (U = Y.payload, typeof U == "function") {
                  A = U.call(gl, A, y);
                  break l;
                }
                A = U;
                break l;
              case 3:
                U.flags = U.flags & -65537 | 128;
              case 0:
                if (U = Y.payload, y = typeof U == "function" ? U.call(gl, A, y) : U, y == null) break l;
                A = M({}, A, y);
                break l;
              case 2:
                ne = !0;
            }
          }
          y = i.callback, y !== null && (l.flags |= 64, g && (l.flags |= 8192), g = u.callbacks, g === null ? u.callbacks = [y] : g.push(y));
        } else
          g = {
            lane: y,
            tag: i.tag,
            payload: i.payload,
            callback: i.callback,
            next: null
          }, p === null ? (v = p = g, f = A) : p = p.next = g, c |= y;
        if (i = i.next, i === null) {
          if (i = u.shared.pending, i === null)
            break;
          g = i, i = g.next, g.next = null, u.lastBaseUpdate = g, u.shared.pending = null;
        }
      } while (!0);
      p === null && (f = A), u.baseState = f, u.firstBaseUpdate = v, u.lastBaseUpdate = p, n === null && (u.shared.lanes = 0), de |= c, l.lanes = c, l.memoizedState = A;
    }
  }
  function Qs(l, t) {
    if (typeof l != "function")
      throw Error(r(191, l));
    l.call(t);
  }
  function Zs(l, t) {
    var e = l.callbacks;
    if (e !== null)
      for (l.callbacks = null, l = 0; l < e.length; l++)
        Qs(e[l], t);
  }
  var ra = o(null), tn = o(0);
  function Ls(l, t) {
    l = $t, N(tn, l), N(ra, t), $t = l | t.baseLanes;
  }
  function $c() {
    N(tn, $t), N(ra, ra.current);
  }
  function kc() {
    $t = tn.current, T(ra), T(tn);
  }
  var ot = o(null), At = null;
  function fe(l) {
    var t = l.alternate;
    N(Ol, Ol.current & 1), N(ot, l), At === null && (t === null || ra.current !== null || t.memoizedState !== null) && (At = l);
  }
  function Wc(l) {
    N(Ol, Ol.current), N(ot, l), At === null && (At = l);
  }
  function Vs(l) {
    l.tag === 22 ? (N(Ol, Ol.current), N(ot, l), At === null && (At = l)) : se();
  }
  function se() {
    N(Ol, Ol.current), N(ot, ot.current);
  }
  function rt(l) {
    T(ot), At === l && (At = null), T(Ol);
  }
  var Ol = o(0);
  function en(l) {
    for (var t = l; t !== null; ) {
      if (t.tag === 13) {
        var e = t.memoizedState;
        if (e !== null && (e = e.dehydrated, e === null || ef(e) || af(e)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === l) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === l) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var Xt = 0, w = null, vl = null, Ul = null, an = !1, da = !1, Ye = !1, un = 0, Fa = 0, ma = null, eh = 0;
  function _l() {
    throw Error(r(321));
  }
  function Fc(l, t) {
    if (t === null) return !1;
    for (var e = 0; e < t.length && e < l.length; e++)
      if (!ft(l[e], t[e])) return !1;
    return !0;
  }
  function Ic(l, t, e, a, u, n) {
    return Xt = n, w = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, E.H = l === null || l.memoizedState === null ? Oo : mi, Ye = !1, n = e(a, u), Ye = !1, da && (n = Js(
      t,
      e,
      a,
      u
    )), Ks(l), n;
  }
  function Ks(l) {
    E.H = lu;
    var t = vl !== null && vl.next !== null;
    if (Xt = 0, Ul = vl = w = null, an = !1, Fa = 0, ma = null, t) throw Error(r(300));
    l === null || jl || (l = l.dependencies, l !== null && $u(l) && (jl = !0));
  }
  function Js(l, t, e, a) {
    w = l;
    var u = 0;
    do {
      if (da && (ma = null), Fa = 0, da = !1, 25 <= u) throw Error(r(301));
      if (u += 1, Ul = vl = null, l.updateQueue != null) {
        var n = l.updateQueue;
        n.lastEffect = null, n.events = null, n.stores = null, n.memoCache != null && (n.memoCache.index = 0);
      }
      E.H = No, n = t(e, a);
    } while (da);
    return n;
  }
  function ah() {
    var l = E.H, t = l.useState()[0];
    return t = typeof t.then == "function" ? Ia(t) : t, l = l.useState()[0], (vl !== null ? vl.memoizedState : null) !== l && (w.flags |= 1024), t;
  }
  function Pc() {
    var l = un !== 0;
    return un = 0, l;
  }
  function li(l, t, e) {
    t.updateQueue = l.updateQueue, t.flags &= -2053, l.lanes &= ~e;
  }
  function ti(l) {
    if (an) {
      for (l = l.memoizedState; l !== null; ) {
        var t = l.queue;
        t !== null && (t.pending = null), l = l.next;
      }
      an = !1;
    }
    Xt = 0, Ul = vl = w = null, da = !1, Fa = un = 0, ma = null;
  }
  function Wl() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Ul === null ? w.memoizedState = Ul = l : Ul = Ul.next = l, Ul;
  }
  function Nl() {
    if (vl === null) {
      var l = w.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = vl.next;
    var t = Ul === null ? w.memoizedState : Ul.next;
    if (t !== null)
      Ul = t, vl = l;
    else {
      if (l === null)
        throw w.alternate === null ? Error(r(467)) : Error(r(310));
      vl = l, l = {
        memoizedState: vl.memoizedState,
        baseState: vl.baseState,
        baseQueue: vl.baseQueue,
        queue: vl.queue,
        next: null
      }, Ul === null ? w.memoizedState = Ul = l : Ul = Ul.next = l;
    }
    return Ul;
  }
  function nn() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Ia(l) {
    var t = Fa;
    return Fa += 1, ma === null && (ma = []), l = qs(ma, l, t), t = w, (Ul === null ? t.memoizedState : Ul.next) === null && (t = t.alternate, E.H = t === null || t.memoizedState === null ? Oo : mi), l;
  }
  function cn(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return Ia(l);
      if (l.$$typeof === ml) return Vl(l);
    }
    throw Error(r(438, String(l)));
  }
  function ei(l) {
    var t = null, e = w.updateQueue;
    if (e !== null && (t = e.memoCache), t == null) {
      var a = w.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (t = {
        data: a.data.map(function(u) {
          return u.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), e === null && (e = nn(), w.updateQueue = e), e.memoCache = t, e = t.data[t.index], e === void 0)
      for (e = t.data[t.index] = Array(l), a = 0; a < l; a++)
        e[a] = Ft;
    return t.index++, e;
  }
  function Qt(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function fn(l) {
    var t = Nl();
    return ai(t, vl, l);
  }
  function ai(l, t, e) {
    var a = l.queue;
    if (a === null) throw Error(r(311));
    a.lastRenderedReducer = e;
    var u = l.baseQueue, n = a.pending;
    if (n !== null) {
      if (u !== null) {
        var c = u.next;
        u.next = n.next, n.next = c;
      }
      t.baseQueue = u = n, a.pending = null;
    }
    if (n = l.baseState, u === null) l.memoizedState = n;
    else {
      t = u.next;
      var i = c = null, f = null, v = t, p = !1;
      do {
        var A = v.lane & -536870913;
        if (A !== v.lane ? (tl & A) === A : (Xt & A) === A) {
          var y = v.revertLane;
          if (y === 0)
            f !== null && (f = f.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: v.action,
              hasEagerState: v.hasEagerState,
              eagerState: v.eagerState,
              next: null
            }), A === ia && (p = !0);
          else if ((Xt & y) === y) {
            v = v.next, y === ia && (p = !0);
            continue;
          } else
            A = {
              lane: 0,
              revertLane: v.revertLane,
              gesture: null,
              action: v.action,
              hasEagerState: v.hasEagerState,
              eagerState: v.eagerState,
              next: null
            }, f === null ? (i = f = A, c = n) : f = f.next = A, w.lanes |= y, de |= y;
          A = v.action, Ye && e(n, A), n = v.hasEagerState ? v.eagerState : e(n, A);
        } else
          y = {
            lane: A,
            revertLane: v.revertLane,
            gesture: v.gesture,
            action: v.action,
            hasEagerState: v.hasEagerState,
            eagerState: v.eagerState,
            next: null
          }, f === null ? (i = f = y, c = n) : f = f.next = y, w.lanes |= A, de |= A;
        v = v.next;
      } while (v !== null && v !== t);
      if (f === null ? c = n : f.next = i, !ft(n, l.memoizedState) && (jl = !0, p && (e = fa, e !== null)))
        throw e;
      l.memoizedState = n, l.baseState = c, l.baseQueue = f, a.lastRenderedState = n;
    }
    return u === null && (a.lanes = 0), [l.memoizedState, a.dispatch];
  }
  function ui(l) {
    var t = Nl(), e = t.queue;
    if (e === null) throw Error(r(311));
    e.lastRenderedReducer = l;
    var a = e.dispatch, u = e.pending, n = t.memoizedState;
    if (u !== null) {
      e.pending = null;
      var c = u = u.next;
      do
        n = l(n, c.action), c = c.next;
      while (c !== u);
      ft(n, t.memoizedState) || (jl = !0), t.memoizedState = n, t.baseQueue === null && (t.baseState = n), e.lastRenderedState = n;
    }
    return [n, a];
  }
  function ws(l, t, e) {
    var a = w, u = Nl(), n = al;
    if (n) {
      if (e === void 0) throw Error(r(407));
      e = e();
    } else e = t();
    var c = !ft(
      (vl || u).memoizedState,
      e
    );
    if (c && (u.memoizedState = e, jl = !0), u = u.queue, ii(Ws.bind(null, a, u, l), [
      l
    ]), u.getSnapshot !== t || c || Ul !== null && Ul.memoizedState.tag & 1) {
      if (a.flags |= 2048, ha(
        9,
        { destroy: void 0 },
        ks.bind(
          null,
          a,
          u,
          e,
          t
        ),
        null
      ), Sl === null) throw Error(r(349));
      n || (Xt & 127) !== 0 || $s(a, t, e);
    }
    return e;
  }
  function $s(l, t, e) {
    l.flags |= 16384, l = { getSnapshot: t, value: e }, t = w.updateQueue, t === null ? (t = nn(), w.updateQueue = t, t.stores = [l]) : (e = t.stores, e === null ? t.stores = [l] : e.push(l));
  }
  function ks(l, t, e, a) {
    t.value = e, t.getSnapshot = a, Fs(t) && Is(l);
  }
  function Ws(l, t, e) {
    return e(function() {
      Fs(t) && Is(l);
    });
  }
  function Fs(l) {
    var t = l.getSnapshot;
    l = l.value;
    try {
      var e = t();
      return !ft(l, e);
    } catch {
      return !0;
    }
  }
  function Is(l) {
    var t = Ne(l, 2);
    t !== null && ut(t, l, 2);
  }
  function ni(l) {
    var t = Wl();
    if (typeof l == "function") {
      var e = l;
      if (l = e(), Ye) {
        It(!0);
        try {
          e();
        } finally {
          It(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = l, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Qt,
      lastRenderedState: l
    }, t;
  }
  function Ps(l, t, e, a) {
    return l.baseState = e, ai(
      l,
      vl,
      typeof a == "function" ? a : Qt
    );
  }
  function uh(l, t, e, a, u) {
    if (rn(l)) throw Error(r(485));
    if (l = t.action, l !== null) {
      var n = {
        payload: u,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(c) {
          n.listeners.push(c);
        }
      };
      E.T !== null ? e(!0) : n.isTransition = !1, a(n), e = t.pending, e === null ? (n.next = t.pending = n, lo(t, n)) : (n.next = e.next, t.pending = e.next = n);
    }
  }
  function lo(l, t) {
    var e = t.action, a = t.payload, u = l.state;
    if (t.isTransition) {
      var n = E.T, c = {};
      E.T = c;
      try {
        var i = e(u, a), f = E.S;
        f !== null && f(c, i), to(l, t, i);
      } catch (v) {
        ci(l, t, v);
      } finally {
        n !== null && c.types !== null && (n.types = c.types), E.T = n;
      }
    } else
      try {
        n = e(u, a), to(l, t, n);
      } catch (v) {
        ci(l, t, v);
      }
  }
  function to(l, t, e) {
    e !== null && typeof e == "object" && typeof e.then == "function" ? e.then(
      function(a) {
        eo(l, t, a);
      },
      function(a) {
        return ci(l, t, a);
      }
    ) : eo(l, t, e);
  }
  function eo(l, t, e) {
    t.status = "fulfilled", t.value = e, ao(t), l.state = e, t = l.pending, t !== null && (e = t.next, e === t ? l.pending = null : (e = e.next, t.next = e, lo(l, e)));
  }
  function ci(l, t, e) {
    var a = l.pending;
    if (l.pending = null, a !== null) {
      a = a.next;
      do
        t.status = "rejected", t.reason = e, ao(t), t = t.next;
      while (t !== a);
    }
    l.action = null;
  }
  function ao(l) {
    l = l.listeners;
    for (var t = 0; t < l.length; t++) (0, l[t])();
  }
  function uo(l, t) {
    return t;
  }
  function no(l, t) {
    if (al) {
      var e = Sl.formState;
      if (e !== null) {
        l: {
          var a = w;
          if (al) {
            if (pl) {
              t: {
                for (var u = pl, n = zt; u.nodeType !== 8; ) {
                  if (!n) {
                    u = null;
                    break t;
                  }
                  if (u = Tt(
                    u.nextSibling
                  ), u === null) {
                    u = null;
                    break t;
                  }
                }
                n = u.data, u = n === "F!" || n === "F" ? u : null;
              }
              if (u) {
                pl = Tt(
                  u.nextSibling
                ), a = u.data === "F!";
                break l;
              }
            }
            ae(a);
          }
          a = !1;
        }
        a && (t = e[0]);
      }
    }
    return e = Wl(), e.memoizedState = e.baseState = t, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: uo,
      lastRenderedState: t
    }, e.queue = a, e = _o.bind(
      null,
      w,
      a
    ), a.dispatch = e, a = ni(!1), n = di.bind(
      null,
      w,
      !1,
      a.queue
    ), a = Wl(), u = {
      state: t,
      dispatch: null,
      action: l,
      pending: null
    }, a.queue = u, e = uh.bind(
      null,
      w,
      u,
      n,
      e
    ), u.dispatch = e, a.memoizedState = l, [t, e, !1];
  }
  function co(l) {
    var t = Nl();
    return io(t, vl, l);
  }
  function io(l, t, e) {
    if (t = ai(
      l,
      t,
      uo
    )[0], l = fn(Qt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var a = Ia(t);
      } catch (c) {
        throw c === sa ? Fu : c;
      }
    else a = t;
    t = Nl();
    var u = t.queue, n = u.dispatch;
    return e !== t.memoizedState && (w.flags |= 2048, ha(
      9,
      { destroy: void 0 },
      nh.bind(null, u, e),
      null
    )), [a, n, l];
  }
  function nh(l, t) {
    l.action = t;
  }
  function fo(l) {
    var t = Nl(), e = vl;
    if (e !== null)
      return io(t, e, l);
    Nl(), t = t.memoizedState, e = Nl();
    var a = e.queue.dispatch;
    return e.memoizedState = l, [t, a, !1];
  }
  function ha(l, t, e, a) {
    return l = { tag: l, create: e, deps: a, inst: t, next: null }, t = w.updateQueue, t === null && (t = nn(), w.updateQueue = t), e = t.lastEffect, e === null ? t.lastEffect = l.next = l : (a = e.next, e.next = l, l.next = a, t.lastEffect = l), l;
  }
  function so() {
    return Nl().memoizedState;
  }
  function sn(l, t, e, a) {
    var u = Wl();
    w.flags |= l, u.memoizedState = ha(
      1 | t,
      { destroy: void 0 },
      e,
      a === void 0 ? null : a
    );
  }
  function on(l, t, e, a) {
    var u = Nl();
    a = a === void 0 ? null : a;
    var n = u.memoizedState.inst;
    vl !== null && a !== null && Fc(a, vl.memoizedState.deps) ? u.memoizedState = ha(t, n, e, a) : (w.flags |= l, u.memoizedState = ha(
      1 | t,
      n,
      e,
      a
    ));
  }
  function oo(l, t) {
    sn(8390656, 8, l, t);
  }
  function ii(l, t) {
    on(2048, 8, l, t);
  }
  function ch(l) {
    w.flags |= 4;
    var t = w.updateQueue;
    if (t === null)
      t = nn(), w.updateQueue = t, t.events = [l];
    else {
      var e = t.events;
      e === null ? t.events = [l] : e.push(l);
    }
  }
  function ro(l) {
    var t = Nl().memoizedState;
    return ch({ ref: t, nextImpl: l }), function() {
      if ((il & 2) !== 0) throw Error(r(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function mo(l, t) {
    return on(4, 2, l, t);
  }
  function ho(l, t) {
    return on(4, 4, l, t);
  }
  function vo(l, t) {
    if (typeof t == "function") {
      l = l();
      var e = t(l);
      return function() {
        typeof e == "function" ? e() : t(null);
      };
    }
    if (t != null)
      return l = l(), t.current = l, function() {
        t.current = null;
      };
  }
  function yo(l, t, e) {
    e = e != null ? e.concat([l]) : null, on(4, 4, vo.bind(null, t, l), e);
  }
  function fi() {
  }
  function go(l, t) {
    var e = Nl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    return t !== null && Fc(t, a[1]) ? a[0] : (e.memoizedState = [l, t], l);
  }
  function bo(l, t) {
    var e = Nl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    if (t !== null && Fc(t, a[1]))
      return a[0];
    if (a = l(), Ye) {
      It(!0);
      try {
        l();
      } finally {
        It(!1);
      }
    }
    return e.memoizedState = [a, t], a;
  }
  function si(l, t, e) {
    return e === void 0 || (Xt & 1073741824) !== 0 && (tl & 261930) === 0 ? l.memoizedState = t : (l.memoizedState = e, l = Sr(), w.lanes |= l, de |= l, e);
  }
  function So(l, t, e, a) {
    return ft(e, t) ? e : ra.current !== null ? (l = si(l, e, a), ft(l, t) || (jl = !0), l) : (Xt & 42) === 0 || (Xt & 1073741824) !== 0 && (tl & 261930) === 0 ? (jl = !0, l.memoizedState = e) : (l = Sr(), w.lanes |= l, de |= l, t);
  }
  function po(l, t, e, a, u) {
    var n = O.p;
    O.p = n !== 0 && 8 > n ? n : 8;
    var c = E.T, i = {};
    E.T = i, di(l, !1, t, e);
    try {
      var f = u(), v = E.S;
      if (v !== null && v(i, f), f !== null && typeof f == "object" && typeof f.then == "function") {
        var p = th(
          f,
          a
        );
        Pa(
          l,
          t,
          p,
          ht(l)
        );
      } else
        Pa(
          l,
          t,
          a,
          ht(l)
        );
    } catch (A) {
      Pa(
        l,
        t,
        { then: function() {
        }, status: "rejected", reason: A },
        ht()
      );
    } finally {
      O.p = n, c !== null && i.types !== null && (c.types = i.types), E.T = c;
    }
  }
  function ih() {
  }
  function oi(l, t, e, a) {
    if (l.tag !== 5) throw Error(r(476));
    var u = Eo(l).queue;
    po(
      l,
      u,
      t,
      G,
      e === null ? ih : function() {
        return zo(l), e(a);
      }
    );
  }
  function Eo(l) {
    var t = l.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: G,
      baseState: G,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Qt,
        lastRenderedState: G
      },
      next: null
    };
    var e = {};
    return t.next = {
      memoizedState: e,
      baseState: e,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Qt,
        lastRenderedState: e
      },
      next: null
    }, l.memoizedState = t, l = l.alternate, l !== null && (l.memoizedState = t), t;
  }
  function zo(l) {
    var t = Eo(l);
    t.next === null && (t = l.alternate.memoizedState), Pa(
      l,
      t.next.queue,
      {},
      ht()
    );
  }
  function ri() {
    return Vl(yu);
  }
  function Ao() {
    return Nl().memoizedState;
  }
  function To() {
    return Nl().memoizedState;
  }
  function fh(l) {
    for (var t = l.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var e = ht();
          l = ce(e);
          var a = ie(t, l, e);
          a !== null && (ut(a, t, e), $a(a, t, e)), t = { cache: Xc() }, l.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function sh(l, t, e) {
    var a = ht();
    e = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, rn(l) ? xo(t, e) : (e = Nc(l, t, e, a), e !== null && (ut(e, l, a), Mo(e, t, a)));
  }
  function _o(l, t, e) {
    var a = ht();
    Pa(l, t, e, a);
  }
  function Pa(l, t, e, a) {
    var u = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (rn(l)) xo(t, u);
    else {
      var n = l.alternate;
      if (l.lanes === 0 && (n === null || n.lanes === 0) && (n = t.lastRenderedReducer, n !== null))
        try {
          var c = t.lastRenderedState, i = n(c, e);
          if (u.hasEagerState = !0, u.eagerState = i, ft(i, c))
            return Vu(l, t, u, 0), Sl === null && Lu(), !1;
        } catch {
        }
      if (e = Nc(l, t, u, a), e !== null)
        return ut(e, l, a), Mo(e, t, a), !0;
    }
    return !1;
  }
  function di(l, t, e, a) {
    if (a = {
      lane: 2,
      revertLane: Vi(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, rn(l)) {
      if (t) throw Error(r(479));
    } else
      t = Nc(
        l,
        e,
        a,
        2
      ), t !== null && ut(t, l, 2);
  }
  function rn(l) {
    var t = l.alternate;
    return l === w || t !== null && t === w;
  }
  function xo(l, t) {
    da = an = !0;
    var e = l.pending;
    e === null ? t.next = t : (t.next = e.next, e.next = t), l.pending = t;
  }
  function Mo(l, t, e) {
    if ((e & 4194048) !== 0) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Uf(l, e);
    }
  }
  var lu = {
    readContext: Vl,
    use: cn,
    useCallback: _l,
    useContext: _l,
    useEffect: _l,
    useImperativeHandle: _l,
    useLayoutEffect: _l,
    useInsertionEffect: _l,
    useMemo: _l,
    useReducer: _l,
    useRef: _l,
    useState: _l,
    useDebugValue: _l,
    useDeferredValue: _l,
    useTransition: _l,
    useSyncExternalStore: _l,
    useId: _l,
    useHostTransitionStatus: _l,
    useFormState: _l,
    useActionState: _l,
    useOptimistic: _l,
    useMemoCache: _l,
    useCacheRefresh: _l
  };
  lu.useEffectEvent = _l;
  var Oo = {
    readContext: Vl,
    use: cn,
    useCallback: function(l, t) {
      return Wl().memoizedState = [
        l,
        t === void 0 ? null : t
      ], l;
    },
    useContext: Vl,
    useEffect: oo,
    useImperativeHandle: function(l, t, e) {
      e = e != null ? e.concat([l]) : null, sn(
        4194308,
        4,
        vo.bind(null, t, l),
        e
      );
    },
    useLayoutEffect: function(l, t) {
      return sn(4194308, 4, l, t);
    },
    useInsertionEffect: function(l, t) {
      sn(4, 2, l, t);
    },
    useMemo: function(l, t) {
      var e = Wl();
      t = t === void 0 ? null : t;
      var a = l();
      if (Ye) {
        It(!0);
        try {
          l();
        } finally {
          It(!1);
        }
      }
      return e.memoizedState = [a, t], a;
    },
    useReducer: function(l, t, e) {
      var a = Wl();
      if (e !== void 0) {
        var u = e(t);
        if (Ye) {
          It(!0);
          try {
            e(t);
          } finally {
            It(!1);
          }
        }
      } else u = t;
      return a.memoizedState = a.baseState = u, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: u
      }, a.queue = l, l = l.dispatch = sh.bind(
        null,
        w,
        l
      ), [a.memoizedState, l];
    },
    useRef: function(l) {
      var t = Wl();
      return l = { current: l }, t.memoizedState = l;
    },
    useState: function(l) {
      l = ni(l);
      var t = l.queue, e = _o.bind(null, w, t);
      return t.dispatch = e, [l.memoizedState, e];
    },
    useDebugValue: fi,
    useDeferredValue: function(l, t) {
      var e = Wl();
      return si(e, l, t);
    },
    useTransition: function() {
      var l = ni(!1);
      return l = po.bind(
        null,
        w,
        l.queue,
        !0,
        !1
      ), Wl().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, t, e) {
      var a = w, u = Wl();
      if (al) {
        if (e === void 0)
          throw Error(r(407));
        e = e();
      } else {
        if (e = t(), Sl === null)
          throw Error(r(349));
        (tl & 127) !== 0 || $s(a, t, e);
      }
      u.memoizedState = e;
      var n = { value: e, getSnapshot: t };
      return u.queue = n, oo(Ws.bind(null, a, n, l), [
        l
      ]), a.flags |= 2048, ha(
        9,
        { destroy: void 0 },
        ks.bind(
          null,
          a,
          n,
          e,
          t
        ),
        null
      ), e;
    },
    useId: function() {
      var l = Wl(), t = Sl.identifierPrefix;
      if (al) {
        var e = Dt, a = Nt;
        e = (a & ~(1 << 32 - it(a) - 1)).toString(32) + e, t = "_" + t + "R_" + e, e = un++, 0 < e && (t += "H" + e.toString(32)), t += "_";
      } else
        e = eh++, t = "_" + t + "r_" + e.toString(32) + "_";
      return l.memoizedState = t;
    },
    useHostTransitionStatus: ri,
    useFormState: no,
    useActionState: no,
    useOptimistic: function(l) {
      var t = Wl();
      t.memoizedState = t.baseState = l;
      var e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = e, t = di.bind(
        null,
        w,
        !0,
        e
      ), e.dispatch = t, [l, t];
    },
    useMemoCache: ei,
    useCacheRefresh: function() {
      return Wl().memoizedState = fh.bind(
        null,
        w
      );
    },
    useEffectEvent: function(l) {
      var t = Wl(), e = { impl: l };
      return t.memoizedState = e, function() {
        if ((il & 2) !== 0)
          throw Error(r(440));
        return e.impl.apply(void 0, arguments);
      };
    }
  }, mi = {
    readContext: Vl,
    use: cn,
    useCallback: go,
    useContext: Vl,
    useEffect: ii,
    useImperativeHandle: yo,
    useInsertionEffect: mo,
    useLayoutEffect: ho,
    useMemo: bo,
    useReducer: fn,
    useRef: so,
    useState: function() {
      return fn(Qt);
    },
    useDebugValue: fi,
    useDeferredValue: function(l, t) {
      var e = Nl();
      return So(
        e,
        vl.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = fn(Qt)[0], t = Nl().memoizedState;
      return [
        typeof l == "boolean" ? l : Ia(l),
        t
      ];
    },
    useSyncExternalStore: ws,
    useId: Ao,
    useHostTransitionStatus: ri,
    useFormState: co,
    useActionState: co,
    useOptimistic: function(l, t) {
      var e = Nl();
      return Ps(e, vl, l, t);
    },
    useMemoCache: ei,
    useCacheRefresh: To
  };
  mi.useEffectEvent = ro;
  var No = {
    readContext: Vl,
    use: cn,
    useCallback: go,
    useContext: Vl,
    useEffect: ii,
    useImperativeHandle: yo,
    useInsertionEffect: mo,
    useLayoutEffect: ho,
    useMemo: bo,
    useReducer: ui,
    useRef: so,
    useState: function() {
      return ui(Qt);
    },
    useDebugValue: fi,
    useDeferredValue: function(l, t) {
      var e = Nl();
      return vl === null ? si(e, l, t) : So(
        e,
        vl.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = ui(Qt)[0], t = Nl().memoizedState;
      return [
        typeof l == "boolean" ? l : Ia(l),
        t
      ];
    },
    useSyncExternalStore: ws,
    useId: Ao,
    useHostTransitionStatus: ri,
    useFormState: fo,
    useActionState: fo,
    useOptimistic: function(l, t) {
      var e = Nl();
      return vl !== null ? Ps(e, vl, l, t) : (e.baseState = l, [l, e.queue.dispatch]);
    },
    useMemoCache: ei,
    useCacheRefresh: To
  };
  No.useEffectEvent = ro;
  function hi(l, t, e, a) {
    t = l.memoizedState, e = e(a, t), e = e == null ? t : M({}, t, e), l.memoizedState = e, l.lanes === 0 && (l.updateQueue.baseState = e);
  }
  var vi = {
    enqueueSetState: function(l, t, e) {
      l = l._reactInternals;
      var a = ht(), u = ce(a);
      u.payload = t, e != null && (u.callback = e), t = ie(l, u, a), t !== null && (ut(t, l, a), $a(t, l, a));
    },
    enqueueReplaceState: function(l, t, e) {
      l = l._reactInternals;
      var a = ht(), u = ce(a);
      u.tag = 1, u.payload = t, e != null && (u.callback = e), t = ie(l, u, a), t !== null && (ut(t, l, a), $a(t, l, a));
    },
    enqueueForceUpdate: function(l, t) {
      l = l._reactInternals;
      var e = ht(), a = ce(e);
      a.tag = 2, t != null && (a.callback = t), t = ie(l, a, e), t !== null && (ut(t, l, e), $a(t, l, e));
    }
  };
  function Do(l, t, e, a, u, n, c) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(a, n, c) : t.prototype && t.prototype.isPureReactComponent ? !Xa(e, a) || !Xa(u, n) : !0;
  }
  function Uo(l, t, e, a) {
    l = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(e, a), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(e, a), t.state !== l && vi.enqueueReplaceState(t, t.state, null);
  }
  function Ge(l, t) {
    var e = t;
    if ("ref" in t) {
      e = {};
      for (var a in t)
        a !== "ref" && (e[a] = t[a]);
    }
    if (l = l.defaultProps) {
      e === t && (e = M({}, e));
      for (var u in l)
        e[u] === void 0 && (e[u] = l[u]);
    }
    return e;
  }
  function jo(l) {
    Zu(l);
  }
  function Co(l) {
    console.error(l);
  }
  function Ho(l) {
    Zu(l);
  }
  function dn(l, t) {
    try {
      var e = l.onUncaughtError;
      e(t.value, { componentStack: t.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Ro(l, t, e) {
    try {
      var a = l.onCaughtError;
      a(e.value, {
        componentStack: e.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  function yi(l, t, e) {
    return e = ce(e), e.tag = 3, e.payload = { element: null }, e.callback = function() {
      dn(l, t);
    }, e;
  }
  function qo(l) {
    return l = ce(l), l.tag = 3, l;
  }
  function Bo(l, t, e, a) {
    var u = e.type.getDerivedStateFromError;
    if (typeof u == "function") {
      var n = a.value;
      l.payload = function() {
        return u(n);
      }, l.callback = function() {
        Ro(t, e, a);
      };
    }
    var c = e.stateNode;
    c !== null && typeof c.componentDidCatch == "function" && (l.callback = function() {
      Ro(t, e, a), typeof u != "function" && (me === null ? me = /* @__PURE__ */ new Set([this]) : me.add(this));
      var i = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: i !== null ? i : ""
      });
    });
  }
  function oh(l, t, e, a, u) {
    if (e.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (t = e.alternate, t !== null && ca(
        t,
        e,
        u,
        !0
      ), e = ot.current, e !== null) {
        switch (e.tag) {
          case 31:
          case 13:
            return At === null ? Tn() : e.alternate === null && xl === 0 && (xl = 3), e.flags &= -257, e.flags |= 65536, e.lanes = u, a === Iu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? e.updateQueue = /* @__PURE__ */ new Set([a]) : t.add(a), Qi(l, a, u)), !1;
          case 22:
            return e.flags |= 65536, a === Iu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, e.updateQueue = t) : (e = t.retryQueue, e === null ? t.retryQueue = /* @__PURE__ */ new Set([a]) : e.add(a)), Qi(l, a, u)), !1;
        }
        throw Error(r(435, e.tag));
      }
      return Qi(l, a, u), Tn(), !1;
    }
    if (al)
      return t = ot.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = u, a !== Rc && (l = Error(r(422), { cause: a }), La(St(l, e)))) : (a !== Rc && (t = Error(r(423), {
        cause: a
      }), La(
        St(t, e)
      )), l = l.current.alternate, l.flags |= 65536, u &= -u, l.lanes |= u, a = St(a, e), u = yi(
        l.stateNode,
        a,
        u
      ), Jc(l, u), xl !== 4 && (xl = 2)), !1;
    var n = Error(r(520), { cause: a });
    if (n = St(n, e), fu === null ? fu = [n] : fu.push(n), xl !== 4 && (xl = 2), t === null) return !0;
    a = St(a, e), e = t;
    do {
      switch (e.tag) {
        case 3:
          return e.flags |= 65536, l = u & -u, e.lanes |= l, l = yi(e.stateNode, a, l), Jc(e, l), !1;
        case 1:
          if (t = e.type, n = e.stateNode, (e.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || n !== null && typeof n.componentDidCatch == "function" && (me === null || !me.has(n))))
            return e.flags |= 65536, u &= -u, e.lanes |= u, u = qo(u), Bo(
              u,
              l,
              e,
              a
            ), Jc(e, u), !1;
      }
      e = e.return;
    } while (e !== null);
    return !1;
  }
  var gi = Error(r(461)), jl = !1;
  function Kl(l, t, e, a) {
    t.child = l === null ? Xs(t, null, e, a) : Be(
      t,
      l.child,
      e,
      a
    );
  }
  function Yo(l, t, e, a, u) {
    e = e.render;
    var n = t.ref;
    if ("ref" in a) {
      var c = {};
      for (var i in a)
        i !== "ref" && (c[i] = a[i]);
    } else c = a;
    return Ce(t), a = Ic(
      l,
      t,
      e,
      c,
      n,
      u
    ), i = Pc(), l !== null && !jl ? (li(l, t, u), Zt(l, t, u)) : (al && i && Cc(t), t.flags |= 1, Kl(l, t, a, u), t.child);
  }
  function Go(l, t, e, a, u) {
    if (l === null) {
      var n = e.type;
      return typeof n == "function" && !Dc(n) && n.defaultProps === void 0 && e.compare === null ? (t.tag = 15, t.type = n, Xo(
        l,
        t,
        n,
        a,
        u
      )) : (l = Ju(
        e.type,
        null,
        a,
        t,
        t.mode,
        u
      ), l.ref = t.ref, l.return = t, t.child = l);
    }
    if (n = l.child, !_i(l, u)) {
      var c = n.memoizedProps;
      if (e = e.compare, e = e !== null ? e : Xa, e(c, a) && l.ref === t.ref)
        return Zt(l, t, u);
    }
    return t.flags |= 1, l = qt(n, a), l.ref = t.ref, l.return = t, t.child = l;
  }
  function Xo(l, t, e, a, u) {
    if (l !== null) {
      var n = l.memoizedProps;
      if (Xa(n, a) && l.ref === t.ref)
        if (jl = !1, t.pendingProps = a = n, _i(l, u))
          (l.flags & 131072) !== 0 && (jl = !0);
        else
          return t.lanes = l.lanes, Zt(l, t, u);
    }
    return bi(
      l,
      t,
      e,
      a,
      u
    );
  }
  function Qo(l, t, e, a) {
    var u = a.children, n = l !== null ? l.memoizedState : null;
    if (l === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (n = n !== null ? n.baseLanes | e : e, l !== null) {
          for (a = t.child = l.child, u = 0; a !== null; )
            u = u | a.lanes | a.childLanes, a = a.sibling;
          a = u & ~n;
        } else a = 0, t.child = null;
        return Zo(
          l,
          t,
          n,
          e,
          a
        );
      }
      if ((e & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && Wu(
          t,
          n !== null ? n.cachePool : null
        ), n !== null ? Ls(t, n) : $c(), Vs(t);
      else
        return a = t.lanes = 536870912, Zo(
          l,
          t,
          n !== null ? n.baseLanes | e : e,
          e,
          a
        );
    } else
      n !== null ? (Wu(t, n.cachePool), Ls(t, n), se(), t.memoizedState = null) : (l !== null && Wu(t, null), $c(), se());
    return Kl(l, t, u, e), t.child;
  }
  function tu(l, t) {
    return l !== null && l.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function Zo(l, t, e, a, u) {
    var n = Zc();
    return n = n === null ? null : { parent: Dl._currentValue, pool: n }, t.memoizedState = {
      baseLanes: e,
      cachePool: n
    }, l !== null && Wu(t, null), $c(), Vs(t), l !== null && ca(l, t, a, !0), t.childLanes = u, null;
  }
  function mn(l, t) {
    return t = vn(
      { mode: t.mode, children: t.children },
      l.mode
    ), t.ref = l.ref, l.child = t, t.return = l, t;
  }
  function Lo(l, t, e) {
    return Be(t, l.child, null, e), l = mn(t, t.pendingProps), l.flags |= 2, rt(t), t.memoizedState = null, l;
  }
  function rh(l, t, e) {
    var a = t.pendingProps, u = (t.flags & 128) !== 0;
    if (t.flags &= -129, l === null) {
      if (al) {
        if (a.mode === "hidden")
          return l = mn(t, a), t.lanes = 536870912, tu(null, l);
        if (Wc(t), (l = pl) ? (l = td(
          l,
          zt
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: te !== null ? { id: Nt, overflow: Dt } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = _s(l), e.return = t, t.child = e, Ll = t, pl = null)) : l = null, l === null) throw ae(t);
        return t.lanes = 536870912, null;
      }
      return mn(t, a);
    }
    var n = l.memoizedState;
    if (n !== null) {
      var c = n.dehydrated;
      if (Wc(t), u)
        if (t.flags & 256)
          t.flags &= -257, t = Lo(
            l,
            t,
            e
          );
        else if (t.memoizedState !== null)
          t.child = l.child, t.flags |= 128, t = null;
        else throw Error(r(558));
      else if (jl || ca(l, t, e, !1), u = (e & l.childLanes) !== 0, jl || u) {
        if (a = Sl, a !== null && (c = jf(a, e), c !== 0 && c !== n.retryLane))
          throw n.retryLane = c, Ne(l, c), ut(a, l, c), gi;
        Tn(), t = Lo(
          l,
          t,
          e
        );
      } else
        l = n.treeContext, pl = Tt(c.nextSibling), Ll = t, al = !0, ee = null, zt = !1, l !== null && Os(t, l), t = mn(t, a), t.flags |= 4096;
      return t;
    }
    return l = qt(l.child, {
      mode: a.mode,
      children: a.children
    }), l.ref = t.ref, t.child = l, l.return = t, l;
  }
  function hn(l, t) {
    var e = t.ref;
    if (e === null)
      l !== null && l.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof e != "function" && typeof e != "object")
        throw Error(r(284));
      (l === null || l.ref !== e) && (t.flags |= 4194816);
    }
  }
  function bi(l, t, e, a, u) {
    return Ce(t), e = Ic(
      l,
      t,
      e,
      a,
      void 0,
      u
    ), a = Pc(), l !== null && !jl ? (li(l, t, u), Zt(l, t, u)) : (al && a && Cc(t), t.flags |= 1, Kl(l, t, e, u), t.child);
  }
  function Vo(l, t, e, a, u, n) {
    return Ce(t), t.updateQueue = null, e = Js(
      t,
      a,
      e,
      u
    ), Ks(l), a = Pc(), l !== null && !jl ? (li(l, t, n), Zt(l, t, n)) : (al && a && Cc(t), t.flags |= 1, Kl(l, t, e, n), t.child);
  }
  function Ko(l, t, e, a, u) {
    if (Ce(t), t.stateNode === null) {
      var n = ea, c = e.contextType;
      typeof c == "object" && c !== null && (n = Vl(c)), n = new e(a, n), t.memoizedState = n.state !== null && n.state !== void 0 ? n.state : null, n.updater = vi, t.stateNode = n, n._reactInternals = t, n = t.stateNode, n.props = a, n.state = t.memoizedState, n.refs = {}, Vc(t), c = e.contextType, n.context = typeof c == "object" && c !== null ? Vl(c) : ea, n.state = t.memoizedState, c = e.getDerivedStateFromProps, typeof c == "function" && (hi(
        t,
        e,
        c,
        a
      ), n.state = t.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof n.getSnapshotBeforeUpdate == "function" || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (c = n.state, typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount(), c !== n.state && vi.enqueueReplaceState(n, n.state, null), Wa(t, a, n, u), ka(), n.state = t.memoizedState), typeof n.componentDidMount == "function" && (t.flags |= 4194308), a = !0;
    } else if (l === null) {
      n = t.stateNode;
      var i = t.memoizedProps, f = Ge(e, i);
      n.props = f;
      var v = n.context, p = e.contextType;
      c = ea, typeof p == "object" && p !== null && (c = Vl(p));
      var A = e.getDerivedStateFromProps;
      p = typeof A == "function" || typeof n.getSnapshotBeforeUpdate == "function", i = t.pendingProps !== i, p || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (i || v !== c) && Uo(
        t,
        n,
        a,
        c
      ), ne = !1;
      var y = t.memoizedState;
      n.state = y, Wa(t, a, n, u), ka(), v = t.memoizedState, i || y !== v || ne ? (typeof A == "function" && (hi(
        t,
        e,
        A,
        a
      ), v = t.memoizedState), (f = ne || Do(
        t,
        e,
        f,
        a,
        y,
        v,
        c
      )) ? (p || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount()), typeof n.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof n.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = a, t.memoizedState = v), n.props = a, n.state = v, n.context = c, a = f) : (typeof n.componentDidMount == "function" && (t.flags |= 4194308), a = !1);
    } else {
      n = t.stateNode, Kc(l, t), c = t.memoizedProps, p = Ge(e, c), n.props = p, A = t.pendingProps, y = n.context, v = e.contextType, f = ea, typeof v == "object" && v !== null && (f = Vl(v)), i = e.getDerivedStateFromProps, (v = typeof i == "function" || typeof n.getSnapshotBeforeUpdate == "function") || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (c !== A || y !== f) && Uo(
        t,
        n,
        a,
        f
      ), ne = !1, y = t.memoizedState, n.state = y, Wa(t, a, n, u), ka();
      var g = t.memoizedState;
      c !== A || y !== g || ne || l !== null && l.dependencies !== null && $u(l.dependencies) ? (typeof i == "function" && (hi(
        t,
        e,
        i,
        a
      ), g = t.memoizedState), (p = ne || Do(
        t,
        e,
        p,
        a,
        y,
        g,
        f
      ) || l !== null && l.dependencies !== null && $u(l.dependencies)) ? (v || typeof n.UNSAFE_componentWillUpdate != "function" && typeof n.componentWillUpdate != "function" || (typeof n.componentWillUpdate == "function" && n.componentWillUpdate(a, g, f), typeof n.UNSAFE_componentWillUpdate == "function" && n.UNSAFE_componentWillUpdate(
        a,
        g,
        f
      )), typeof n.componentDidUpdate == "function" && (t.flags |= 4), typeof n.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof n.componentDidUpdate != "function" || c === l.memoizedProps && y === l.memoizedState || (t.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || c === l.memoizedProps && y === l.memoizedState || (t.flags |= 1024), t.memoizedProps = a, t.memoizedState = g), n.props = a, n.state = g, n.context = f, a = p) : (typeof n.componentDidUpdate != "function" || c === l.memoizedProps && y === l.memoizedState || (t.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || c === l.memoizedProps && y === l.memoizedState || (t.flags |= 1024), a = !1);
    }
    return n = a, hn(l, t), a = (t.flags & 128) !== 0, n || a ? (n = t.stateNode, e = a && typeof e.getDerivedStateFromError != "function" ? null : n.render(), t.flags |= 1, l !== null && a ? (t.child = Be(
      t,
      l.child,
      null,
      u
    ), t.child = Be(
      t,
      null,
      e,
      u
    )) : Kl(l, t, e, u), t.memoizedState = n.state, l = t.child) : l = Zt(
      l,
      t,
      u
    ), l;
  }
  function Jo(l, t, e, a) {
    return Ue(), t.flags |= 256, Kl(l, t, e, a), t.child;
  }
  var Si = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function pi(l) {
    return { baseLanes: l, cachePool: Hs() };
  }
  function Ei(l, t, e) {
    return l = l !== null ? l.childLanes & ~e : 0, t && (l |= mt), l;
  }
  function wo(l, t, e) {
    var a = t.pendingProps, u = !1, n = (t.flags & 128) !== 0, c;
    if ((c = n) || (c = l !== null && l.memoizedState === null ? !1 : (Ol.current & 2) !== 0), c && (u = !0, t.flags &= -129), c = (t.flags & 32) !== 0, t.flags &= -33, l === null) {
      if (al) {
        if (u ? fe(t) : se(), (l = pl) ? (l = td(
          l,
          zt
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: te !== null ? { id: Nt, overflow: Dt } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = _s(l), e.return = t, t.child = e, Ll = t, pl = null)) : l = null, l === null) throw ae(t);
        return af(l) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var i = a.children;
      return a = a.fallback, u ? (se(), u = t.mode, i = vn(
        { mode: "hidden", children: i },
        u
      ), a = De(
        a,
        u,
        e,
        null
      ), i.return = t, a.return = t, i.sibling = a, t.child = i, a = t.child, a.memoizedState = pi(e), a.childLanes = Ei(
        l,
        c,
        e
      ), t.memoizedState = Si, tu(null, a)) : (fe(t), zi(t, i));
    }
    var f = l.memoizedState;
    if (f !== null && (i = f.dehydrated, i !== null)) {
      if (n)
        t.flags & 256 ? (fe(t), t.flags &= -257, t = Ai(
          l,
          t,
          e
        )) : t.memoizedState !== null ? (se(), t.child = l.child, t.flags |= 128, t = null) : (se(), i = a.fallback, u = t.mode, a = vn(
          { mode: "visible", children: a.children },
          u
        ), i = De(
          i,
          u,
          e,
          null
        ), i.flags |= 2, a.return = t, i.return = t, a.sibling = i, t.child = a, Be(
          t,
          l.child,
          null,
          e
        ), a = t.child, a.memoizedState = pi(e), a.childLanes = Ei(
          l,
          c,
          e
        ), t.memoizedState = Si, t = tu(null, a));
      else if (fe(t), af(i)) {
        if (c = i.nextSibling && i.nextSibling.dataset, c) var v = c.dgst;
        c = v, a = Error(r(419)), a.stack = "", a.digest = c, La({ value: a, source: null, stack: null }), t = Ai(
          l,
          t,
          e
        );
      } else if (jl || ca(l, t, e, !1), c = (e & l.childLanes) !== 0, jl || c) {
        if (c = Sl, c !== null && (a = jf(c, e), a !== 0 && a !== f.retryLane))
          throw f.retryLane = a, Ne(l, a), ut(c, l, a), gi;
        ef(i) || Tn(), t = Ai(
          l,
          t,
          e
        );
      } else
        ef(i) ? (t.flags |= 192, t.child = l.child, t = null) : (l = f.treeContext, pl = Tt(
          i.nextSibling
        ), Ll = t, al = !0, ee = null, zt = !1, l !== null && Os(t, l), t = zi(
          t,
          a.children
        ), t.flags |= 4096);
      return t;
    }
    return u ? (se(), i = a.fallback, u = t.mode, f = l.child, v = f.sibling, a = qt(f, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = f.subtreeFlags & 65011712, v !== null ? i = qt(
      v,
      i
    ) : (i = De(
      i,
      u,
      e,
      null
    ), i.flags |= 2), i.return = t, a.return = t, a.sibling = i, t.child = a, tu(null, a), a = t.child, i = l.child.memoizedState, i === null ? i = pi(e) : (u = i.cachePool, u !== null ? (f = Dl._currentValue, u = u.parent !== f ? { parent: f, pool: f } : u) : u = Hs(), i = {
      baseLanes: i.baseLanes | e,
      cachePool: u
    }), a.memoizedState = i, a.childLanes = Ei(
      l,
      c,
      e
    ), t.memoizedState = Si, tu(l.child, a)) : (fe(t), e = l.child, l = e.sibling, e = qt(e, {
      mode: "visible",
      children: a.children
    }), e.return = t, e.sibling = null, l !== null && (c = t.deletions, c === null ? (t.deletions = [l], t.flags |= 16) : c.push(l)), t.child = e, t.memoizedState = null, e);
  }
  function zi(l, t) {
    return t = vn(
      { mode: "visible", children: t },
      l.mode
    ), t.return = l, l.child = t;
  }
  function vn(l, t) {
    return l = st(22, l, null, t), l.lanes = 0, l;
  }
  function Ai(l, t, e) {
    return Be(t, l.child, null, e), l = zi(
      t,
      t.pendingProps.children
    ), l.flags |= 2, t.memoizedState = null, l;
  }
  function $o(l, t, e) {
    l.lanes |= t;
    var a = l.alternate;
    a !== null && (a.lanes |= t), Yc(l.return, t, e);
  }
  function Ti(l, t, e, a, u, n) {
    var c = l.memoizedState;
    c === null ? l.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: e,
      tailMode: u,
      treeForkCount: n
    } : (c.isBackwards = t, c.rendering = null, c.renderingStartTime = 0, c.last = a, c.tail = e, c.tailMode = u, c.treeForkCount = n);
  }
  function ko(l, t, e) {
    var a = t.pendingProps, u = a.revealOrder, n = a.tail;
    a = a.children;
    var c = Ol.current, i = (c & 2) !== 0;
    if (i ? (c = c & 1 | 2, t.flags |= 128) : c &= 1, N(Ol, c), Kl(l, t, a, e), a = al ? Za : 0, !i && l !== null && (l.flags & 128) !== 0)
      l: for (l = t.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && $o(l, e, t);
        else if (l.tag === 19)
          $o(l, e, t);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === t) break l;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t)
            break l;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (u) {
      case "forwards":
        for (e = t.child, u = null; e !== null; )
          l = e.alternate, l !== null && en(l) === null && (u = e), e = e.sibling;
        e = u, e === null ? (u = t.child, t.child = null) : (u = e.sibling, e.sibling = null), Ti(
          t,
          !1,
          u,
          e,
          n,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (e = null, u = t.child, t.child = null; u !== null; ) {
          if (l = u.alternate, l !== null && en(l) === null) {
            t.child = u;
            break;
          }
          l = u.sibling, u.sibling = e, e = u, u = l;
        }
        Ti(
          t,
          !0,
          e,
          null,
          n,
          a
        );
        break;
      case "together":
        Ti(
          t,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Zt(l, t, e) {
    if (l !== null && (t.dependencies = l.dependencies), de |= t.lanes, (e & t.childLanes) === 0)
      if (l !== null) {
        if (ca(
          l,
          t,
          e,
          !1
        ), (e & t.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && t.child !== l.child)
      throw Error(r(153));
    if (t.child !== null) {
      for (l = t.child, e = qt(l, l.pendingProps), t.child = e, e.return = t; l.sibling !== null; )
        l = l.sibling, e = e.sibling = qt(l, l.pendingProps), e.return = t;
      e.sibling = null;
    }
    return t.child;
  }
  function _i(l, t) {
    return (l.lanes & t) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && $u(l)));
  }
  function dh(l, t, e) {
    switch (t.tag) {
      case 3:
        kl(t, t.stateNode.containerInfo), ue(t, Dl, l.memoizedState.cache), Ue();
        break;
      case 27:
      case 5:
        Ma(t);
        break;
      case 4:
        kl(t, t.stateNode.containerInfo);
        break;
      case 10:
        ue(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, Wc(t), null;
        break;
      case 13:
        var a = t.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (fe(t), t.flags |= 128, null) : (e & t.child.childLanes) !== 0 ? wo(l, t, e) : (fe(t), l = Zt(
            l,
            t,
            e
          ), l !== null ? l.sibling : null);
        fe(t);
        break;
      case 19:
        var u = (l.flags & 128) !== 0;
        if (a = (e & t.childLanes) !== 0, a || (ca(
          l,
          t,
          e,
          !1
        ), a = (e & t.childLanes) !== 0), u) {
          if (a)
            return ko(
              l,
              t,
              e
            );
          t.flags |= 128;
        }
        if (u = t.memoizedState, u !== null && (u.rendering = null, u.tail = null, u.lastEffect = null), N(Ol, Ol.current), a) break;
        return null;
      case 22:
        return t.lanes = 0, Qo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        ue(t, Dl, l.memoizedState.cache);
    }
    return Zt(l, t, e);
  }
  function Wo(l, t, e) {
    if (l !== null)
      if (l.memoizedProps !== t.pendingProps)
        jl = !0;
      else {
        if (!_i(l, e) && (t.flags & 128) === 0)
          return jl = !1, dh(
            l,
            t,
            e
          );
        jl = (l.flags & 131072) !== 0;
      }
    else
      jl = !1, al && (t.flags & 1048576) !== 0 && Ms(t, Za, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        l: {
          var a = t.pendingProps;
          if (l = Re(t.elementType), t.type = l, typeof l == "function")
            Dc(l) ? (a = Ge(l, a), t.tag = 1, t = Ko(
              null,
              t,
              l,
              a,
              e
            )) : (t.tag = 0, t = bi(
              null,
              t,
              l,
              a,
              e
            ));
          else {
            if (l != null) {
              var u = l.$$typeof;
              if (u === Xl) {
                t.tag = 11, t = Yo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              } else if (u === L) {
                t.tag = 14, t = Go(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              }
            }
            throw t = Bl(l) || l, Error(r(306, t, ""));
          }
        }
        return t;
      case 0:
        return bi(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 1:
        return a = t.type, u = Ge(
          a,
          t.pendingProps
        ), Ko(
          l,
          t,
          a,
          u,
          e
        );
      case 3:
        l: {
          if (kl(
            t,
            t.stateNode.containerInfo
          ), l === null) throw Error(r(387));
          a = t.pendingProps;
          var n = t.memoizedState;
          u = n.element, Kc(l, t), Wa(t, a, null, e);
          var c = t.memoizedState;
          if (a = c.cache, ue(t, Dl, a), a !== n.cache && Gc(
            t,
            [Dl],
            e,
            !0
          ), ka(), a = c.element, n.isDehydrated)
            if (n = {
              element: a,
              isDehydrated: !1,
              cache: c.cache
            }, t.updateQueue.baseState = n, t.memoizedState = n, t.flags & 256) {
              t = Jo(
                l,
                t,
                a,
                e
              );
              break l;
            } else if (a !== u) {
              u = St(
                Error(r(424)),
                t
              ), La(u), t = Jo(
                l,
                t,
                a,
                e
              );
              break l;
            } else
              for (l = t.stateNode.containerInfo, l.nodeType === 9 ? l = l.body : l = l.nodeName === "HTML" ? l.ownerDocument.body : l, pl = Tt(l.firstChild), Ll = t, al = !0, ee = null, zt = !0, e = Xs(
                t,
                null,
                a,
                e
              ), t.child = e; e; )
                e.flags = e.flags & -3 | 4096, e = e.sibling;
          else {
            if (Ue(), a === u) {
              t = Zt(
                l,
                t,
                e
              );
              break l;
            }
            Kl(l, t, a, e);
          }
          t = t.child;
        }
        return t;
      case 26:
        return hn(l, t), l === null ? (e = id(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = e : al || (e = t.type, l = t.pendingProps, a = Un(
          F.current
        ).createElement(e), a[Zl] = t, a[Il] = l, Jl(a, e, l), Yl(a), t.stateNode = a) : t.memoizedState = id(
          t.type,
          l.memoizedProps,
          t.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return Ma(t), l === null && al && (a = t.stateNode = ud(
          t.type,
          t.pendingProps,
          F.current
        ), Ll = t, zt = !0, u = pl, ge(t.type) ? (uf = u, pl = Tt(a.firstChild)) : pl = u), Kl(
          l,
          t,
          t.pendingProps.children,
          e
        ), hn(l, t), l === null && (t.flags |= 4194304), t.child;
      case 5:
        return l === null && al && ((u = a = pl) && (a = Zh(
          a,
          t.type,
          t.pendingProps,
          zt
        ), a !== null ? (t.stateNode = a, Ll = t, pl = Tt(a.firstChild), zt = !1, u = !0) : u = !1), u || ae(t)), Ma(t), u = t.type, n = t.pendingProps, c = l !== null ? l.memoizedProps : null, a = n.children, Pi(u, n) ? a = null : c !== null && Pi(u, c) && (t.flags |= 32), t.memoizedState !== null && (u = Ic(
          l,
          t,
          ah,
          null,
          null,
          e
        ), yu._currentValue = u), hn(l, t), Kl(l, t, a, e), t.child;
      case 6:
        return l === null && al && ((l = e = pl) && (e = Lh(
          e,
          t.pendingProps,
          zt
        ), e !== null ? (t.stateNode = e, Ll = t, pl = null, l = !0) : l = !1), l || ae(t)), null;
      case 13:
        return wo(l, t, e);
      case 4:
        return kl(
          t,
          t.stateNode.containerInfo
        ), a = t.pendingProps, l === null ? t.child = Be(
          t,
          null,
          a,
          e
        ) : Kl(l, t, a, e), t.child;
      case 11:
        return Yo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 7:
        return Kl(
          l,
          t,
          t.pendingProps,
          e
        ), t.child;
      case 8:
        return Kl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 12:
        return Kl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 10:
        return a = t.pendingProps, ue(t, t.type, a.value), Kl(l, t, a.children, e), t.child;
      case 9:
        return u = t.type._context, a = t.pendingProps.children, Ce(t), u = Vl(u), a = a(u), t.flags |= 1, Kl(l, t, a, e), t.child;
      case 14:
        return Go(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 15:
        return Xo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 19:
        return ko(l, t, e);
      case 31:
        return rh(l, t, e);
      case 22:
        return Qo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        return Ce(t), a = Vl(Dl), l === null ? (u = Zc(), u === null && (u = Sl, n = Xc(), u.pooledCache = n, n.refCount++, n !== null && (u.pooledCacheLanes |= e), u = n), t.memoizedState = { parent: a, cache: u }, Vc(t), ue(t, Dl, u)) : ((l.lanes & e) !== 0 && (Kc(l, t), Wa(t, null, null, e), ka()), u = l.memoizedState, n = t.memoizedState, u.parent !== a ? (u = { parent: a, cache: a }, t.memoizedState = u, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = u), ue(t, Dl, a)) : (a = n.cache, ue(t, Dl, a), a !== u.cache && Gc(
          t,
          [Dl],
          e,
          !0
        ))), Kl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(r(156, t.tag));
  }
  function Lt(l) {
    l.flags |= 4;
  }
  function xi(l, t, e, a, u) {
    if ((t = (l.mode & 32) !== 0) && (t = !1), t) {
      if (l.flags |= 16777216, (u & 335544128) === u)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (Ar()) l.flags |= 8192;
        else
          throw qe = Iu, Lc;
    } else l.flags &= -16777217;
  }
  function Fo(l, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !dd(t))
      if (Ar()) l.flags |= 8192;
      else
        throw qe = Iu, Lc;
  }
  function yn(l, t) {
    t !== null && (l.flags |= 4), l.flags & 16384 && (t = l.tag !== 22 ? Nf() : 536870912, l.lanes |= t, ba |= t);
  }
  function eu(l, t) {
    if (!al)
      switch (l.tailMode) {
        case "hidden":
          t = l.tail;
          for (var e = null; t !== null; )
            t.alternate !== null && (e = t), t = t.sibling;
          e === null ? l.tail = null : e.sibling = null;
          break;
        case "collapsed":
          e = l.tail;
          for (var a = null; e !== null; )
            e.alternate !== null && (a = e), e = e.sibling;
          a === null ? t || l.tail === null ? l.tail = null : l.tail.sibling = null : a.sibling = null;
      }
  }
  function El(l) {
    var t = l.alternate !== null && l.alternate.child === l.child, e = 0, a = 0;
    if (t)
      for (var u = l.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags & 65011712, a |= u.flags & 65011712, u.return = l, u = u.sibling;
    else
      for (u = l.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags, a |= u.flags, u.return = l, u = u.sibling;
    return l.subtreeFlags |= a, l.childLanes = e, t;
  }
  function mh(l, t, e) {
    var a = t.pendingProps;
    switch (Hc(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return El(t), null;
      case 1:
        return El(t), null;
      case 3:
        return e = t.stateNode, a = null, l !== null && (a = l.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), Gt(Dl), Ml(), e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null), (l === null || l.child === null) && (na(t) ? Lt(t) : l === null || l.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, qc())), El(t), null;
      case 26:
        var u = t.type, n = t.memoizedState;
        return l === null ? (Lt(t), n !== null ? (El(t), Fo(t, n)) : (El(t), xi(
          t,
          u,
          null,
          a,
          e
        ))) : n ? n !== l.memoizedState ? (Lt(t), El(t), Fo(t, n)) : (El(t), t.flags &= -16777217) : (l = l.memoizedProps, l !== a && Lt(t), El(t), xi(
          t,
          u,
          l,
          a,
          e
        )), null;
      case 27:
        if (xu(t), e = F.current, u = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Lt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(r(166));
            return El(t), null;
          }
          l = j.current, na(t) ? Ns(t) : (l = ud(u, a, e), t.stateNode = l, Lt(t));
        }
        return El(t), null;
      case 5:
        if (xu(t), u = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Lt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(r(166));
            return El(t), null;
          }
          if (n = j.current, na(t))
            Ns(t);
          else {
            var c = Un(
              F.current
            );
            switch (n) {
              case 1:
                n = c.createElementNS(
                  "http://www.w3.org/2000/svg",
                  u
                );
                break;
              case 2:
                n = c.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  u
                );
                break;
              default:
                switch (u) {
                  case "svg":
                    n = c.createElementNS(
                      "http://www.w3.org/2000/svg",
                      u
                    );
                    break;
                  case "math":
                    n = c.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      u
                    );
                    break;
                  case "script":
                    n = c.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(
                      n.firstChild
                    );
                    break;
                  case "select":
                    n = typeof a.is == "string" ? c.createElement("select", {
                      is: a.is
                    }) : c.createElement("select"), a.multiple ? n.multiple = !0 : a.size && (n.size = a.size);
                    break;
                  default:
                    n = typeof a.is == "string" ? c.createElement(u, { is: a.is }) : c.createElement(u);
                }
            }
            n[Zl] = t, n[Il] = a;
            l: for (c = t.child; c !== null; ) {
              if (c.tag === 5 || c.tag === 6)
                n.appendChild(c.stateNode);
              else if (c.tag !== 4 && c.tag !== 27 && c.child !== null) {
                c.child.return = c, c = c.child;
                continue;
              }
              if (c === t) break l;
              for (; c.sibling === null; ) {
                if (c.return === null || c.return === t)
                  break l;
                c = c.return;
              }
              c.sibling.return = c.return, c = c.sibling;
            }
            t.stateNode = n;
            l: switch (Jl(n, u, a), u) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break l;
              case "img":
                a = !0;
                break l;
              default:
                a = !1;
            }
            a && Lt(t);
          }
        }
        return El(t), xi(
          t,
          t.type,
          l === null ? null : l.memoizedProps,
          t.pendingProps,
          e
        ), null;
      case 6:
        if (l && t.stateNode != null)
          l.memoizedProps !== a && Lt(t);
        else {
          if (typeof a != "string" && t.stateNode === null)
            throw Error(r(166));
          if (l = F.current, na(t)) {
            if (l = t.stateNode, e = t.memoizedProps, a = null, u = Ll, u !== null)
              switch (u.tag) {
                case 27:
                case 5:
                  a = u.memoizedProps;
              }
            l[Zl] = t, l = !!(l.nodeValue === e || a !== null && a.suppressHydrationWarning === !0 || wr(l.nodeValue, e)), l || ae(t, !0);
          } else
            l = Un(l).createTextNode(
              a
            ), l[Zl] = t, t.stateNode = l;
        }
        return El(t), null;
      case 31:
        if (e = t.memoizedState, l === null || l.memoizedState !== null) {
          if (a = na(t), e !== null) {
            if (l === null) {
              if (!a) throw Error(r(318));
              if (l = t.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(557));
              l[Zl] = t;
            } else
              Ue(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            El(t), l = !1;
          } else
            e = qc(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = e), l = !0;
          if (!l)
            return t.flags & 256 ? (rt(t), t) : (rt(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(r(558));
        }
        return El(t), null;
      case 13:
        if (a = t.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (u = na(t), a !== null && a.dehydrated !== null) {
            if (l === null) {
              if (!u) throw Error(r(318));
              if (u = t.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(r(317));
              u[Zl] = t;
            } else
              Ue(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            El(t), u = !1;
          } else
            u = qc(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = u), u = !0;
          if (!u)
            return t.flags & 256 ? (rt(t), t) : (rt(t), null);
        }
        return rt(t), (t.flags & 128) !== 0 ? (t.lanes = e, t) : (e = a !== null, l = l !== null && l.memoizedState !== null, e && (a = t.child, u = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (u = a.alternate.memoizedState.cachePool.pool), n = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (n = a.memoizedState.cachePool.pool), n !== u && (a.flags |= 2048)), e !== l && e && (t.child.flags |= 8192), yn(t, t.updateQueue), El(t), null);
      case 4:
        return Ml(), l === null && $i(t.stateNode.containerInfo), El(t), null;
      case 10:
        return Gt(t.type), El(t), null;
      case 19:
        if (T(Ol), a = t.memoizedState, a === null) return El(t), null;
        if (u = (t.flags & 128) !== 0, n = a.rendering, n === null)
          if (u) eu(a, !1);
          else {
            if (xl !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = t.child; l !== null; ) {
                if (n = en(l), n !== null) {
                  for (t.flags |= 128, eu(a, !1), l = n.updateQueue, t.updateQueue = l, yn(t, l), t.subtreeFlags = 0, l = e, e = t.child; e !== null; )
                    Ts(e, l), e = e.sibling;
                  return N(
                    Ol,
                    Ol.current & 1 | 2
                  ), al && Bt(t, a.treeForkCount), t.child;
                }
                l = l.sibling;
              }
            a.tail !== null && nt() > En && (t.flags |= 128, u = !0, eu(a, !1), t.lanes = 4194304);
          }
        else {
          if (!u)
            if (l = en(n), l !== null) {
              if (t.flags |= 128, u = !0, l = l.updateQueue, t.updateQueue = l, yn(t, l), eu(a, !0), a.tail === null && a.tailMode === "hidden" && !n.alternate && !al)
                return El(t), null;
            } else
              2 * nt() - a.renderingStartTime > En && e !== 536870912 && (t.flags |= 128, u = !0, eu(a, !1), t.lanes = 4194304);
          a.isBackwards ? (n.sibling = t.child, t.child = n) : (l = a.last, l !== null ? l.sibling = n : t.child = n, a.last = n);
        }
        return a.tail !== null ? (l = a.tail, a.rendering = l, a.tail = l.sibling, a.renderingStartTime = nt(), l.sibling = null, e = Ol.current, N(
          Ol,
          u ? e & 1 | 2 : e & 1
        ), al && Bt(t, a.treeForkCount), l) : (El(t), null);
      case 22:
      case 23:
        return rt(t), kc(), a = t.memoizedState !== null, l !== null ? l.memoizedState !== null !== a && (t.flags |= 8192) : a && (t.flags |= 8192), a ? (e & 536870912) !== 0 && (t.flags & 128) === 0 && (El(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : El(t), e = t.updateQueue, e !== null && yn(t, e.retryQueue), e = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), a = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), a !== e && (t.flags |= 2048), l !== null && T(He), null;
      case 24:
        return e = null, l !== null && (e = l.memoizedState.cache), t.memoizedState.cache !== e && (t.flags |= 2048), Gt(Dl), El(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, t.tag));
  }
  function hh(l, t) {
    switch (Hc(t), t.tag) {
      case 1:
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 3:
        return Gt(Dl), Ml(), l = t.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (t.flags = l & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return xu(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (rt(t), t.alternate === null)
            throw Error(r(340));
          Ue();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 13:
        if (rt(t), l = t.memoizedState, l !== null && l.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(r(340));
          Ue();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 19:
        return T(Ol), null;
      case 4:
        return Ml(), null;
      case 10:
        return Gt(t.type), null;
      case 22:
      case 23:
        return rt(t), kc(), l !== null && T(He), l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 24:
        return Gt(Dl), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Io(l, t) {
    switch (Hc(t), t.tag) {
      case 3:
        Gt(Dl), Ml();
        break;
      case 26:
      case 27:
      case 5:
        xu(t);
        break;
      case 4:
        Ml();
        break;
      case 31:
        t.memoizedState !== null && rt(t);
        break;
      case 13:
        rt(t);
        break;
      case 19:
        T(Ol);
        break;
      case 10:
        Gt(t.type);
        break;
      case 22:
      case 23:
        rt(t), kc(), l !== null && T(He);
        break;
      case 24:
        Gt(Dl);
    }
  }
  function au(l, t) {
    try {
      var e = t.updateQueue, a = e !== null ? e.lastEffect : null;
      if (a !== null) {
        var u = a.next;
        e = u;
        do {
          if ((e.tag & l) === l) {
            a = void 0;
            var n = e.create, c = e.inst;
            a = n(), c.destroy = a;
          }
          e = e.next;
        } while (e !== u);
      }
    } catch (i) {
      dl(t, t.return, i);
    }
  }
  function oe(l, t, e) {
    try {
      var a = t.updateQueue, u = a !== null ? a.lastEffect : null;
      if (u !== null) {
        var n = u.next;
        a = n;
        do {
          if ((a.tag & l) === l) {
            var c = a.inst, i = c.destroy;
            if (i !== void 0) {
              c.destroy = void 0, u = t;
              var f = e, v = i;
              try {
                v();
              } catch (p) {
                dl(
                  u,
                  f,
                  p
                );
              }
            }
          }
          a = a.next;
        } while (a !== n);
      }
    } catch (p) {
      dl(t, t.return, p);
    }
  }
  function Po(l) {
    var t = l.updateQueue;
    if (t !== null) {
      var e = l.stateNode;
      try {
        Zs(t, e);
      } catch (a) {
        dl(l, l.return, a);
      }
    }
  }
  function lr(l, t, e) {
    e.props = Ge(
      l.type,
      l.memoizedProps
    ), e.state = l.memoizedState;
    try {
      e.componentWillUnmount();
    } catch (a) {
      dl(l, t, a);
    }
  }
  function uu(l, t) {
    try {
      var e = l.ref;
      if (e !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var a = l.stateNode;
            break;
          case 30:
            a = l.stateNode;
            break;
          default:
            a = l.stateNode;
        }
        typeof e == "function" ? l.refCleanup = e(a) : e.current = a;
      }
    } catch (u) {
      dl(l, t, u);
    }
  }
  function Ut(l, t) {
    var e = l.ref, a = l.refCleanup;
    if (e !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (u) {
          dl(l, t, u);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof e == "function")
        try {
          e(null);
        } catch (u) {
          dl(l, t, u);
        }
      else e.current = null;
  }
  function tr(l) {
    var t = l.type, e = l.memoizedProps, a = l.stateNode;
    try {
      l: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          e.autoFocus && a.focus();
          break l;
        case "img":
          e.src ? a.src = e.src : e.srcSet && (a.srcset = e.srcSet);
      }
    } catch (u) {
      dl(l, l.return, u);
    }
  }
  function Mi(l, t, e) {
    try {
      var a = l.stateNode;
      qh(a, l.type, e, t), a[Il] = t;
    } catch (u) {
      dl(l, l.return, u);
    }
  }
  function er(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && ge(l.type) || l.tag === 4;
  }
  function Oi(l) {
    l: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || er(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && ge(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue l;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function Ni(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).insertBefore(l, t) : (t = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, t.appendChild(l), e = e._reactRootContainer, e != null || t.onclick !== null || (t.onclick = Ht));
    else if (a !== 4 && (a === 27 && ge(l.type) && (e = l.stateNode, t = null), l = l.child, l !== null))
      for (Ni(l, t, e), l = l.sibling; l !== null; )
        Ni(l, t, e), l = l.sibling;
  }
  function gn(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? e.insertBefore(l, t) : e.appendChild(l);
    else if (a !== 4 && (a === 27 && ge(l.type) && (e = l.stateNode), l = l.child, l !== null))
      for (gn(l, t, e), l = l.sibling; l !== null; )
        gn(l, t, e), l = l.sibling;
  }
  function ar(l) {
    var t = l.stateNode, e = l.memoizedProps;
    try {
      for (var a = l.type, u = t.attributes; u.length; )
        t.removeAttributeNode(u[0]);
      Jl(t, a, e), t[Zl] = l, t[Il] = e;
    } catch (n) {
      dl(l, l.return, n);
    }
  }
  var Vt = !1, Cl = !1, Di = !1, ur = typeof WeakSet == "function" ? WeakSet : Set, Gl = null;
  function vh(l, t) {
    if (l = l.containerInfo, Fi = Yn, l = vs(l), Ac(l)) {
      if ("selectionStart" in l)
        var e = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        l: {
          e = (e = l.ownerDocument) && e.defaultView || window;
          var a = e.getSelection && e.getSelection();
          if (a && a.rangeCount !== 0) {
            e = a.anchorNode;
            var u = a.anchorOffset, n = a.focusNode;
            a = a.focusOffset;
            try {
              e.nodeType, n.nodeType;
            } catch {
              e = null;
              break l;
            }
            var c = 0, i = -1, f = -1, v = 0, p = 0, A = l, y = null;
            t: for (; ; ) {
              for (var g; A !== e || u !== 0 && A.nodeType !== 3 || (i = c + u), A !== n || a !== 0 && A.nodeType !== 3 || (f = c + a), A.nodeType === 3 && (c += A.nodeValue.length), (g = A.firstChild) !== null; )
                y = A, A = g;
              for (; ; ) {
                if (A === l) break t;
                if (y === e && ++v === u && (i = c), y === n && ++p === a && (f = c), (g = A.nextSibling) !== null) break;
                A = y, y = A.parentNode;
              }
              A = g;
            }
            e = i === -1 || f === -1 ? null : { start: i, end: f };
          } else e = null;
        }
      e = e || { start: 0, end: 0 };
    } else e = null;
    for (Ii = { focusedElem: l, selectionRange: e }, Yn = !1, Gl = t; Gl !== null; )
      if (t = Gl, l = t.child, (t.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = t, Gl = l;
      else
        for (; Gl !== null; ) {
          switch (t = Gl, n = t.alternate, l = t.flags, t.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = t.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (e = 0; e < l.length; e++)
                  u = l[e], u.ref.impl = u.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && n !== null) {
                l = void 0, e = t, u = n.memoizedProps, n = n.memoizedState, a = e.stateNode;
                try {
                  var U = Ge(
                    e.type,
                    u
                  );
                  l = a.getSnapshotBeforeUpdate(
                    U,
                    n
                  ), a.__reactInternalSnapshotBeforeUpdate = l;
                } catch (Y) {
                  dl(
                    e,
                    e.return,
                    Y
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = t.stateNode.containerInfo, e = l.nodeType, e === 9)
                  tf(l);
                else if (e === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      tf(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(r(163));
          }
          if (l = t.sibling, l !== null) {
            l.return = t.return, Gl = l;
            break;
          }
          Gl = t.return;
        }
  }
  function nr(l, t, e) {
    var a = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Jt(l, e), a & 4 && au(5, e);
        break;
      case 1:
        if (Jt(l, e), a & 4)
          if (l = e.stateNode, t === null)
            try {
              l.componentDidMount();
            } catch (c) {
              dl(e, e.return, c);
            }
          else {
            var u = Ge(
              e.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              l.componentDidUpdate(
                u,
                t,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (c) {
              dl(
                e,
                e.return,
                c
              );
            }
          }
        a & 64 && Po(e), a & 512 && uu(e, e.return);
        break;
      case 3:
        if (Jt(l, e), a & 64 && (l = e.updateQueue, l !== null)) {
          if (t = null, e.child !== null)
            switch (e.child.tag) {
              case 27:
              case 5:
                t = e.child.stateNode;
                break;
              case 1:
                t = e.child.stateNode;
            }
          try {
            Zs(l, t);
          } catch (c) {
            dl(e, e.return, c);
          }
        }
        break;
      case 27:
        t === null && a & 4 && ar(e);
      case 26:
      case 5:
        Jt(l, e), t === null && a & 4 && tr(e), a & 512 && uu(e, e.return);
        break;
      case 12:
        Jt(l, e);
        break;
      case 31:
        Jt(l, e), a & 4 && fr(l, e);
        break;
      case 13:
        Jt(l, e), a & 4 && sr(l, e), a & 64 && (l = e.memoizedState, l !== null && (l = l.dehydrated, l !== null && (e = Th.bind(
          null,
          e
        ), Vh(l, e))));
        break;
      case 22:
        if (a = e.memoizedState !== null || Vt, !a) {
          t = t !== null && t.memoizedState !== null || Cl, u = Vt;
          var n = Cl;
          Vt = a, (Cl = t) && !n ? wt(
            l,
            e,
            (e.subtreeFlags & 8772) !== 0
          ) : Jt(l, e), Vt = u, Cl = n;
        }
        break;
      case 30:
        break;
      default:
        Jt(l, e);
    }
  }
  function cr(l) {
    var t = l.alternate;
    t !== null && (l.alternate = null, cr(t)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (t = l.stateNode, t !== null && cc(t)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var Al = null, lt = !1;
  function Kt(l, t, e) {
    for (e = e.child; e !== null; )
      ir(l, t, e), e = e.sibling;
  }
  function ir(l, t, e) {
    if (ct && typeof ct.onCommitFiberUnmount == "function")
      try {
        ct.onCommitFiberUnmount(Oa, e);
      } catch {
      }
    switch (e.tag) {
      case 26:
        Cl || Ut(e, t), Kt(
          l,
          t,
          e
        ), e.memoizedState ? e.memoizedState.count-- : e.stateNode && (e = e.stateNode, e.parentNode.removeChild(e));
        break;
      case 27:
        Cl || Ut(e, t);
        var a = Al, u = lt;
        ge(e.type) && (Al = e.stateNode, lt = !1), Kt(
          l,
          t,
          e
        ), mu(e.stateNode), Al = a, lt = u;
        break;
      case 5:
        Cl || Ut(e, t);
      case 6:
        if (a = Al, u = lt, Al = null, Kt(
          l,
          t,
          e
        ), Al = a, lt = u, Al !== null)
          if (lt)
            try {
              (Al.nodeType === 9 ? Al.body : Al.nodeName === "HTML" ? Al.ownerDocument.body : Al).removeChild(e.stateNode);
            } catch (n) {
              dl(
                e,
                t,
                n
              );
            }
          else
            try {
              Al.removeChild(e.stateNode);
            } catch (n) {
              dl(
                e,
                t,
                n
              );
            }
        break;
      case 18:
        Al !== null && (lt ? (l = Al, Pr(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          e.stateNode
        ), xa(l)) : Pr(Al, e.stateNode));
        break;
      case 4:
        a = Al, u = lt, Al = e.stateNode.containerInfo, lt = !0, Kt(
          l,
          t,
          e
        ), Al = a, lt = u;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        oe(2, e, t), Cl || oe(4, e, t), Kt(
          l,
          t,
          e
        );
        break;
      case 1:
        Cl || (Ut(e, t), a = e.stateNode, typeof a.componentWillUnmount == "function" && lr(
          e,
          t,
          a
        )), Kt(
          l,
          t,
          e
        );
        break;
      case 21:
        Kt(
          l,
          t,
          e
        );
        break;
      case 22:
        Cl = (a = Cl) || e.memoizedState !== null, Kt(
          l,
          t,
          e
        ), Cl = a;
        break;
      default:
        Kt(
          l,
          t,
          e
        );
    }
  }
  function fr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        xa(l);
      } catch (e) {
        dl(t, t.return, e);
      }
    }
  }
  function sr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        xa(l);
      } catch (e) {
        dl(t, t.return, e);
      }
  }
  function yh(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var t = l.stateNode;
        return t === null && (t = l.stateNode = new ur()), t;
      case 22:
        return l = l.stateNode, t = l._retryCache, t === null && (t = l._retryCache = new ur()), t;
      default:
        throw Error(r(435, l.tag));
    }
  }
  function bn(l, t) {
    var e = yh(l);
    t.forEach(function(a) {
      if (!e.has(a)) {
        e.add(a);
        var u = _h.bind(null, l, a);
        a.then(u, u);
      }
    });
  }
  function tt(l, t) {
    var e = t.deletions;
    if (e !== null)
      for (var a = 0; a < e.length; a++) {
        var u = e[a], n = l, c = t, i = c;
        l: for (; i !== null; ) {
          switch (i.tag) {
            case 27:
              if (ge(i.type)) {
                Al = i.stateNode, lt = !1;
                break l;
              }
              break;
            case 5:
              Al = i.stateNode, lt = !1;
              break l;
            case 3:
            case 4:
              Al = i.stateNode.containerInfo, lt = !0;
              break l;
          }
          i = i.return;
        }
        if (Al === null) throw Error(r(160));
        ir(n, c, u), Al = null, lt = !1, n = u.alternate, n !== null && (n.return = null), u.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        or(t, l), t = t.sibling;
  }
  var Mt = null;
  function or(l, t) {
    var e = l.alternate, a = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        tt(t, l), et(l), a & 4 && (oe(3, l, l.return), au(3, l), oe(5, l, l.return));
        break;
      case 1:
        tt(t, l), et(l), a & 512 && (Cl || e === null || Ut(e, e.return)), a & 64 && Vt && (l = l.updateQueue, l !== null && (a = l.callbacks, a !== null && (e = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = e === null ? a : e.concat(a))));
        break;
      case 26:
        var u = Mt;
        if (tt(t, l), et(l), a & 512 && (Cl || e === null || Ut(e, e.return)), a & 4) {
          var n = e !== null ? e.memoizedState : null;
          if (a = l.memoizedState, e === null)
            if (a === null)
              if (l.stateNode === null) {
                l: {
                  a = l.type, e = l.memoizedProps, u = u.ownerDocument || u;
                  t: switch (a) {
                    case "title":
                      n = u.getElementsByTagName("title")[0], (!n || n[Ua] || n[Zl] || n.namespaceURI === "http://www.w3.org/2000/svg" || n.hasAttribute("itemprop")) && (n = u.createElement(a), u.head.insertBefore(
                        n,
                        u.querySelector("head > title")
                      )), Jl(n, a, e), n[Zl] = l, Yl(n), a = n;
                      break l;
                    case "link":
                      var c = od(
                        "link",
                        "href",
                        u
                      ).get(a + (e.href || ""));
                      if (c) {
                        for (var i = 0; i < c.length; i++)
                          if (n = c[i], n.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && n.getAttribute("rel") === (e.rel == null ? null : e.rel) && n.getAttribute("title") === (e.title == null ? null : e.title) && n.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            c.splice(i, 1);
                            break t;
                          }
                      }
                      n = u.createElement(a), Jl(n, a, e), u.head.appendChild(n);
                      break;
                    case "meta":
                      if (c = od(
                        "meta",
                        "content",
                        u
                      ).get(a + (e.content || ""))) {
                        for (i = 0; i < c.length; i++)
                          if (n = c[i], n.getAttribute("content") === (e.content == null ? null : "" + e.content) && n.getAttribute("name") === (e.name == null ? null : e.name) && n.getAttribute("property") === (e.property == null ? null : e.property) && n.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && n.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            c.splice(i, 1);
                            break t;
                          }
                      }
                      n = u.createElement(a), Jl(n, a, e), u.head.appendChild(n);
                      break;
                    default:
                      throw Error(r(468, a));
                  }
                  n[Zl] = l, Yl(n), a = n;
                }
                l.stateNode = a;
              } else
                rd(
                  u,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = sd(
                u,
                a,
                l.memoizedProps
              );
          else
            n !== a ? (n === null ? e.stateNode !== null && (e = e.stateNode, e.parentNode.removeChild(e)) : n.count--, a === null ? rd(
              u,
              l.type,
              l.stateNode
            ) : sd(
              u,
              a,
              l.memoizedProps
            )) : a === null && l.stateNode !== null && Mi(
              l,
              l.memoizedProps,
              e.memoizedProps
            );
        }
        break;
      case 27:
        tt(t, l), et(l), a & 512 && (Cl || e === null || Ut(e, e.return)), e !== null && a & 4 && Mi(
          l,
          l.memoizedProps,
          e.memoizedProps
        );
        break;
      case 5:
        if (tt(t, l), et(l), a & 512 && (Cl || e === null || Ut(e, e.return)), l.flags & 32) {
          u = l.stateNode;
          try {
            ke(u, "");
          } catch (U) {
            dl(l, l.return, U);
          }
        }
        a & 4 && l.stateNode != null && (u = l.memoizedProps, Mi(
          l,
          u,
          e !== null ? e.memoizedProps : u
        )), a & 1024 && (Di = !0);
        break;
      case 6:
        if (tt(t, l), et(l), a & 4) {
          if (l.stateNode === null)
            throw Error(r(162));
          a = l.memoizedProps, e = l.stateNode;
          try {
            e.nodeValue = a;
          } catch (U) {
            dl(l, l.return, U);
          }
        }
        break;
      case 3:
        if (Hn = null, u = Mt, Mt = jn(t.containerInfo), tt(t, l), Mt = u, et(l), a & 4 && e !== null && e.memoizedState.isDehydrated)
          try {
            xa(t.containerInfo);
          } catch (U) {
            dl(l, l.return, U);
          }
        Di && (Di = !1, rr(l));
        break;
      case 4:
        a = Mt, Mt = jn(
          l.stateNode.containerInfo
        ), tt(t, l), et(l), Mt = a;
        break;
      case 12:
        tt(t, l), et(l);
        break;
      case 31:
        tt(t, l), et(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 13:
        tt(t, l), et(l), l.child.flags & 8192 && l.memoizedState !== null != (e !== null && e.memoizedState !== null) && (pn = nt()), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 22:
        u = l.memoizedState !== null;
        var f = e !== null && e.memoizedState !== null, v = Vt, p = Cl;
        if (Vt = v || u, Cl = p || f, tt(t, l), Cl = p, Vt = v, et(l), a & 8192)
          l: for (t = l.stateNode, t._visibility = u ? t._visibility & -2 : t._visibility | 1, u && (e === null || f || Vt || Cl || Xe(l)), e = null, t = l; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (e === null) {
                f = e = t;
                try {
                  if (n = f.stateNode, u)
                    c = n.style, typeof c.setProperty == "function" ? c.setProperty("display", "none", "important") : c.display = "none";
                  else {
                    i = f.stateNode;
                    var A = f.memoizedProps.style, y = A != null && A.hasOwnProperty("display") ? A.display : null;
                    i.style.display = y == null || typeof y == "boolean" ? "" : ("" + y).trim();
                  }
                } catch (U) {
                  dl(f, f.return, U);
                }
              }
            } else if (t.tag === 6) {
              if (e === null) {
                f = t;
                try {
                  f.stateNode.nodeValue = u ? "" : f.memoizedProps;
                } catch (U) {
                  dl(f, f.return, U);
                }
              }
            } else if (t.tag === 18) {
              if (e === null) {
                f = t;
                try {
                  var g = f.stateNode;
                  u ? ld(g, !0) : ld(f.stateNode, !1);
                } catch (U) {
                  dl(f, f.return, U);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === l) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === l) break l;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === l) break l;
              e === t && (e = null), t = t.return;
            }
            e === t && (e = null), t.sibling.return = t.return, t = t.sibling;
          }
        a & 4 && (a = l.updateQueue, a !== null && (e = a.retryQueue, e !== null && (a.retryQueue = null, bn(l, e))));
        break;
      case 19:
        tt(t, l), et(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        tt(t, l), et(l);
    }
  }
  function et(l) {
    var t = l.flags;
    if (t & 2) {
      try {
        for (var e, a = l.return; a !== null; ) {
          if (er(a)) {
            e = a;
            break;
          }
          a = a.return;
        }
        if (e == null) throw Error(r(160));
        switch (e.tag) {
          case 27:
            var u = e.stateNode, n = Oi(l);
            gn(l, n, u);
            break;
          case 5:
            var c = e.stateNode;
            e.flags & 32 && (ke(c, ""), e.flags &= -33);
            var i = Oi(l);
            gn(l, i, c);
            break;
          case 3:
          case 4:
            var f = e.stateNode.containerInfo, v = Oi(l);
            Ni(
              l,
              v,
              f
            );
            break;
          default:
            throw Error(r(161));
        }
      } catch (p) {
        dl(l, l.return, p);
      }
      l.flags &= -3;
    }
    t & 4096 && (l.flags &= -4097);
  }
  function rr(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var t = l;
        rr(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), l = l.sibling;
      }
  }
  function Jt(l, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        nr(l, t.alternate, t), t = t.sibling;
  }
  function Xe(l) {
    for (l = l.child; l !== null; ) {
      var t = l;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          oe(4, t, t.return), Xe(t);
          break;
        case 1:
          Ut(t, t.return);
          var e = t.stateNode;
          typeof e.componentWillUnmount == "function" && lr(
            t,
            t.return,
            e
          ), Xe(t);
          break;
        case 27:
          mu(t.stateNode);
        case 26:
        case 5:
          Ut(t, t.return), Xe(t);
          break;
        case 22:
          t.memoizedState === null && Xe(t);
          break;
        case 30:
          Xe(t);
          break;
        default:
          Xe(t);
      }
      l = l.sibling;
    }
  }
  function wt(l, t, e) {
    for (e = e && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var a = t.alternate, u = l, n = t, c = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          wt(
            u,
            n,
            e
          ), au(4, n);
          break;
        case 1:
          if (wt(
            u,
            n,
            e
          ), a = n, u = a.stateNode, typeof u.componentDidMount == "function")
            try {
              u.componentDidMount();
            } catch (v) {
              dl(a, a.return, v);
            }
          if (a = n, u = a.updateQueue, u !== null) {
            var i = a.stateNode;
            try {
              var f = u.shared.hiddenCallbacks;
              if (f !== null)
                for (u.shared.hiddenCallbacks = null, u = 0; u < f.length; u++)
                  Qs(f[u], i);
            } catch (v) {
              dl(a, a.return, v);
            }
          }
          e && c & 64 && Po(n), uu(n, n.return);
          break;
        case 27:
          ar(n);
        case 26:
        case 5:
          wt(
            u,
            n,
            e
          ), e && a === null && c & 4 && tr(n), uu(n, n.return);
          break;
        case 12:
          wt(
            u,
            n,
            e
          );
          break;
        case 31:
          wt(
            u,
            n,
            e
          ), e && c & 4 && fr(u, n);
          break;
        case 13:
          wt(
            u,
            n,
            e
          ), e && c & 4 && sr(u, n);
          break;
        case 22:
          n.memoizedState === null && wt(
            u,
            n,
            e
          ), uu(n, n.return);
          break;
        case 30:
          break;
        default:
          wt(
            u,
            n,
            e
          );
      }
      t = t.sibling;
    }
  }
  function Ui(l, t) {
    var e = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== e && (l != null && l.refCount++, e != null && Va(e));
  }
  function ji(l, t) {
    l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && Va(l));
  }
  function Ot(l, t, e, a) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        dr(
          l,
          t,
          e,
          a
        ), t = t.sibling;
  }
  function dr(l, t, e, a) {
    var u = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Ot(
          l,
          t,
          e,
          a
        ), u & 2048 && au(9, t);
        break;
      case 1:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 3:
        Ot(
          l,
          t,
          e,
          a
        ), u & 2048 && (l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && Va(l)));
        break;
      case 12:
        if (u & 2048) {
          Ot(
            l,
            t,
            e,
            a
          ), l = t.stateNode;
          try {
            var n = t.memoizedProps, c = n.id, i = n.onPostCommit;
            typeof i == "function" && i(
              c,
              t.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (f) {
            dl(t, t.return, f);
          }
        } else
          Ot(
            l,
            t,
            e,
            a
          );
        break;
      case 31:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 13:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 23:
        break;
      case 22:
        n = t.stateNode, c = t.alternate, t.memoizedState !== null ? n._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : nu(l, t) : n._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : (n._visibility |= 2, va(
          l,
          t,
          e,
          a,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), u & 2048 && Ui(c, t);
        break;
      case 24:
        Ot(
          l,
          t,
          e,
          a
        ), u & 2048 && ji(t.alternate, t);
        break;
      default:
        Ot(
          l,
          t,
          e,
          a
        );
    }
  }
  function va(l, t, e, a, u) {
    for (u = u && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var n = l, c = t, i = e, f = a, v = c.flags;
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
          va(
            n,
            c,
            i,
            f,
            u
          ), au(8, c);
          break;
        case 23:
          break;
        case 22:
          var p = c.stateNode;
          c.memoizedState !== null ? p._visibility & 2 ? va(
            n,
            c,
            i,
            f,
            u
          ) : nu(
            n,
            c
          ) : (p._visibility |= 2, va(
            n,
            c,
            i,
            f,
            u
          )), u && v & 2048 && Ui(
            c.alternate,
            c
          );
          break;
        case 24:
          va(
            n,
            c,
            i,
            f,
            u
          ), u && v & 2048 && ji(c.alternate, c);
          break;
        default:
          va(
            n,
            c,
            i,
            f,
            u
          );
      }
      t = t.sibling;
    }
  }
  function nu(l, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var e = l, a = t, u = a.flags;
        switch (a.tag) {
          case 22:
            nu(e, a), u & 2048 && Ui(
              a.alternate,
              a
            );
            break;
          case 24:
            nu(e, a), u & 2048 && ji(a.alternate, a);
            break;
          default:
            nu(e, a);
        }
        t = t.sibling;
      }
  }
  var cu = 8192;
  function ya(l, t, e) {
    if (l.subtreeFlags & cu)
      for (l = l.child; l !== null; )
        mr(
          l,
          t,
          e
        ), l = l.sibling;
  }
  function mr(l, t, e) {
    switch (l.tag) {
      case 26:
        ya(
          l,
          t,
          e
        ), l.flags & cu && l.memoizedState !== null && ev(
          e,
          Mt,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        ya(
          l,
          t,
          e
        );
        break;
      case 3:
      case 4:
        var a = Mt;
        Mt = jn(l.stateNode.containerInfo), ya(
          l,
          t,
          e
        ), Mt = a;
        break;
      case 22:
        l.memoizedState === null && (a = l.alternate, a !== null && a.memoizedState !== null ? (a = cu, cu = 16777216, ya(
          l,
          t,
          e
        ), cu = a) : ya(
          l,
          t,
          e
        ));
        break;
      default:
        ya(
          l,
          t,
          e
        );
    }
  }
  function hr(l) {
    var t = l.alternate;
    if (t !== null && (l = t.child, l !== null)) {
      t.child = null;
      do
        t = l.sibling, l.sibling = null, l = t;
      while (l !== null);
    }
  }
  function iu(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Gl = a, yr(
            a,
            l
          );
        }
      hr(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        vr(l), l = l.sibling;
  }
  function vr(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        iu(l), l.flags & 2048 && oe(9, l, l.return);
        break;
      case 3:
        iu(l);
        break;
      case 12:
        iu(l);
        break;
      case 22:
        var t = l.stateNode;
        l.memoizedState !== null && t._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (t._visibility &= -3, Sn(l)) : iu(l);
        break;
      default:
        iu(l);
    }
  }
  function Sn(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Gl = a, yr(
            a,
            l
          );
        }
      hr(l);
    }
    for (l = l.child; l !== null; ) {
      switch (t = l, t.tag) {
        case 0:
        case 11:
        case 15:
          oe(8, t, t.return), Sn(t);
          break;
        case 22:
          e = t.stateNode, e._visibility & 2 && (e._visibility &= -3, Sn(t));
          break;
        default:
          Sn(t);
      }
      l = l.sibling;
    }
  }
  function yr(l, t) {
    for (; Gl !== null; ) {
      var e = Gl;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          oe(8, e, t);
          break;
        case 23:
        case 22:
          if (e.memoizedState !== null && e.memoizedState.cachePool !== null) {
            var a = e.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          Va(e.memoizedState.cache);
      }
      if (a = e.child, a !== null) a.return = e, Gl = a;
      else
        l: for (e = l; Gl !== null; ) {
          a = Gl;
          var u = a.sibling, n = a.return;
          if (cr(a), a === e) {
            Gl = null;
            break l;
          }
          if (u !== null) {
            u.return = n, Gl = u;
            break l;
          }
          Gl = n;
        }
    }
  }
  var gh = {
    getCacheForType: function(l) {
      var t = Vl(Dl), e = t.data.get(l);
      return e === void 0 && (e = l(), t.data.set(l, e)), e;
    },
    cacheSignal: function() {
      return Vl(Dl).controller.signal;
    }
  }, bh = typeof WeakMap == "function" ? WeakMap : Map, il = 0, Sl = null, I = null, tl = 0, rl = 0, dt = null, re = !1, ga = !1, Ci = !1, $t = 0, xl = 0, de = 0, Qe = 0, Hi = 0, mt = 0, ba = 0, fu = null, at = null, Ri = !1, pn = 0, gr = 0, En = 1 / 0, zn = null, me = null, Hl = 0, he = null, Sa = null, kt = 0, qi = 0, Bi = null, br = null, su = 0, Yi = null;
  function ht() {
    return (il & 2) !== 0 && tl !== 0 ? tl & -tl : E.T !== null ? Vi() : Cf();
  }
  function Sr() {
    if (mt === 0)
      if ((tl & 536870912) === 0 || al) {
        var l = Nu;
        Nu <<= 1, (Nu & 3932160) === 0 && (Nu = 262144), mt = l;
      } else mt = 536870912;
    return l = ot.current, l !== null && (l.flags |= 32), mt;
  }
  function ut(l, t, e) {
    (l === Sl && (rl === 2 || rl === 9) || l.cancelPendingCommit !== null) && (pa(l, 0), ve(
      l,
      tl,
      mt,
      !1
    )), Da(l, e), ((il & 2) === 0 || l !== Sl) && (l === Sl && ((il & 2) === 0 && (Qe |= e), xl === 4 && ve(
      l,
      tl,
      mt,
      !1
    )), jt(l));
  }
  function pr(l, t, e) {
    if ((il & 6) !== 0) throw Error(r(327));
    var a = !e && (t & 127) === 0 && (t & l.expiredLanes) === 0 || Na(l, t), u = a ? Eh(l, t) : Xi(l, t, !0), n = a;
    do {
      if (u === 0) {
        ga && !a && ve(l, t, 0, !1);
        break;
      } else {
        if (e = l.current.alternate, n && !Sh(e)) {
          u = Xi(l, t, !1), n = !1;
          continue;
        }
        if (u === 2) {
          if (n = t, l.errorRecoveryDisabledLanes & n)
            var c = 0;
          else
            c = l.pendingLanes & -536870913, c = c !== 0 ? c : c & 536870912 ? 536870912 : 0;
          if (c !== 0) {
            t = c;
            l: {
              var i = l;
              u = fu;
              var f = i.current.memoizedState.isDehydrated;
              if (f && (pa(i, c).flags |= 256), c = Xi(
                i,
                c,
                !1
              ), c !== 2) {
                if (Ci && !f) {
                  i.errorRecoveryDisabledLanes |= n, Qe |= n, u = 4;
                  break l;
                }
                n = at, at = u, n !== null && (at === null ? at = n : at.push.apply(
                  at,
                  n
                ));
              }
              u = c;
            }
            if (n = !1, u !== 2) continue;
          }
        }
        if (u === 1) {
          pa(l, 0), ve(l, t, 0, !0);
          break;
        }
        l: {
          switch (a = l, n = u, n) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              ve(
                a,
                t,
                mt,
                !re
              );
              break l;
            case 2:
              at = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((t & 62914560) === t && (u = pn + 300 - nt(), 10 < u)) {
            if (ve(
              a,
              t,
              mt,
              !re
            ), Uu(a, 0, !0) !== 0) break l;
            kt = t, a.timeoutHandle = Fr(
              Er.bind(
                null,
                a,
                e,
                at,
                zn,
                Ri,
                t,
                mt,
                Qe,
                ba,
                re,
                n,
                "Throttled",
                -0,
                0
              ),
              u
            );
            break l;
          }
          Er(
            a,
            e,
            at,
            zn,
            Ri,
            t,
            mt,
            Qe,
            ba,
            re,
            n,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    jt(l);
  }
  function Er(l, t, e, a, u, n, c, i, f, v, p, A, y, g) {
    if (l.timeoutHandle = -1, A = t.subtreeFlags, A & 8192 || (A & 16785408) === 16785408) {
      A = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ht
      }, mr(
        t,
        n,
        A
      );
      var U = (n & 62914560) === n ? pn - nt() : (n & 4194048) === n ? gr - nt() : 0;
      if (U = av(
        A,
        U
      ), U !== null) {
        kt = n, l.cancelPendingCommit = U(
          Nr.bind(
            null,
            l,
            t,
            n,
            e,
            a,
            u,
            c,
            i,
            f,
            p,
            A,
            null,
            y,
            g
          )
        ), ve(l, n, c, !v);
        return;
      }
    }
    Nr(
      l,
      t,
      n,
      e,
      a,
      u,
      c,
      i,
      f
    );
  }
  function Sh(l) {
    for (var t = l; ; ) {
      var e = t.tag;
      if ((e === 0 || e === 11 || e === 15) && t.flags & 16384 && (e = t.updateQueue, e !== null && (e = e.stores, e !== null)))
        for (var a = 0; a < e.length; a++) {
          var u = e[a], n = u.getSnapshot;
          u = u.value;
          try {
            if (!ft(n(), u)) return !1;
          } catch {
            return !1;
          }
        }
      if (e = t.child, t.subtreeFlags & 16384 && e !== null)
        e.return = t, t = e;
      else {
        if (t === l) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function ve(l, t, e, a) {
    t &= ~Hi, t &= ~Qe, l.suspendedLanes |= t, l.pingedLanes &= ~t, a && (l.warmLanes |= t), a = l.expirationTimes;
    for (var u = t; 0 < u; ) {
      var n = 31 - it(u), c = 1 << n;
      a[n] = -1, u &= ~c;
    }
    e !== 0 && Df(l, e, t);
  }
  function An() {
    return (il & 6) === 0 ? (ou(0), !1) : !0;
  }
  function Gi() {
    if (I !== null) {
      if (rl === 0)
        var l = I.return;
      else
        l = I, Yt = je = null, ti(l), oa = null, Ja = 0, l = I;
      for (; l !== null; )
        Io(l.alternate, l), l = l.return;
      I = null;
    }
  }
  function pa(l, t) {
    var e = l.timeoutHandle;
    e !== -1 && (l.timeoutHandle = -1, Gh(e)), e = l.cancelPendingCommit, e !== null && (l.cancelPendingCommit = null, e()), kt = 0, Gi(), Sl = l, I = e = qt(l.current, null), tl = t, rl = 0, dt = null, re = !1, ga = Na(l, t), Ci = !1, ba = mt = Hi = Qe = de = xl = 0, at = fu = null, Ri = !1, (t & 8) !== 0 && (t |= t & 32);
    var a = l.entangledLanes;
    if (a !== 0)
      for (l = l.entanglements, a &= t; 0 < a; ) {
        var u = 31 - it(a), n = 1 << u;
        t |= l[u], a &= ~n;
      }
    return $t = t, Lu(), e;
  }
  function zr(l, t) {
    w = null, E.H = lu, t === sa || t === Fu ? (t = Bs(), rl = 3) : t === Lc ? (t = Bs(), rl = 4) : rl = t === gi ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, dt = t, I === null && (xl = 1, dn(
      l,
      St(t, l.current)
    ));
  }
  function Ar() {
    var l = ot.current;
    return l === null ? !0 : (tl & 4194048) === tl ? At === null : (tl & 62914560) === tl || (tl & 536870912) !== 0 ? l === At : !1;
  }
  function Tr() {
    var l = E.H;
    return E.H = lu, l === null ? lu : l;
  }
  function _r() {
    var l = E.A;
    return E.A = gh, l;
  }
  function Tn() {
    xl = 4, re || (tl & 4194048) !== tl && ot.current !== null || (ga = !0), (de & 134217727) === 0 && (Qe & 134217727) === 0 || Sl === null || ve(
      Sl,
      tl,
      mt,
      !1
    );
  }
  function Xi(l, t, e) {
    var a = il;
    il |= 2;
    var u = Tr(), n = _r();
    (Sl !== l || tl !== t) && (zn = null, pa(l, t)), t = !1;
    var c = xl;
    l: do
      try {
        if (rl !== 0 && I !== null) {
          var i = I, f = dt;
          switch (rl) {
            case 8:
              Gi(), c = 6;
              break l;
            case 3:
            case 2:
            case 9:
            case 6:
              ot.current === null && (t = !0);
              var v = rl;
              if (rl = 0, dt = null, Ea(l, i, f, v), e && ga) {
                c = 0;
                break l;
              }
              break;
            default:
              v = rl, rl = 0, dt = null, Ea(l, i, f, v);
          }
        }
        ph(), c = xl;
        break;
      } catch (p) {
        zr(l, p);
      }
    while (!0);
    return t && l.shellSuspendCounter++, Yt = je = null, il = a, E.H = u, E.A = n, I === null && (Sl = null, tl = 0, Lu()), c;
  }
  function ph() {
    for (; I !== null; ) xr(I);
  }
  function Eh(l, t) {
    var e = il;
    il |= 2;
    var a = Tr(), u = _r();
    Sl !== l || tl !== t ? (zn = null, En = nt() + 500, pa(l, t)) : ga = Na(
      l,
      t
    );
    l: do
      try {
        if (rl !== 0 && I !== null) {
          t = I;
          var n = dt;
          t: switch (rl) {
            case 1:
              rl = 0, dt = null, Ea(l, t, n, 1);
              break;
            case 2:
            case 9:
              if (Rs(n)) {
                rl = 0, dt = null, Mr(t);
                break;
              }
              t = function() {
                rl !== 2 && rl !== 9 || Sl !== l || (rl = 7), jt(l);
              }, n.then(t, t);
              break l;
            case 3:
              rl = 7;
              break l;
            case 4:
              rl = 5;
              break l;
            case 7:
              Rs(n) ? (rl = 0, dt = null, Mr(t)) : (rl = 0, dt = null, Ea(l, t, n, 7));
              break;
            case 5:
              var c = null;
              switch (I.tag) {
                case 26:
                  c = I.memoizedState;
                case 5:
                case 27:
                  var i = I;
                  if (c ? dd(c) : i.stateNode.complete) {
                    rl = 0, dt = null;
                    var f = i.sibling;
                    if (f !== null) I = f;
                    else {
                      var v = i.return;
                      v !== null ? (I = v, _n(v)) : I = null;
                    }
                    break t;
                  }
              }
              rl = 0, dt = null, Ea(l, t, n, 5);
              break;
            case 6:
              rl = 0, dt = null, Ea(l, t, n, 6);
              break;
            case 8:
              Gi(), xl = 6;
              break l;
            default:
              throw Error(r(462));
          }
        }
        zh();
        break;
      } catch (p) {
        zr(l, p);
      }
    while (!0);
    return Yt = je = null, E.H = a, E.A = u, il = e, I !== null ? 0 : (Sl = null, tl = 0, Lu(), xl);
  }
  function zh() {
    for (; I !== null && !Kd(); )
      xr(I);
  }
  function xr(l) {
    var t = Wo(l.alternate, l, $t);
    l.memoizedProps = l.pendingProps, t === null ? _n(l) : I = t;
  }
  function Mr(l) {
    var t = l, e = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Vo(
          e,
          t,
          t.pendingProps,
          t.type,
          void 0,
          tl
        );
        break;
      case 11:
        t = Vo(
          e,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          tl
        );
        break;
      case 5:
        ti(t);
      default:
        Io(e, t), t = I = Ts(t, $t), t = Wo(e, t, $t);
    }
    l.memoizedProps = l.pendingProps, t === null ? _n(l) : I = t;
  }
  function Ea(l, t, e, a) {
    Yt = je = null, ti(t), oa = null, Ja = 0;
    var u = t.return;
    try {
      if (oh(
        l,
        u,
        t,
        e,
        tl
      )) {
        xl = 1, dn(
          l,
          St(e, l.current)
        ), I = null;
        return;
      }
    } catch (n) {
      if (u !== null) throw I = u, n;
      xl = 1, dn(
        l,
        St(e, l.current)
      ), I = null;
      return;
    }
    t.flags & 32768 ? (al || a === 1 ? l = !0 : ga || (tl & 536870912) !== 0 ? l = !1 : (re = l = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = ot.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Or(t, l)) : _n(t);
  }
  function _n(l) {
    var t = l;
    do {
      if ((t.flags & 32768) !== 0) {
        Or(
          t,
          re
        );
        return;
      }
      l = t.return;
      var e = mh(
        t.alternate,
        t,
        $t
      );
      if (e !== null) {
        I = e;
        return;
      }
      if (t = t.sibling, t !== null) {
        I = t;
        return;
      }
      I = t = l;
    } while (t !== null);
    xl === 0 && (xl = 5);
  }
  function Or(l, t) {
    do {
      var e = hh(l.alternate, l);
      if (e !== null) {
        e.flags &= 32767, I = e;
        return;
      }
      if (e = l.return, e !== null && (e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null), !t && (l = l.sibling, l !== null)) {
        I = l;
        return;
      }
      I = l = e;
    } while (l !== null);
    xl = 6, I = null;
  }
  function Nr(l, t, e, a, u, n, c, i, f) {
    l.cancelPendingCommit = null;
    do
      xn();
    while (Hl !== 0);
    if ((il & 6) !== 0) throw Error(r(327));
    if (t !== null) {
      if (t === l.current) throw Error(r(177));
      if (n = t.lanes | t.childLanes, n |= Oc, tm(
        l,
        e,
        n,
        c,
        i,
        f
      ), l === Sl && (I = Sl = null, tl = 0), Sa = t, he = l, kt = e, qi = n, Bi = u, br = a, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, xh(Mu, function() {
        return Hr(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), a = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || a) {
        a = E.T, E.T = null, u = O.p, O.p = 2, c = il, il |= 4;
        try {
          vh(l, t, e);
        } finally {
          il = c, O.p = u, E.T = a;
        }
      }
      Hl = 1, Dr(), Ur(), jr();
    }
  }
  function Dr() {
    if (Hl === 1) {
      Hl = 0;
      var l = he, t = Sa, e = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || e) {
        e = E.T, E.T = null;
        var a = O.p;
        O.p = 2;
        var u = il;
        il |= 4;
        try {
          or(t, l);
          var n = Ii, c = vs(l.containerInfo), i = n.focusedElem, f = n.selectionRange;
          if (c !== i && i && i.ownerDocument && hs(
            i.ownerDocument.documentElement,
            i
          )) {
            if (f !== null && Ac(i)) {
              var v = f.start, p = f.end;
              if (p === void 0 && (p = v), "selectionStart" in i)
                i.selectionStart = v, i.selectionEnd = Math.min(
                  p,
                  i.value.length
                );
              else {
                var A = i.ownerDocument || document, y = A && A.defaultView || window;
                if (y.getSelection) {
                  var g = y.getSelection(), U = i.textContent.length, Y = Math.min(f.start, U), gl = f.end === void 0 ? Y : Math.min(f.end, U);
                  !g.extend && Y > gl && (c = gl, gl = Y, Y = c);
                  var m = ms(
                    i,
                    Y
                  ), s = ms(
                    i,
                    gl
                  );
                  if (m && s && (g.rangeCount !== 1 || g.anchorNode !== m.node || g.anchorOffset !== m.offset || g.focusNode !== s.node || g.focusOffset !== s.offset)) {
                    var h = A.createRange();
                    h.setStart(m.node, m.offset), g.removeAllRanges(), Y > gl ? (g.addRange(h), g.extend(s.node, s.offset)) : (h.setEnd(s.node, s.offset), g.addRange(h));
                  }
                }
              }
            }
            for (A = [], g = i; g = g.parentNode; )
              g.nodeType === 1 && A.push({
                element: g,
                left: g.scrollLeft,
                top: g.scrollTop
              });
            for (typeof i.focus == "function" && i.focus(), i = 0; i < A.length; i++) {
              var z = A[i];
              z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
            }
          }
          Yn = !!Fi, Ii = Fi = null;
        } finally {
          il = u, O.p = a, E.T = e;
        }
      }
      l.current = t, Hl = 2;
    }
  }
  function Ur() {
    if (Hl === 2) {
      Hl = 0;
      var l = he, t = Sa, e = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || e) {
        e = E.T, E.T = null;
        var a = O.p;
        O.p = 2;
        var u = il;
        il |= 4;
        try {
          nr(l, t.alternate, t);
        } finally {
          il = u, O.p = a, E.T = e;
        }
      }
      Hl = 3;
    }
  }
  function jr() {
    if (Hl === 4 || Hl === 3) {
      Hl = 0, Jd();
      var l = he, t = Sa, e = kt, a = br;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Hl = 5 : (Hl = 0, Sa = he = null, Cr(l, l.pendingLanes));
      var u = l.pendingLanes;
      if (u === 0 && (me = null), uc(e), t = t.stateNode, ct && typeof ct.onCommitFiberRoot == "function")
        try {
          ct.onCommitFiberRoot(
            Oa,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        t = E.T, u = O.p, O.p = 2, E.T = null;
        try {
          for (var n = l.onRecoverableError, c = 0; c < a.length; c++) {
            var i = a[c];
            n(i.value, {
              componentStack: i.stack
            });
          }
        } finally {
          E.T = t, O.p = u;
        }
      }
      (kt & 3) !== 0 && xn(), jt(l), u = l.pendingLanes, (e & 261930) !== 0 && (u & 42) !== 0 ? l === Yi ? su++ : (su = 0, Yi = l) : su = 0, ou(0);
    }
  }
  function Cr(l, t) {
    (l.pooledCacheLanes &= t) === 0 && (t = l.pooledCache, t != null && (l.pooledCache = null, Va(t)));
  }
  function xn() {
    return Dr(), Ur(), jr(), Hr();
  }
  function Hr() {
    if (Hl !== 5) return !1;
    var l = he, t = qi;
    qi = 0;
    var e = uc(kt), a = E.T, u = O.p;
    try {
      O.p = 32 > e ? 32 : e, E.T = null, e = Bi, Bi = null;
      var n = he, c = kt;
      if (Hl = 0, Sa = he = null, kt = 0, (il & 6) !== 0) throw Error(r(331));
      var i = il;
      if (il |= 4, vr(n.current), dr(
        n,
        n.current,
        c,
        e
      ), il = i, ou(0, !1), ct && typeof ct.onPostCommitFiberRoot == "function")
        try {
          ct.onPostCommitFiberRoot(Oa, n);
        } catch {
        }
      return !0;
    } finally {
      O.p = u, E.T = a, Cr(l, t);
    }
  }
  function Rr(l, t, e) {
    t = St(e, t), t = yi(l.stateNode, t, 2), l = ie(l, t, 2), l !== null && (Da(l, 2), jt(l));
  }
  function dl(l, t, e) {
    if (l.tag === 3)
      Rr(l, l, e);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          Rr(
            t,
            l,
            e
          );
          break;
        } else if (t.tag === 1) {
          var a = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (me === null || !me.has(a))) {
            l = St(e, l), e = qo(2), a = ie(t, e, 2), a !== null && (Bo(
              e,
              a,
              t,
              l
            ), Da(a, 2), jt(a));
            break;
          }
        }
        t = t.return;
      }
  }
  function Qi(l, t, e) {
    var a = l.pingCache;
    if (a === null) {
      a = l.pingCache = new bh();
      var u = /* @__PURE__ */ new Set();
      a.set(t, u);
    } else
      u = a.get(t), u === void 0 && (u = /* @__PURE__ */ new Set(), a.set(t, u));
    u.has(e) || (Ci = !0, u.add(e), l = Ah.bind(null, l, t, e), t.then(l, l));
  }
  function Ah(l, t, e) {
    var a = l.pingCache;
    a !== null && a.delete(t), l.pingedLanes |= l.suspendedLanes & e, l.warmLanes &= ~e, Sl === l && (tl & e) === e && (xl === 4 || xl === 3 && (tl & 62914560) === tl && 300 > nt() - pn ? (il & 2) === 0 && pa(l, 0) : Hi |= e, ba === tl && (ba = 0)), jt(l);
  }
  function qr(l, t) {
    t === 0 && (t = Nf()), l = Ne(l, t), l !== null && (Da(l, t), jt(l));
  }
  function Th(l) {
    var t = l.memoizedState, e = 0;
    t !== null && (e = t.retryLane), qr(l, e);
  }
  function _h(l, t) {
    var e = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var a = l.stateNode, u = l.memoizedState;
        u !== null && (e = u.retryLane);
        break;
      case 19:
        a = l.stateNode;
        break;
      case 22:
        a = l.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    a !== null && a.delete(t), qr(l, e);
  }
  function xh(l, t) {
    return lc(l, t);
  }
  var Mn = null, za = null, Zi = !1, On = !1, Li = !1, ye = 0;
  function jt(l) {
    l !== za && l.next === null && (za === null ? Mn = za = l : za = za.next = l), On = !0, Zi || (Zi = !0, Oh());
  }
  function ou(l, t) {
    if (!Li && On) {
      Li = !0;
      do
        for (var e = !1, a = Mn; a !== null; ) {
          if (l !== 0) {
            var u = a.pendingLanes;
            if (u === 0) var n = 0;
            else {
              var c = a.suspendedLanes, i = a.pingedLanes;
              n = (1 << 31 - it(42 | l) + 1) - 1, n &= u & ~(c & ~i), n = n & 201326741 ? n & 201326741 | 1 : n ? n | 2 : 0;
            }
            n !== 0 && (e = !0, Xr(a, n));
          } else
            n = tl, n = Uu(
              a,
              a === Sl ? n : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (n & 3) === 0 || Na(a, n) || (e = !0, Xr(a, n));
          a = a.next;
        }
      while (e);
      Li = !1;
    }
  }
  function Mh() {
    Br();
  }
  function Br() {
    On = Zi = !1;
    var l = 0;
    ye !== 0 && Yh() && (l = ye);
    for (var t = nt(), e = null, a = Mn; a !== null; ) {
      var u = a.next, n = Yr(a, t);
      n === 0 ? (a.next = null, e === null ? Mn = u : e.next = u, u === null && (za = e)) : (e = a, (l !== 0 || (n & 3) !== 0) && (On = !0)), a = u;
    }
    Hl !== 0 && Hl !== 5 || ou(l), ye !== 0 && (ye = 0);
  }
  function Yr(l, t) {
    for (var e = l.suspendedLanes, a = l.pingedLanes, u = l.expirationTimes, n = l.pendingLanes & -62914561; 0 < n; ) {
      var c = 31 - it(n), i = 1 << c, f = u[c];
      f === -1 ? ((i & e) === 0 || (i & a) !== 0) && (u[c] = lm(i, t)) : f <= t && (l.expiredLanes |= i), n &= ~i;
    }
    if (t = Sl, e = tl, e = Uu(
      l,
      l === t ? e : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a = l.callbackNode, e === 0 || l === t && (rl === 2 || rl === 9) || l.cancelPendingCommit !== null)
      return a !== null && a !== null && tc(a), l.callbackNode = null, l.callbackPriority = 0;
    if ((e & 3) === 0 || Na(l, e)) {
      if (t = e & -e, t === l.callbackPriority) return t;
      switch (a !== null && tc(a), uc(e)) {
        case 2:
        case 8:
          e = Mf;
          break;
        case 32:
          e = Mu;
          break;
        case 268435456:
          e = Of;
          break;
        default:
          e = Mu;
      }
      return a = Gr.bind(null, l), e = lc(e, a), l.callbackPriority = t, l.callbackNode = e, t;
    }
    return a !== null && a !== null && tc(a), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function Gr(l, t) {
    if (Hl !== 0 && Hl !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var e = l.callbackNode;
    if (xn() && l.callbackNode !== e)
      return null;
    var a = tl;
    return a = Uu(
      l,
      l === Sl ? a : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a === 0 ? null : (pr(l, a, t), Yr(l, nt()), l.callbackNode != null && l.callbackNode === e ? Gr.bind(null, l) : null);
  }
  function Xr(l, t) {
    if (xn()) return null;
    pr(l, t, !0);
  }
  function Oh() {
    Xh(function() {
      (il & 6) !== 0 ? lc(
        xf,
        Mh
      ) : Br();
    });
  }
  function Vi() {
    if (ye === 0) {
      var l = ia;
      l === 0 && (l = Ou, Ou <<= 1, (Ou & 261888) === 0 && (Ou = 256)), ye = l;
    }
    return ye;
  }
  function Qr(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : Ru("" + l);
  }
  function Zr(l, t) {
    var e = t.ownerDocument.createElement("input");
    return e.name = t.name, e.value = t.value, l.id && e.setAttribute("form", l.id), t.parentNode.insertBefore(e, t), l = new FormData(l), e.parentNode.removeChild(e), l;
  }
  function Nh(l, t, e, a, u) {
    if (t === "submit" && e && e.stateNode === u) {
      var n = Qr(
        (u[Il] || null).action
      ), c = a.submitter;
      c && (t = (t = c[Il] || null) ? Qr(t.formAction) : c.getAttribute("formAction"), t !== null && (n = t, c = null));
      var i = new Gu(
        "action",
        "action",
        null,
        a,
        u
      );
      l.push({
        event: i,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (ye !== 0) {
                  var f = c ? Zr(u, c) : new FormData(u);
                  oi(
                    e,
                    {
                      pending: !0,
                      data: f,
                      method: u.method,
                      action: n
                    },
                    null,
                    f
                  );
                }
              } else
                typeof n == "function" && (i.preventDefault(), f = c ? Zr(u, c) : new FormData(u), oi(
                  e,
                  {
                    pending: !0,
                    data: f,
                    method: u.method,
                    action: n
                  },
                  n,
                  f
                ));
            },
            currentTarget: u
          }
        ]
      });
    }
  }
  for (var Ki = 0; Ki < Mc.length; Ki++) {
    var Ji = Mc[Ki], Dh = Ji.toLowerCase(), Uh = Ji[0].toUpperCase() + Ji.slice(1);
    xt(
      Dh,
      "on" + Uh
    );
  }
  xt(bs, "onAnimationEnd"), xt(Ss, "onAnimationIteration"), xt(ps, "onAnimationStart"), xt("dblclick", "onDoubleClick"), xt("focusin", "onFocus"), xt("focusout", "onBlur"), xt(wm, "onTransitionRun"), xt($m, "onTransitionStart"), xt(km, "onTransitionCancel"), xt(Es, "onTransitionEnd"), we("onMouseEnter", ["mouseout", "mouseover"]), we("onMouseLeave", ["mouseout", "mouseover"]), we("onPointerEnter", ["pointerout", "pointerover"]), we("onPointerLeave", ["pointerout", "pointerover"]), _e(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), _e(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), _e("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), _e(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), _e(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), _e(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var ru = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), jh = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(ru)
  );
  function Lr(l, t) {
    t = (t & 4) !== 0;
    for (var e = 0; e < l.length; e++) {
      var a = l[e], u = a.event;
      a = a.listeners;
      l: {
        var n = void 0;
        if (t)
          for (var c = a.length - 1; 0 <= c; c--) {
            var i = a[c], f = i.instance, v = i.currentTarget;
            if (i = i.listener, f !== n && u.isPropagationStopped())
              break l;
            n = i, u.currentTarget = v;
            try {
              n(u);
            } catch (p) {
              Zu(p);
            }
            u.currentTarget = null, n = f;
          }
        else
          for (c = 0; c < a.length; c++) {
            if (i = a[c], f = i.instance, v = i.currentTarget, i = i.listener, f !== n && u.isPropagationStopped())
              break l;
            n = i, u.currentTarget = v;
            try {
              n(u);
            } catch (p) {
              Zu(p);
            }
            u.currentTarget = null, n = f;
          }
      }
    }
  }
  function P(l, t) {
    var e = t[nc];
    e === void 0 && (e = t[nc] = /* @__PURE__ */ new Set());
    var a = l + "__bubble";
    e.has(a) || (Vr(t, l, 2, !1), e.add(a));
  }
  function wi(l, t, e) {
    var a = 0;
    t && (a |= 4), Vr(
      e,
      l,
      a,
      t
    );
  }
  var Nn = "_reactListening" + Math.random().toString(36).slice(2);
  function $i(l) {
    if (!l[Nn]) {
      l[Nn] = !0, qf.forEach(function(e) {
        e !== "selectionchange" && (jh.has(e) || wi(e, !1, l), wi(e, !0, l));
      });
      var t = l.nodeType === 9 ? l : l.ownerDocument;
      t === null || t[Nn] || (t[Nn] = !0, wi("selectionchange", !1, t));
    }
  }
  function Vr(l, t, e, a) {
    switch (Sd(t)) {
      case 2:
        var u = cv;
        break;
      case 8:
        u = iv;
        break;
      default:
        u = of;
    }
    e = u.bind(
      null,
      t,
      e,
      l
    ), u = void 0, !hc || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (u = !0), a ? u !== void 0 ? l.addEventListener(t, e, {
      capture: !0,
      passive: u
    }) : l.addEventListener(t, e, !0) : u !== void 0 ? l.addEventListener(t, e, {
      passive: u
    }) : l.addEventListener(t, e, !1);
  }
  function ki(l, t, e, a, u) {
    var n = a;
    if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
      l: for (; ; ) {
        if (a === null) return;
        var c = a.tag;
        if (c === 3 || c === 4) {
          var i = a.stateNode.containerInfo;
          if (i === u) break;
          if (c === 4)
            for (c = a.return; c !== null; ) {
              var f = c.tag;
              if ((f === 3 || f === 4) && c.stateNode.containerInfo === u)
                return;
              c = c.return;
            }
          for (; i !== null; ) {
            if (c = Ve(i), c === null) return;
            if (f = c.tag, f === 5 || f === 6 || f === 26 || f === 27) {
              a = n = c;
              continue l;
            }
            i = i.parentNode;
          }
        }
        a = a.return;
      }
    $f(function() {
      var v = n, p = dc(e), A = [];
      l: {
        var y = zs.get(l);
        if (y !== void 0) {
          var g = Gu, U = l;
          switch (l) {
            case "keypress":
              if (Bu(e) === 0) break l;
            case "keydown":
            case "keyup":
              g = _m;
              break;
            case "focusin":
              U = "focus", g = bc;
              break;
            case "focusout":
              U = "blur", g = bc;
              break;
            case "beforeblur":
            case "afterblur":
              g = bc;
              break;
            case "click":
              if (e.button === 2) break l;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              g = Ff;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              g = mm;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              g = Om;
              break;
            case bs:
            case Ss:
            case ps:
              g = ym;
              break;
            case Es:
              g = Dm;
              break;
            case "scroll":
            case "scrollend":
              g = rm;
              break;
            case "wheel":
              g = jm;
              break;
            case "copy":
            case "cut":
            case "paste":
              g = bm;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              g = Pf;
              break;
            case "toggle":
            case "beforetoggle":
              g = Hm;
          }
          var Y = (t & 4) !== 0, gl = !Y && (l === "scroll" || l === "scrollend"), m = Y ? y !== null ? y + "Capture" : null : y;
          Y = [];
          for (var s = v, h; s !== null; ) {
            var z = s;
            if (h = z.stateNode, z = z.tag, z !== 5 && z !== 26 && z !== 27 || h === null || m === null || (z = Ca(s, m), z != null && Y.push(
              du(s, z, h)
            )), gl) break;
            s = s.return;
          }
          0 < Y.length && (y = new g(
            y,
            U,
            null,
            e,
            p
          ), A.push({ event: y, listeners: Y }));
        }
      }
      if ((t & 7) === 0) {
        l: {
          if (y = l === "mouseover" || l === "pointerover", g = l === "mouseout" || l === "pointerout", y && e !== rc && (U = e.relatedTarget || e.fromElement) && (Ve(U) || U[Le]))
            break l;
          if ((g || y) && (y = p.window === p ? p : (y = p.ownerDocument) ? y.defaultView || y.parentWindow : window, g ? (U = e.relatedTarget || e.toElement, g = v, U = U ? Ve(U) : null, U !== null && (gl = Q(U), Y = U.tag, U !== gl || Y !== 5 && Y !== 27 && Y !== 6) && (U = null)) : (g = null, U = v), g !== U)) {
            if (Y = Ff, z = "onMouseLeave", m = "onMouseEnter", s = "mouse", (l === "pointerout" || l === "pointerover") && (Y = Pf, z = "onPointerLeave", m = "onPointerEnter", s = "pointer"), gl = g == null ? y : ja(g), h = U == null ? y : ja(U), y = new Y(
              z,
              s + "leave",
              g,
              e,
              p
            ), y.target = gl, y.relatedTarget = h, z = null, Ve(p) === v && (Y = new Y(
              m,
              s + "enter",
              U,
              e,
              p
            ), Y.target = h, Y.relatedTarget = gl, z = Y), gl = z, g && U)
              t: {
                for (Y = Ch, m = g, s = U, h = 0, z = m; z; z = Y(z))
                  h++;
                z = 0;
                for (var q = s; q; q = Y(q))
                  z++;
                for (; 0 < h - z; )
                  m = Y(m), h--;
                for (; 0 < z - h; )
                  s = Y(s), z--;
                for (; h--; ) {
                  if (m === s || s !== null && m === s.alternate) {
                    Y = m;
                    break t;
                  }
                  m = Y(m), s = Y(s);
                }
                Y = null;
              }
            else Y = null;
            g !== null && Kr(
              A,
              y,
              g,
              Y,
              !1
            ), U !== null && gl !== null && Kr(
              A,
              gl,
              U,
              Y,
              !0
            );
          }
        }
        l: {
          if (y = v ? ja(v) : window, g = y.nodeName && y.nodeName.toLowerCase(), g === "select" || g === "input" && y.type === "file")
            var nl = is;
          else if (ns(y))
            if (fs)
              nl = Vm;
            else {
              nl = Zm;
              var H = Qm;
            }
          else
            g = y.nodeName, !g || g.toLowerCase() !== "input" || y.type !== "checkbox" && y.type !== "radio" ? v && oc(v.elementType) && (nl = is) : nl = Lm;
          if (nl && (nl = nl(l, v))) {
            cs(
              A,
              nl,
              e,
              p
            );
            break l;
          }
          H && H(l, y, v), l === "focusout" && v && y.type === "number" && v.memoizedProps.value != null && sc(y, "number", y.value);
        }
        switch (H = v ? ja(v) : window, l) {
          case "focusin":
            (ns(H) || H.contentEditable === "true") && (Pe = H, Tc = v, Qa = null);
            break;
          case "focusout":
            Qa = Tc = Pe = null;
            break;
          case "mousedown":
            _c = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            _c = !1, ys(A, e, p);
            break;
          case "selectionchange":
            if (Jm) break;
          case "keydown":
          case "keyup":
            ys(A, e, p);
        }
        var k;
        if (pc)
          l: {
            switch (l) {
              case "compositionstart":
                var el = "onCompositionStart";
                break l;
              case "compositionend":
                el = "onCompositionEnd";
                break l;
              case "compositionupdate":
                el = "onCompositionUpdate";
                break l;
            }
            el = void 0;
          }
        else
          Ie ? as(l, e) && (el = "onCompositionEnd") : l === "keydown" && e.keyCode === 229 && (el = "onCompositionStart");
        el && (ls && e.locale !== "ko" && (Ie || el !== "onCompositionStart" ? el === "onCompositionEnd" && Ie && (k = kf()) : (le = p, vc = "value" in le ? le.value : le.textContent, Ie = !0)), H = Dn(v, el), 0 < H.length && (el = new If(
          el,
          l,
          null,
          e,
          p
        ), A.push({ event: el, listeners: H }), k ? el.data = k : (k = us(e), k !== null && (el.data = k)))), (k = qm ? Bm(l, e) : Ym(l, e)) && (el = Dn(v, "onBeforeInput"), 0 < el.length && (H = new If(
          "onBeforeInput",
          "beforeinput",
          null,
          e,
          p
        ), A.push({
          event: H,
          listeners: el
        }), H.data = k)), Nh(
          A,
          l,
          v,
          e,
          p
        );
      }
      Lr(A, t);
    });
  }
  function du(l, t, e) {
    return {
      instance: l,
      listener: t,
      currentTarget: e
    };
  }
  function Dn(l, t) {
    for (var e = t + "Capture", a = []; l !== null; ) {
      var u = l, n = u.stateNode;
      if (u = u.tag, u !== 5 && u !== 26 && u !== 27 || n === null || (u = Ca(l, e), u != null && a.unshift(
        du(l, u, n)
      ), u = Ca(l, t), u != null && a.push(
        du(l, u, n)
      )), l.tag === 3) return a;
      l = l.return;
    }
    return [];
  }
  function Ch(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Kr(l, t, e, a, u) {
    for (var n = t._reactName, c = []; e !== null && e !== a; ) {
      var i = e, f = i.alternate, v = i.stateNode;
      if (i = i.tag, f !== null && f === a) break;
      i !== 5 && i !== 26 && i !== 27 || v === null || (f = v, u ? (v = Ca(e, n), v != null && c.unshift(
        du(e, v, f)
      )) : u || (v = Ca(e, n), v != null && c.push(
        du(e, v, f)
      ))), e = e.return;
    }
    c.length !== 0 && l.push({ event: t, listeners: c });
  }
  var Hh = /\r\n?/g, Rh = /\u0000|\uFFFD/g;
  function Jr(l) {
    return (typeof l == "string" ? l : "" + l).replace(Hh, `
`).replace(Rh, "");
  }
  function wr(l, t) {
    return t = Jr(t), Jr(l) === t;
  }
  function yl(l, t, e, a, u, n) {
    switch (e) {
      case "children":
        typeof a == "string" ? t === "body" || t === "textarea" && a === "" || ke(l, a) : (typeof a == "number" || typeof a == "bigint") && t !== "body" && ke(l, "" + a);
        break;
      case "className":
        Cu(l, "class", a);
        break;
      case "tabIndex":
        Cu(l, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Cu(l, e, a);
        break;
      case "style":
        Jf(l, a, n);
        break;
      case "data":
        if (t !== "object") {
          Cu(l, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (t !== "a" || e !== "href")) {
          l.removeAttribute(e);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Ru("" + a), l.setAttribute(e, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          l.setAttribute(
            e,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof n == "function" && (e === "formAction" ? (t !== "input" && yl(l, t, "name", u.name, u, null), yl(
            l,
            t,
            "formEncType",
            u.formEncType,
            u,
            null
          ), yl(
            l,
            t,
            "formMethod",
            u.formMethod,
            u,
            null
          ), yl(
            l,
            t,
            "formTarget",
            u.formTarget,
            u,
            null
          )) : (yl(l, t, "encType", u.encType, u, null), yl(l, t, "method", u.method, u, null), yl(l, t, "target", u.target, u, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Ru("" + a), l.setAttribute(e, a);
        break;
      case "onClick":
        a != null && (l.onclick = Ht);
        break;
      case "onScroll":
        a != null && P("scroll", l);
        break;
      case "onScrollEnd":
        a != null && P("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(r(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(r(60));
            l.innerHTML = e;
          }
        }
        break;
      case "multiple":
        l.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        l.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        e = Ru("" + a), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          e
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "" + a) : l.removeAttribute(e);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "") : l.removeAttribute(e);
        break;
      case "capture":
      case "download":
        a === !0 ? l.setAttribute(e, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? l.removeAttribute(e) : l.setAttribute(e, a);
        break;
      case "popover":
        P("beforetoggle", l), P("toggle", l), ju(l, "popover", a);
        break;
      case "xlinkActuate":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        Ct(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        Ct(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        ju(l, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = sm.get(e) || e, ju(l, e, a));
    }
  }
  function Wi(l, t, e, a, u, n) {
    switch (e) {
      case "style":
        Jf(l, a, n);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(r(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(r(60));
            l.innerHTML = e;
          }
        }
        break;
      case "children":
        typeof a == "string" ? ke(l, a) : (typeof a == "number" || typeof a == "bigint") && ke(l, "" + a);
        break;
      case "onScroll":
        a != null && P("scroll", l);
        break;
      case "onScrollEnd":
        a != null && P("scrollend", l);
        break;
      case "onClick":
        a != null && (l.onclick = Ht);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Bf.hasOwnProperty(e))
          l: {
            if (e[0] === "o" && e[1] === "n" && (u = e.endsWith("Capture"), t = e.slice(2, u ? e.length - 7 : void 0), n = l[Il] || null, n = n != null ? n[e] : null, typeof n == "function" && l.removeEventListener(t, n, u), typeof a == "function")) {
              typeof n != "function" && n !== null && (e in l ? l[e] = null : l.hasAttribute(e) && l.removeAttribute(e)), l.addEventListener(t, a, u);
              break l;
            }
            e in l ? l[e] = a : a === !0 ? l.setAttribute(e, "") : ju(l, e, a);
          }
    }
  }
  function Jl(l, t, e) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        P("error", l), P("load", l);
        var a = !1, u = !1, n;
        for (n in e)
          if (e.hasOwnProperty(n)) {
            var c = e[n];
            if (c != null)
              switch (n) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  u = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, t));
                default:
                  yl(l, t, n, c, e, null);
              }
          }
        u && yl(l, t, "srcSet", e.srcSet, e, null), a && yl(l, t, "src", e.src, e, null);
        return;
      case "input":
        P("invalid", l);
        var i = n = c = u = null, f = null, v = null;
        for (a in e)
          if (e.hasOwnProperty(a)) {
            var p = e[a];
            if (p != null)
              switch (a) {
                case "name":
                  u = p;
                  break;
                case "type":
                  c = p;
                  break;
                case "checked":
                  f = p;
                  break;
                case "defaultChecked":
                  v = p;
                  break;
                case "value":
                  n = p;
                  break;
                case "defaultValue":
                  i = p;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (p != null)
                    throw Error(r(137, t));
                  break;
                default:
                  yl(l, t, a, p, e, null);
              }
          }
        Zf(
          l,
          n,
          i,
          f,
          v,
          c,
          u,
          !1
        );
        return;
      case "select":
        P("invalid", l), a = c = n = null;
        for (u in e)
          if (e.hasOwnProperty(u) && (i = e[u], i != null))
            switch (u) {
              case "value":
                n = i;
                break;
              case "defaultValue":
                c = i;
                break;
              case "multiple":
                a = i;
              default:
                yl(l, t, u, i, e, null);
            }
        t = n, e = c, l.multiple = !!a, t != null ? $e(l, !!a, t, !1) : e != null && $e(l, !!a, e, !0);
        return;
      case "textarea":
        P("invalid", l), n = u = a = null;
        for (c in e)
          if (e.hasOwnProperty(c) && (i = e[c], i != null))
            switch (c) {
              case "value":
                a = i;
                break;
              case "defaultValue":
                u = i;
                break;
              case "children":
                n = i;
                break;
              case "dangerouslySetInnerHTML":
                if (i != null) throw Error(r(91));
                break;
              default:
                yl(l, t, c, i, e, null);
            }
        Vf(l, a, u, n);
        return;
      case "option":
        for (f in e)
          e.hasOwnProperty(f) && (a = e[f], a != null) && (f === "selected" ? l.selected = a && typeof a != "function" && typeof a != "symbol" : yl(l, t, f, a, e, null));
        return;
      case "dialog":
        P("beforetoggle", l), P("toggle", l), P("cancel", l), P("close", l);
        break;
      case "iframe":
      case "object":
        P("load", l);
        break;
      case "video":
      case "audio":
        for (a = 0; a < ru.length; a++)
          P(ru[a], l);
        break;
      case "image":
        P("error", l), P("load", l);
        break;
      case "details":
        P("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        P("error", l), P("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (v in e)
          if (e.hasOwnProperty(v) && (a = e[v], a != null))
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, t));
              default:
                yl(l, t, v, a, e, null);
            }
        return;
      default:
        if (oc(t)) {
          for (p in e)
            e.hasOwnProperty(p) && (a = e[p], a !== void 0 && Wi(
              l,
              t,
              p,
              a,
              e,
              void 0
            ));
          return;
        }
    }
    for (i in e)
      e.hasOwnProperty(i) && (a = e[i], a != null && yl(l, t, i, a, e, null));
  }
  function qh(l, t, e, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var u = null, n = null, c = null, i = null, f = null, v = null, p = null;
        for (g in e) {
          var A = e[g];
          if (e.hasOwnProperty(g) && A != null)
            switch (g) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                f = A;
              default:
                a.hasOwnProperty(g) || yl(l, t, g, null, a, A);
            }
        }
        for (var y in a) {
          var g = a[y];
          if (A = e[y], a.hasOwnProperty(y) && (g != null || A != null))
            switch (y) {
              case "type":
                n = g;
                break;
              case "name":
                u = g;
                break;
              case "checked":
                v = g;
                break;
              case "defaultChecked":
                p = g;
                break;
              case "value":
                c = g;
                break;
              case "defaultValue":
                i = g;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (g != null)
                  throw Error(r(137, t));
                break;
              default:
                g !== A && yl(
                  l,
                  t,
                  y,
                  g,
                  a,
                  A
                );
            }
        }
        fc(
          l,
          c,
          i,
          f,
          v,
          p,
          n,
          u
        );
        return;
      case "select":
        g = c = i = y = null;
        for (n in e)
          if (f = e[n], e.hasOwnProperty(n) && f != null)
            switch (n) {
              case "value":
                break;
              case "multiple":
                g = f;
              default:
                a.hasOwnProperty(n) || yl(
                  l,
                  t,
                  n,
                  null,
                  a,
                  f
                );
            }
        for (u in a)
          if (n = a[u], f = e[u], a.hasOwnProperty(u) && (n != null || f != null))
            switch (u) {
              case "value":
                y = n;
                break;
              case "defaultValue":
                i = n;
                break;
              case "multiple":
                c = n;
              default:
                n !== f && yl(
                  l,
                  t,
                  u,
                  n,
                  a,
                  f
                );
            }
        t = i, e = c, a = g, y != null ? $e(l, !!e, y, !1) : !!a != !!e && (t != null ? $e(l, !!e, t, !0) : $e(l, !!e, e ? [] : "", !1));
        return;
      case "textarea":
        g = y = null;
        for (i in e)
          if (u = e[i], e.hasOwnProperty(i) && u != null && !a.hasOwnProperty(i))
            switch (i) {
              case "value":
                break;
              case "children":
                break;
              default:
                yl(l, t, i, null, a, u);
            }
        for (c in a)
          if (u = a[c], n = e[c], a.hasOwnProperty(c) && (u != null || n != null))
            switch (c) {
              case "value":
                y = u;
                break;
              case "defaultValue":
                g = u;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (u != null) throw Error(r(91));
                break;
              default:
                u !== n && yl(l, t, c, u, a, n);
            }
        Lf(l, y, g);
        return;
      case "option":
        for (var U in e)
          y = e[U], e.hasOwnProperty(U) && y != null && !a.hasOwnProperty(U) && (U === "selected" ? l.selected = !1 : yl(
            l,
            t,
            U,
            null,
            a,
            y
          ));
        for (f in a)
          y = a[f], g = e[f], a.hasOwnProperty(f) && y !== g && (y != null || g != null) && (f === "selected" ? l.selected = y && typeof y != "function" && typeof y != "symbol" : yl(
            l,
            t,
            f,
            y,
            a,
            g
          ));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Y in e)
          y = e[Y], e.hasOwnProperty(Y) && y != null && !a.hasOwnProperty(Y) && yl(l, t, Y, null, a, y);
        for (v in a)
          if (y = a[v], g = e[v], a.hasOwnProperty(v) && y !== g && (y != null || g != null))
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (y != null)
                  throw Error(r(137, t));
                break;
              default:
                yl(
                  l,
                  t,
                  v,
                  y,
                  a,
                  g
                );
            }
        return;
      default:
        if (oc(t)) {
          for (var gl in e)
            y = e[gl], e.hasOwnProperty(gl) && y !== void 0 && !a.hasOwnProperty(gl) && Wi(
              l,
              t,
              gl,
              void 0,
              a,
              y
            );
          for (p in a)
            y = a[p], g = e[p], !a.hasOwnProperty(p) || y === g || y === void 0 && g === void 0 || Wi(
              l,
              t,
              p,
              y,
              a,
              g
            );
          return;
        }
    }
    for (var m in e)
      y = e[m], e.hasOwnProperty(m) && y != null && !a.hasOwnProperty(m) && yl(l, t, m, null, a, y);
    for (A in a)
      y = a[A], g = e[A], !a.hasOwnProperty(A) || y === g || y == null && g == null || yl(l, t, A, y, a, g);
  }
  function $r(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Bh() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, t = 0, e = performance.getEntriesByType("resource"), a = 0; a < e.length; a++) {
        var u = e[a], n = u.transferSize, c = u.initiatorType, i = u.duration;
        if (n && i && $r(c)) {
          for (c = 0, i = u.responseEnd, a += 1; a < e.length; a++) {
            var f = e[a], v = f.startTime;
            if (v > i) break;
            var p = f.transferSize, A = f.initiatorType;
            p && $r(A) && (f = f.responseEnd, c += p * (f < i ? 1 : (i - v) / (f - v)));
          }
          if (--a, t += 8 * (n + c) / (u.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return t / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var Fi = null, Ii = null;
  function Un(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function kr(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Wr(l, t) {
    if (l === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && t === "foreignObject" ? 0 : l;
  }
  function Pi(l, t) {
    return l === "textarea" || l === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var lf = null;
  function Yh() {
    var l = window.event;
    return l && l.type === "popstate" ? l === lf ? !1 : (lf = l, !0) : (lf = null, !1);
  }
  var Fr = typeof setTimeout == "function" ? setTimeout : void 0, Gh = typeof clearTimeout == "function" ? clearTimeout : void 0, Ir = typeof Promise == "function" ? Promise : void 0, Xh = typeof queueMicrotask == "function" ? queueMicrotask : typeof Ir < "u" ? function(l) {
    return Ir.resolve(null).then(l).catch(Qh);
  } : Fr;
  function Qh(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function ge(l) {
    return l === "head";
  }
  function Pr(l, t) {
    var e = t, a = 0;
    do {
      var u = e.nextSibling;
      if (l.removeChild(e), u && u.nodeType === 8)
        if (e = u.data, e === "/$" || e === "/&") {
          if (a === 0) {
            l.removeChild(u), xa(t);
            return;
          }
          a--;
        } else if (e === "$" || e === "$?" || e === "$~" || e === "$!" || e === "&")
          a++;
        else if (e === "html")
          mu(l.ownerDocument.documentElement);
        else if (e === "head") {
          e = l.ownerDocument.head, mu(e);
          for (var n = e.firstChild; n; ) {
            var c = n.nextSibling, i = n.nodeName;
            n[Ua] || i === "SCRIPT" || i === "STYLE" || i === "LINK" && n.rel.toLowerCase() === "stylesheet" || e.removeChild(n), n = c;
          }
        } else
          e === "body" && mu(l.ownerDocument.body);
      e = u;
    } while (e);
    xa(t);
  }
  function ld(l, t) {
    var e = l;
    l = 0;
    do {
      var a = e.nextSibling;
      if (e.nodeType === 1 ? t ? (e._stashedDisplay = e.style.display, e.style.display = "none") : (e.style.display = e._stashedDisplay || "", e.getAttribute("style") === "" && e.removeAttribute("style")) : e.nodeType === 3 && (t ? (e._stashedText = e.nodeValue, e.nodeValue = "") : e.nodeValue = e._stashedText || ""), a && a.nodeType === 8)
        if (e = a.data, e === "/$") {
          if (l === 0) break;
          l--;
        } else
          e !== "$" && e !== "$?" && e !== "$~" && e !== "$!" || l++;
      e = a;
    } while (e);
  }
  function tf(l) {
    var t = l.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var e = t;
      switch (t = t.nextSibling, e.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          tf(e), cc(e);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (e.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(e);
    }
  }
  function Zh(l, t, e, a) {
    for (; l.nodeType === 1; ) {
      var u = e;
      if (l.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!a && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (a) {
        if (!l[Ua])
          switch (t) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (n = l.getAttribute("rel"), n === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (n !== u.rel || l.getAttribute("href") !== (u.href == null || u.href === "" ? null : u.href) || l.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin) || l.getAttribute("title") !== (u.title == null ? null : u.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (n = l.getAttribute("src"), (n !== (u.src == null ? null : u.src) || l.getAttribute("type") !== (u.type == null ? null : u.type) || l.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin)) && n && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (t === "input" && l.type === "hidden") {
        var n = u.name == null ? null : "" + u.name;
        if (u.type === "hidden" && l.getAttribute("name") === n)
          return l;
      } else return l;
      if (l = Tt(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Lh(l, t, e) {
    if (t === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !e || (l = Tt(l.nextSibling), l === null)) return null;
    return l;
  }
  function td(l, t) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !t || (l = Tt(l.nextSibling), l === null)) return null;
    return l;
  }
  function ef(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function af(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function Vh(l, t) {
    var e = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = t;
    else if (l.data !== "$?" || e.readyState !== "loading")
      t();
    else {
      var a = function() {
        t(), e.removeEventListener("DOMContentLoaded", a);
      };
      e.addEventListener("DOMContentLoaded", a), l._reactRetry = a;
    }
  }
  function Tt(l) {
    for (; l != null; l = l.nextSibling) {
      var t = l.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = l.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return l;
  }
  var uf = null;
  function ed(l) {
    l = l.nextSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "/$" || e === "/&") {
          if (t === 0)
            return Tt(l.nextSibling);
          t--;
        } else
          e !== "$" && e !== "$!" && e !== "$?" && e !== "$~" && e !== "&" || t++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function ad(l) {
    l = l.previousSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&") {
          if (t === 0) return l;
          t--;
        } else e !== "/$" && e !== "/&" || t++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function ud(l, t, e) {
    switch (t = Un(e), l) {
      case "html":
        if (l = t.documentElement, !l) throw Error(r(452));
        return l;
      case "head":
        if (l = t.head, !l) throw Error(r(453));
        return l;
      case "body":
        if (l = t.body, !l) throw Error(r(454));
        return l;
      default:
        throw Error(r(451));
    }
  }
  function mu(l) {
    for (var t = l.attributes; t.length; )
      l.removeAttributeNode(t[0]);
    cc(l);
  }
  var _t = /* @__PURE__ */ new Map(), nd = /* @__PURE__ */ new Set();
  function jn(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Wt = O.d;
  O.d = {
    f: Kh,
    r: Jh,
    D: wh,
    C: $h,
    L: kh,
    m: Wh,
    X: Ih,
    S: Fh,
    M: Ph
  };
  function Kh() {
    var l = Wt.f(), t = An();
    return l || t;
  }
  function Jh(l) {
    var t = Ke(l);
    t !== null && t.tag === 5 && t.type === "form" ? zo(t) : Wt.r(l);
  }
  var Aa = typeof document > "u" ? null : document;
  function cd(l, t, e) {
    var a = Aa;
    if (a && typeof t == "string" && t) {
      var u = gt(t);
      u = 'link[rel="' + l + '"][href="' + u + '"]', typeof e == "string" && (u += '[crossorigin="' + e + '"]'), nd.has(u) || (nd.add(u), l = { rel: l, crossOrigin: e, href: t }, a.querySelector(u) === null && (t = a.createElement("link"), Jl(t, "link", l), Yl(t), a.head.appendChild(t)));
    }
  }
  function wh(l) {
    Wt.D(l), cd("dns-prefetch", l, null);
  }
  function $h(l, t) {
    Wt.C(l, t), cd("preconnect", l, t);
  }
  function kh(l, t, e) {
    Wt.L(l, t, e);
    var a = Aa;
    if (a && l && t) {
      var u = 'link[rel="preload"][as="' + gt(t) + '"]';
      t === "image" && e && e.imageSrcSet ? (u += '[imagesrcset="' + gt(
        e.imageSrcSet
      ) + '"]', typeof e.imageSizes == "string" && (u += '[imagesizes="' + gt(
        e.imageSizes
      ) + '"]')) : u += '[href="' + gt(l) + '"]';
      var n = u;
      switch (t) {
        case "style":
          n = Ta(l);
          break;
        case "script":
          n = _a(l);
      }
      _t.has(n) || (l = M(
        {
          rel: "preload",
          href: t === "image" && e && e.imageSrcSet ? void 0 : l,
          as: t
        },
        e
      ), _t.set(n, l), a.querySelector(u) !== null || t === "style" && a.querySelector(hu(n)) || t === "script" && a.querySelector(vu(n)) || (t = a.createElement("link"), Jl(t, "link", l), Yl(t), a.head.appendChild(t)));
    }
  }
  function Wh(l, t) {
    Wt.m(l, t);
    var e = Aa;
    if (e && l) {
      var a = t && typeof t.as == "string" ? t.as : "script", u = 'link[rel="modulepreload"][as="' + gt(a) + '"][href="' + gt(l) + '"]', n = u;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          n = _a(l);
      }
      if (!_t.has(n) && (l = M({ rel: "modulepreload", href: l }, t), _t.set(n, l), e.querySelector(u) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (e.querySelector(vu(n)))
              return;
        }
        a = e.createElement("link"), Jl(a, "link", l), Yl(a), e.head.appendChild(a);
      }
    }
  }
  function Fh(l, t, e) {
    Wt.S(l, t, e);
    var a = Aa;
    if (a && l) {
      var u = Je(a).hoistableStyles, n = Ta(l);
      t = t || "default";
      var c = u.get(n);
      if (!c) {
        var i = { loading: 0, preload: null };
        if (c = a.querySelector(
          hu(n)
        ))
          i.loading = 5;
        else {
          l = M(
            { rel: "stylesheet", href: l, "data-precedence": t },
            e
          ), (e = _t.get(n)) && nf(l, e);
          var f = c = a.createElement("link");
          Yl(f), Jl(f, "link", l), f._p = new Promise(function(v, p) {
            f.onload = v, f.onerror = p;
          }), f.addEventListener("load", function() {
            i.loading |= 1;
          }), f.addEventListener("error", function() {
            i.loading |= 2;
          }), i.loading |= 4, Cn(c, t, a);
        }
        c = {
          type: "stylesheet",
          instance: c,
          count: 1,
          state: i
        }, u.set(n, c);
      }
    }
  }
  function Ih(l, t) {
    Wt.X(l, t);
    var e = Aa;
    if (e && l) {
      var a = Je(e).hoistableScripts, u = _a(l), n = a.get(u);
      n || (n = e.querySelector(vu(u)), n || (l = M({ src: l, async: !0 }, t), (t = _t.get(u)) && cf(l, t), n = e.createElement("script"), Yl(n), Jl(n, "link", l), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function Ph(l, t) {
    Wt.M(l, t);
    var e = Aa;
    if (e && l) {
      var a = Je(e).hoistableScripts, u = _a(l), n = a.get(u);
      n || (n = e.querySelector(vu(u)), n || (l = M({ src: l, async: !0, type: "module" }, t), (t = _t.get(u)) && cf(l, t), n = e.createElement("script"), Yl(n), Jl(n, "link", l), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function id(l, t, e, a) {
    var u = (u = F.current) ? jn(u) : null;
    if (!u) throw Error(r(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof e.precedence == "string" && typeof e.href == "string" ? (t = Ta(e.href), e = Je(
          u
        ).hoistableStyles, a = e.get(t), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (e.rel === "stylesheet" && typeof e.href == "string" && typeof e.precedence == "string") {
          l = Ta(e.href);
          var n = Je(
            u
          ).hoistableStyles, c = n.get(l);
          if (c || (u = u.ownerDocument || u, c = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, n.set(l, c), (n = u.querySelector(
            hu(l)
          )) && !n._p && (c.instance = n, c.state.loading = 5), _t.has(l) || (e = {
            rel: "preload",
            as: "style",
            href: e.href,
            crossOrigin: e.crossOrigin,
            integrity: e.integrity,
            media: e.media,
            hrefLang: e.hrefLang,
            referrerPolicy: e.referrerPolicy
          }, _t.set(l, e), n || lv(
            u,
            l,
            e,
            c.state
          ))), t && a === null)
            throw Error(r(528, ""));
          return c;
        }
        if (t && a !== null)
          throw Error(r(529, ""));
        return null;
      case "script":
        return t = e.async, e = e.src, typeof e == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = _a(e), e = Je(
          u
        ).hoistableScripts, a = e.get(t), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(r(444, l));
    }
  }
  function Ta(l) {
    return 'href="' + gt(l) + '"';
  }
  function hu(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function fd(l) {
    return M({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function lv(l, t, e, a) {
    l.querySelector('link[rel="preload"][as="style"][' + t + "]") ? a.loading = 1 : (t = l.createElement("link"), a.preload = t, t.addEventListener("load", function() {
      return a.loading |= 1;
    }), t.addEventListener("error", function() {
      return a.loading |= 2;
    }), Jl(t, "link", e), Yl(t), l.head.appendChild(t));
  }
  function _a(l) {
    return '[src="' + gt(l) + '"]';
  }
  function vu(l) {
    return "script[async]" + l;
  }
  function sd(l, t, e) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var a = l.querySelector(
            'style[data-href~="' + gt(e.href) + '"]'
          );
          if (a)
            return t.instance = a, Yl(a), a;
          var u = M({}, e, {
            "data-href": e.href,
            "data-precedence": e.precedence,
            href: null,
            precedence: null
          });
          return a = (l.ownerDocument || l).createElement(
            "style"
          ), Yl(a), Jl(a, "style", u), Cn(a, e.precedence, l), t.instance = a;
        case "stylesheet":
          u = Ta(e.href);
          var n = l.querySelector(
            hu(u)
          );
          if (n)
            return t.state.loading |= 4, t.instance = n, Yl(n), n;
          a = fd(e), (u = _t.get(u)) && nf(a, u), n = (l.ownerDocument || l).createElement("link"), Yl(n);
          var c = n;
          return c._p = new Promise(function(i, f) {
            c.onload = i, c.onerror = f;
          }), Jl(n, "link", a), t.state.loading |= 4, Cn(n, e.precedence, l), t.instance = n;
        case "script":
          return n = _a(e.src), (u = l.querySelector(
            vu(n)
          )) ? (t.instance = u, Yl(u), u) : (a = e, (u = _t.get(n)) && (a = M({}, e), cf(a, u)), l = l.ownerDocument || l, u = l.createElement("script"), Yl(u), Jl(u, "link", a), l.head.appendChild(u), t.instance = u);
        case "void":
          return null;
        default:
          throw Error(r(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (a = t.instance, t.state.loading |= 4, Cn(a, e.precedence, l));
    return t.instance;
  }
  function Cn(l, t, e) {
    for (var a = e.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), u = a.length ? a[a.length - 1] : null, n = u, c = 0; c < a.length; c++) {
      var i = a[c];
      if (i.dataset.precedence === t) n = i;
      else if (n !== u) break;
    }
    n ? n.parentNode.insertBefore(l, n.nextSibling) : (t = e.nodeType === 9 ? e.head : e, t.insertBefore(l, t.firstChild));
  }
  function nf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.title == null && (l.title = t.title);
  }
  function cf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.integrity == null && (l.integrity = t.integrity);
  }
  var Hn = null;
  function od(l, t, e) {
    if (Hn === null) {
      var a = /* @__PURE__ */ new Map(), u = Hn = /* @__PURE__ */ new Map();
      u.set(e, a);
    } else
      u = Hn, a = u.get(e), a || (a = /* @__PURE__ */ new Map(), u.set(e, a));
    if (a.has(l)) return a;
    for (a.set(l, null), e = e.getElementsByTagName(l), u = 0; u < e.length; u++) {
      var n = e[u];
      if (!(n[Ua] || n[Zl] || l === "link" && n.getAttribute("rel") === "stylesheet") && n.namespaceURI !== "http://www.w3.org/2000/svg") {
        var c = n.getAttribute(t) || "";
        c = l + c;
        var i = a.get(c);
        i ? i.push(n) : a.set(c, [n]);
      }
    }
    return a;
  }
  function rd(l, t, e) {
    l = l.ownerDocument || l, l.head.insertBefore(
      e,
      t === "title" ? l.querySelector("head > title") : null
    );
  }
  function tv(l, t, e) {
    if (e === 1 || t.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        return t.rel === "stylesheet" ? (l = t.disabled, typeof t.precedence == "string" && l == null) : !0;
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function dd(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function ev(l, t, e, a) {
    if (e.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (e.state.loading & 4) === 0) {
      if (e.instance === null) {
        var u = Ta(a.href), n = t.querySelector(
          hu(u)
        );
        if (n) {
          t = n._p, t !== null && typeof t == "object" && typeof t.then == "function" && (l.count++, l = Rn.bind(l), t.then(l, l)), e.state.loading |= 4, e.instance = n, Yl(n);
          return;
        }
        n = t.ownerDocument || t, a = fd(a), (u = _t.get(u)) && nf(a, u), n = n.createElement("link"), Yl(n);
        var c = n;
        c._p = new Promise(function(i, f) {
          c.onload = i, c.onerror = f;
        }), Jl(n, "link", a), e.instance = n;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(e, t), (t = e.state.preload) && (e.state.loading & 3) === 0 && (l.count++, e = Rn.bind(l), t.addEventListener("load", e), t.addEventListener("error", e));
    }
  }
  var ff = 0;
  function av(l, t) {
    return l.stylesheets && l.count === 0 && Bn(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(e) {
      var a = setTimeout(function() {
        if (l.stylesheets && Bn(l, l.stylesheets), l.unsuspend) {
          var n = l.unsuspend;
          l.unsuspend = null, n();
        }
      }, 6e4 + t);
      0 < l.imgBytes && ff === 0 && (ff = 62500 * Bh());
      var u = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Bn(l, l.stylesheets), l.unsuspend)) {
            var n = l.unsuspend;
            l.unsuspend = null, n();
          }
        },
        (l.imgBytes > ff ? 50 : 800) + t
      );
      return l.unsuspend = e, function() {
        l.unsuspend = null, clearTimeout(a), clearTimeout(u);
      };
    } : null;
  }
  function Rn() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Bn(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var qn = null;
  function Bn(l, t) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, qn = /* @__PURE__ */ new Map(), t.forEach(uv, l), qn = null, Rn.call(l));
  }
  function uv(l, t) {
    if (!(t.state.loading & 4)) {
      var e = qn.get(l);
      if (e) var a = e.get(null);
      else {
        e = /* @__PURE__ */ new Map(), qn.set(l, e);
        for (var u = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), n = 0; n < u.length; n++) {
          var c = u[n];
          (c.nodeName === "LINK" || c.getAttribute("media") !== "not all") && (e.set(c.dataset.precedence, c), a = c);
        }
        a && e.set(null, a);
      }
      u = t.instance, c = u.getAttribute("data-precedence"), n = e.get(c) || a, n === a && e.set(null, u), e.set(c, u), this.count++, a = Rn.bind(this), u.addEventListener("load", a), u.addEventListener("error", a), n ? n.parentNode.insertBefore(u, n.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(u, l.firstChild)), t.state.loading |= 4;
    }
  }
  var yu = {
    $$typeof: ml,
    Provider: null,
    Consumer: null,
    _currentValue: G,
    _currentValue2: G,
    _threadCount: 0
  };
  function nv(l, t, e, a, u, n, c, i, f) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ec(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ec(0), this.hiddenUpdates = ec(null), this.identifierPrefix = a, this.onUncaughtError = u, this.onCaughtError = n, this.onRecoverableError = c, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = f, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function md(l, t, e, a, u, n, c, i, f, v, p, A) {
    return l = new nv(
      l,
      t,
      e,
      c,
      f,
      v,
      p,
      A,
      i
    ), t = 1, n === !0 && (t |= 24), n = st(3, null, null, t), l.current = n, n.stateNode = l, t = Xc(), t.refCount++, l.pooledCache = t, t.refCount++, n.memoizedState = {
      element: a,
      isDehydrated: e,
      cache: t
    }, Vc(n), l;
  }
  function hd(l) {
    return l ? (l = ea, l) : ea;
  }
  function vd(l, t, e, a, u, n) {
    u = hd(u), a.context === null ? a.context = u : a.pendingContext = u, a = ce(t), a.payload = { element: e }, n = n === void 0 ? null : n, n !== null && (a.callback = n), e = ie(l, a, t), e !== null && (ut(e, l, t), $a(e, l, t));
  }
  function yd(l, t) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var e = l.retryLane;
      l.retryLane = e !== 0 && e < t ? e : t;
    }
  }
  function sf(l, t) {
    yd(l, t), (l = l.alternate) && yd(l, t);
  }
  function gd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = Ne(l, 67108864);
      t !== null && ut(t, l, 67108864), sf(l, 67108864);
    }
  }
  function bd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = ht();
      t = ac(t);
      var e = Ne(l, t);
      e !== null && ut(e, l, t), sf(l, t);
    }
  }
  var Yn = !0;
  function cv(l, t, e, a) {
    var u = E.T;
    E.T = null;
    var n = O.p;
    try {
      O.p = 2, of(l, t, e, a);
    } finally {
      O.p = n, E.T = u;
    }
  }
  function iv(l, t, e, a) {
    var u = E.T;
    E.T = null;
    var n = O.p;
    try {
      O.p = 8, of(l, t, e, a);
    } finally {
      O.p = n, E.T = u;
    }
  }
  function of(l, t, e, a) {
    if (Yn) {
      var u = rf(a);
      if (u === null)
        ki(
          l,
          t,
          a,
          Gn,
          e
        ), pd(l, a);
      else if (sv(
        u,
        l,
        t,
        e,
        a
      ))
        a.stopPropagation();
      else if (pd(l, a), t & 4 && -1 < fv.indexOf(l)) {
        for (; u !== null; ) {
          var n = Ke(u);
          if (n !== null)
            switch (n.tag) {
              case 3:
                if (n = n.stateNode, n.current.memoizedState.isDehydrated) {
                  var c = Te(n.pendingLanes);
                  if (c !== 0) {
                    var i = n;
                    for (i.pendingLanes |= 2, i.entangledLanes |= 2; c; ) {
                      var f = 1 << 31 - it(c);
                      i.entanglements[1] |= f, c &= ~f;
                    }
                    jt(n), (il & 6) === 0 && (En = nt() + 500, ou(0));
                  }
                }
                break;
              case 31:
              case 13:
                i = Ne(n, 2), i !== null && ut(i, n, 2), An(), sf(n, 2);
            }
          if (n = rf(a), n === null && ki(
            l,
            t,
            a,
            Gn,
            e
          ), n === u) break;
          u = n;
        }
        u !== null && a.stopPropagation();
      } else
        ki(
          l,
          t,
          a,
          null,
          e
        );
    }
  }
  function rf(l) {
    return l = dc(l), df(l);
  }
  var Gn = null;
  function df(l) {
    if (Gn = null, l = Ve(l), l !== null) {
      var t = Q(l);
      if (t === null) l = null;
      else {
        var e = t.tag;
        if (e === 13) {
          if (l = W(t), l !== null) return l;
          l = null;
        } else if (e === 31) {
          if (l = Z(t), l !== null) return l;
          l = null;
        } else if (e === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          l = null;
        } else t !== l && (l = null);
      }
    }
    return Gn = l, null;
  }
  function Sd(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (wd()) {
          case xf:
            return 2;
          case Mf:
            return 8;
          case Mu:
          case $d:
            return 32;
          case Of:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var mf = !1, be = null, Se = null, pe = null, gu = /* @__PURE__ */ new Map(), bu = /* @__PURE__ */ new Map(), Ee = [], fv = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function pd(l, t) {
    switch (l) {
      case "focusin":
      case "focusout":
        be = null;
        break;
      case "dragenter":
      case "dragleave":
        Se = null;
        break;
      case "mouseover":
      case "mouseout":
        pe = null;
        break;
      case "pointerover":
      case "pointerout":
        gu.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        bu.delete(t.pointerId);
    }
  }
  function Su(l, t, e, a, u, n) {
    return l === null || l.nativeEvent !== n ? (l = {
      blockedOn: t,
      domEventName: e,
      eventSystemFlags: a,
      nativeEvent: n,
      targetContainers: [u]
    }, t !== null && (t = Ke(t), t !== null && gd(t)), l) : (l.eventSystemFlags |= a, t = l.targetContainers, u !== null && t.indexOf(u) === -1 && t.push(u), l);
  }
  function sv(l, t, e, a, u) {
    switch (t) {
      case "focusin":
        return be = Su(
          be,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "dragenter":
        return Se = Su(
          Se,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "mouseover":
        return pe = Su(
          pe,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "pointerover":
        var n = u.pointerId;
        return gu.set(
          n,
          Su(
            gu.get(n) || null,
            l,
            t,
            e,
            a,
            u
          )
        ), !0;
      case "gotpointercapture":
        return n = u.pointerId, bu.set(
          n,
          Su(
            bu.get(n) || null,
            l,
            t,
            e,
            a,
            u
          )
        ), !0;
    }
    return !1;
  }
  function Ed(l) {
    var t = Ve(l.target);
    if (t !== null) {
      var e = Q(t);
      if (e !== null) {
        if (t = e.tag, t === 13) {
          if (t = W(e), t !== null) {
            l.blockedOn = t, Hf(l.priority, function() {
              bd(e);
            });
            return;
          }
        } else if (t === 31) {
          if (t = Z(e), t !== null) {
            l.blockedOn = t, Hf(l.priority, function() {
              bd(e);
            });
            return;
          }
        } else if (t === 3 && e.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = e.tag === 3 ? e.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Xn(l) {
    if (l.blockedOn !== null) return !1;
    for (var t = l.targetContainers; 0 < t.length; ) {
      var e = rf(l.nativeEvent);
      if (e === null) {
        e = l.nativeEvent;
        var a = new e.constructor(
          e.type,
          e
        );
        rc = a, e.target.dispatchEvent(a), rc = null;
      } else
        return t = Ke(e), t !== null && gd(t), l.blockedOn = e, !1;
      t.shift();
    }
    return !0;
  }
  function zd(l, t, e) {
    Xn(l) && e.delete(t);
  }
  function ov() {
    mf = !1, be !== null && Xn(be) && (be = null), Se !== null && Xn(Se) && (Se = null), pe !== null && Xn(pe) && (pe = null), gu.forEach(zd), bu.forEach(zd);
  }
  function Qn(l, t) {
    l.blockedOn === t && (l.blockedOn = null, mf || (mf = !0, d.unstable_scheduleCallback(
      d.unstable_NormalPriority,
      ov
    )));
  }
  var Zn = null;
  function Ad(l) {
    Zn !== l && (Zn = l, d.unstable_scheduleCallback(
      d.unstable_NormalPriority,
      function() {
        Zn === l && (Zn = null);
        for (var t = 0; t < l.length; t += 3) {
          var e = l[t], a = l[t + 1], u = l[t + 2];
          if (typeof a != "function") {
            if (df(a || e) === null)
              continue;
            break;
          }
          var n = Ke(e);
          n !== null && (l.splice(t, 3), t -= 3, oi(
            n,
            {
              pending: !0,
              data: u,
              method: e.method,
              action: a
            },
            a,
            u
          ));
        }
      }
    ));
  }
  function xa(l) {
    function t(f) {
      return Qn(f, l);
    }
    be !== null && Qn(be, l), Se !== null && Qn(Se, l), pe !== null && Qn(pe, l), gu.forEach(t), bu.forEach(t);
    for (var e = 0; e < Ee.length; e++) {
      var a = Ee[e];
      a.blockedOn === l && (a.blockedOn = null);
    }
    for (; 0 < Ee.length && (e = Ee[0], e.blockedOn === null); )
      Ed(e), e.blockedOn === null && Ee.shift();
    if (e = (l.ownerDocument || l).$$reactFormReplay, e != null)
      for (a = 0; a < e.length; a += 3) {
        var u = e[a], n = e[a + 1], c = u[Il] || null;
        if (typeof n == "function")
          c || Ad(e);
        else if (c) {
          var i = null;
          if (n && n.hasAttribute("formAction")) {
            if (u = n, c = n[Il] || null)
              i = c.formAction;
            else if (df(u) !== null) continue;
          } else i = c.action;
          typeof i == "function" ? e[a + 1] = i : (e.splice(a, 3), a -= 3), Ad(e);
        }
      }
  }
  function Td() {
    function l(n) {
      n.canIntercept && n.info === "react-transition" && n.intercept({
        handler: function() {
          return new Promise(function(c) {
            return u = c;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      u !== null && (u(), u = null), a || setTimeout(e, 20);
    }
    function e() {
      if (!a && !navigation.transition) {
        var n = navigation.currentEntry;
        n && n.url != null && navigation.navigate(n.url, {
          state: n.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, u = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(e, 100), function() {
        a = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), u !== null && (u(), u = null);
      };
    }
  }
  function hf(l) {
    this._internalRoot = l;
  }
  Ln.prototype.render = hf.prototype.render = function(l) {
    var t = this._internalRoot;
    if (t === null) throw Error(r(409));
    var e = t.current, a = ht();
    vd(e, a, l, t, null, null);
  }, Ln.prototype.unmount = hf.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var t = l.containerInfo;
      vd(l.current, 2, null, l, null, null), An(), t[Le] = null;
    }
  };
  function Ln(l) {
    this._internalRoot = l;
  }
  Ln.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var t = Cf();
      l = { blockedOn: null, target: l, priority: t };
      for (var e = 0; e < Ee.length && t !== 0 && t < Ee[e].priority; e++) ;
      Ee.splice(e, 0, l), e === 0 && Ed(l);
    }
  };
  var _d = _.version;
  if (_d !== "19.2.8")
    throw Error(
      r(
        527,
        _d,
        "19.2.8"
      )
    );
  O.findDOMNode = function(l) {
    var t = l._reactInternals;
    if (t === void 0)
      throw typeof l.render == "function" ? Error(r(188)) : (l = Object.keys(l).join(","), Error(r(268, l)));
    return l = S(t), l = l !== null ? B(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var rv = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: E,
    reconcilerVersion: "19.2.8"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Vn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Vn.isDisabled && Vn.supportsFiber)
      try {
        Oa = Vn.inject(
          rv
        ), ct = Vn;
      } catch {
      }
  }
  return Eu.createRoot = function(l, t) {
    if (!C(l)) throw Error(r(299));
    var e = !1, a = "", u = jo, n = Co, c = Ho;
    return t != null && (t.unstable_strictMode === !0 && (e = !0), t.identifierPrefix !== void 0 && (a = t.identifierPrefix), t.onUncaughtError !== void 0 && (u = t.onUncaughtError), t.onCaughtError !== void 0 && (n = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = md(
      l,
      1,
      !1,
      null,
      null,
      e,
      a,
      null,
      u,
      n,
      c,
      Td
    ), l[Le] = t.current, $i(l), new hf(t);
  }, Eu.hydrateRoot = function(l, t, e) {
    if (!C(l)) throw Error(r(299));
    var a = !1, u = "", n = jo, c = Co, i = Ho, f = null;
    return e != null && (e.unstable_strictMode === !0 && (a = !0), e.identifierPrefix !== void 0 && (u = e.identifierPrefix), e.onUncaughtError !== void 0 && (n = e.onUncaughtError), e.onCaughtError !== void 0 && (c = e.onCaughtError), e.onRecoverableError !== void 0 && (i = e.onRecoverableError), e.formState !== void 0 && (f = e.formState)), t = md(
      l,
      1,
      !0,
      t,
      e ?? null,
      a,
      u,
      f,
      n,
      c,
      i,
      Td
    ), t.context = hd(null), e = t.current, a = ht(), a = ac(a), u = ce(a), u.callback = null, ie(e, u, a), e = a, t.current.lanes = e, Da(t, e), jt(t), l[Le] = t.current, $i(l), new Ln(t);
  }, Eu.version = "19.2.8", Eu;
}
var Rd;
function Ev() {
  if (Rd) return yf.exports;
  Rd = 1;
  function d() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(d);
      } catch (_) {
        console.error(_);
      }
  }
  return d(), yf.exports = pv(), yf.exports;
}
var _u = Ev(), ol = Af();
function zv({
  apiUrl: d,
  heading: _,
  limit: D
}) {
  const [r, C] = ol.useState([]), [Q, W] = ol.useState(null), [Z, x] = ol.useState(!0);
  return ol.useEffect(() => {
    const S = new AbortController();
    async function B() {
      x(!0), W(null);
      try {
        const M = await fetch(
          `${d.replace(/\/$/, "")}/storefront/products?limit=${D}`,
          {
            signal: S.signal
          }
        );
        if (!M.ok)
          throw new Error(`API returned ${M.status}`);
        const K = await M.json();
        C(K.slice(0, D));
      } catch (M) {
        if (M instanceof DOMException && M.name === "AbortError")
          return;
        W(
          M instanceof Error ? M.message : "Unable to reach the API"
        );
      } finally {
        S.signal.aborted || x(!1);
      }
    }
    return B(), () => S.abort();
  }, [d, D]), /* @__PURE__ */ b.jsxs("section", { className: "motech-api-demo", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "motech-api-demo__header", children: [
      /* @__PURE__ */ b.jsxs("div", { children: [
        /* @__PURE__ */ b.jsx("p", { className: "motech-api-demo__eyebrow", children: "React + Motech API" }),
        /* @__PURE__ */ b.jsx("h2", { children: _ })
      ] }),
      /* @__PURE__ */ b.jsx("span", { className: `motech-api-demo__status ${Q ? "is-error" : ""}`, children: Z ? "Connecting" : Q ? "Offline" : "API connected" })
    ] }),
    Z && /* @__PURE__ */ b.jsx("p", { className: "motech-api-demo__message", children: "Loading products from the database…" }),
    Q && /* @__PURE__ */ b.jsxs("div", { className: "motech-api-demo__message is-error", children: [
      /* @__PURE__ */ b.jsx("strong", { children: "Could not load products." }),
      /* @__PURE__ */ b.jsxs("span", { children: [
        Q,
        ". Check the section API URL and that the API is running."
      ] })
    ] }),
    !Z && !Q && r.length === 0 && /* @__PURE__ */ b.jsx("p", { className: "motech-api-demo__message", children: "The API connected, but there are no active products." }),
    /* @__PURE__ */ b.jsx("div", { className: "motech-api-demo__grid", children: r.map((S) => /* @__PURE__ */ b.jsxs(
      "article",
      {
        className: "motech-api-demo__card",
        children: [
          /* @__PURE__ */ b.jsx("div", { className: "motech-api-demo__image", children: S.image ? /* @__PURE__ */ b.jsx(
            "img",
            {
              src: S.image.url,
              alt: S.image.altText ?? S.title
            }
          ) : /* @__PURE__ */ b.jsx("span", { children: "No image" }) }),
          /* @__PURE__ */ b.jsx("p", { children: S.brand || S.category || "Product" }),
          /* @__PURE__ */ b.jsx("h3", { children: S.title }),
          /* @__PURE__ */ b.jsxs("small", { children: [
            S.totalInventory,
            " in local inventory"
          ] })
        ]
      },
      S.shopifyProductId
    )) })
  ] });
}
const Zd = "motech:garage:vehicle", zu = "motech:garage-updated", qd = {
  version: 1,
  vehicles: [],
  activeGenerationId: null
};
function Ze() {
  try {
    const d = localStorage.getItem(Zd);
    if (!d) return qd;
    const _ = JSON.parse(d);
    if ("vehicles" in _ && Array.isArray(_.vehicles)) return _;
    if ("generation" in _ && _.generation?.id)
      return {
        version: 1,
        vehicles: [_],
        activeGenerationId: _.generation.id
      };
  } catch {
  }
  return qd;
}
function Au(d) {
  localStorage.setItem(Zd, JSON.stringify(d)), window.dispatchEvent(
    new CustomEvent(zu, { detail: d })
  );
}
function wn(d) {
  return d.vehicles.find(
    (_) => $n(_) === d.activeGenerationId
  ) ?? null;
}
function $n(d) {
  return d.specification?.id ?? d.generation.id;
}
function Av(d) {
  return d.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
function Tv(d) {
  if (d.specification?.shopifyCollectionHandle)
    return d.specification.shopifyCollectionHandle;
  if (d.generation.shopifyCollectionHandle)
    return d.generation.shopifyCollectionHandle;
  const _ = d.generation.code || d.generation.name;
  return [d.make.slug, d.model.slug, _].map(Av).filter(Boolean).join("-");
}
function kn(d) {
  return `/collections/${Tv(d)}`;
}
function Tu(d) {
  d && window.dispatchEvent(
    new CustomEvent("motech:vehicle-selected", {
      detail: {
        make: d.make,
        model: d.model,
        generation: d.generation
      }
    })
  );
}
const Bd = "motech:analytics:session";
function _v() {
  try {
    const d = localStorage.getItem(Bd);
    if (d) return d;
    const _ = crypto.randomUUID();
    return localStorage.setItem(Bd, _), _;
  } catch {
    return;
  }
}
function xv(d, _, D = "selector") {
  const r = _.specification?.id;
  r && fetch(`${d.replace(/\/$/, "")}/storefront/analytics/vehicle-selection`, {
    method: "POST",
    keepalive: !0,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      vehicleId: r,
      sessionId: _v(),
      source: D
    })
  }).catch(() => {
  });
}
function Yd(d, _) {
  const D = d.code?.trim() ?? "", r = d.name.trim(), C = D && !r.toLowerCase().startsWith(D.toLowerCase()) ? `${D} ${r}` : r;
  return [
    C,
    _.trim && !C.toLowerCase().includes(_.trim.toLowerCase()) ? _.trim : null
  ].filter(Boolean).join(" ");
}
function Mv(d) {
  return `${window.location.pathname.match(
    /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i
  )?.[0] ?? ""}${kn(d)}`;
}
function Ov({ apiUrl: d, heading: _, subheading: D }) {
  const [r, C] = ol.useState([]), [Q, W] = ol.useState(""), [Z, x] = ol.useState(""), [S, B] = ol.useState(""), [M, K] = ol.useState(!0), [X, R] = ol.useState(null), [ll, fl] = ol.useState(!1);
  ol.useEffect(() => {
    const $ = new AbortController();
    async function Bl() {
      try {
        const Tl = await fetch(
          `${d.replace(/\/$/, "")}/storefront/vehicle-catalogue`,
          {
            signal: $.signal
          }
        );
        if (!Tl.ok) throw new Error(`API returned ${Tl.status}`);
        C(await Tl.json());
      } catch (Tl) {
        if (Tl instanceof DOMException && Tl.name === "AbortError")
          return;
        R(
          Tl instanceof Error ? Tl.message : "Unable to load vehicles"
        );
      } finally {
        $.signal.aborted || K(!1);
      }
    }
    return Bl(), () => $.abort();
  }, [d]);
  const ul = ol.useMemo(
    () => r.find(($) => $.id === Q),
    [r, Q]
  ), Rl = ul?.models ?? [], ml = Rl.find(($) => $.id === Z), $l = (ml?.generations ?? []).flatMap(
    ($) => $.vehicles.map((Bl) => ({
      generation: $,
      specification: Bl
    }))
  ), Ql = $l.find(
    ({ specification: $ }) => $.id === S
  ), L = Ql?.generation, zl = Ql?.specification;
  ol.useEffect(() => {
    !L || !ul || !ml || window.dispatchEvent(
      new CustomEvent("motech:vehicle-selected", {
        detail: {
          make: ul,
          model: ml,
          generation: L,
          specification: zl
        }
      })
    );
  }, [L, ul, ml, zl]);
  function vt() {
    if (!L || !zl || !ul || !ml)
      return;
    const $ = {
      make: ul,
      model: ml,
      generation: L,
      specification: zl,
      savedAt: (/* @__PURE__ */ new Date()).toISOString()
    }, Tl = [
      ...Ze().vehicles.filter(
        (E) => (E.specification?.id ?? E.generation.id) !== zl.id
      ),
      $
    ];
    Au({
      version: 1,
      vehicles: Tl,
      activeGenerationId: zl.id
    }), fl(!0), Tu($), xv(d, $), window.location.assign(Mv($));
  }
  function Ft() {
    W(""), x(""), B(""), fl(!1);
  }
  const Fl = "h-14 w-full cursor-pointer appearance-none rounded-[var(--button-border-radius)] border border-[rgb(var(--border-color))] bg-[rgb(var(--background))] px-4 pr-11 text-sm text-[rgb(var(--text-color))] transition-colors hover:border-[rgb(var(--border-color-darker))] focus:border-[rgb(var(--text-color))] focus:outline-none disabled:cursor-not-allowed disabled:opacity-45", ql = () => /* @__PURE__ */ b.jsx(
    "svg",
    {
      "aria-hidden": "true",
      className: "pointer-events-none absolute right-4 top-1/2 size-3 -translate-y-1/2 text-[rgb(var(--text-color))]",
      viewBox: "0 0 10 6",
      fill: "none",
      children: /* @__PURE__ */ b.jsx("path", { d: "m1 1 4 4 4-4", stroke: "currentColor", strokeWidth: "1.5" })
    }
  );
  return /* @__PURE__ */ b.jsx("section", { className: "motech-car-selector isolate w-full bg-[rgb(var(--secondary-background))] py-7 text-[rgb(var(--text-color))] sm:py-9", children: /* @__PURE__ */ b.jsxs("div", { className: "w-full px-[var(--container-gutter)] xl:grid xl:grid-cols-[260px_minmax(0,1fr)] xl:items-end xl:gap-10", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "mb-6 text-left xl:mb-0", children: [
      /* @__PURE__ */ b.jsx("p", { className: "mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-[rgb(var(--text-color))] opacity-60", children: "Vehicle finder" }),
      /* @__PURE__ */ b.jsx("h2", { className: "[font-family:var(--heading-font-family)] text-xl font-[var(--heading-font-weight)] uppercase tracking-[var(--heading-letter-spacing)] text-[rgb(var(--heading-color))] sm:text-2xl", children: _ }),
      D && /* @__PURE__ */ b.jsx("p", { className: "mt-2 max-w-md text-sm leading-5 opacity-70", children: D })
    ] }),
    X ? /* @__PURE__ */ b.jsxs("div", { className: "flex flex-col gap-1 rounded-[var(--block-border-radius-reduced)] border border-[rgb(var(--error-color))] bg-[rgb(var(--error-background))] p-5 text-sm text-[rgb(var(--error-color))]", children: [
      /* @__PURE__ */ b.jsx("strong", { className: "font-bold", children: "Could not load the vehicle catalogue." }),
      /* @__PURE__ */ b.jsxs("span", { children: [
        X,
        ". Check that the API is running."
      ] })
    ] }) : /* @__PURE__ */ b.jsxs("div", { className: "grid gap-3 md:grid-cols-3 lg:grid-cols-[1fr_1fr_1fr_auto] lg:items-end", children: [
      /* @__PURE__ */ b.jsxs("label", { className: "block min-w-0", children: [
        /* @__PURE__ */ b.jsx("span", { className: "mb-2 block text-[11px] font-bold uppercase tracking-[0.14em] opacity-65", children: "01 — Make" }),
        /* @__PURE__ */ b.jsxs("span", { className: "relative block", children: [
          /* @__PURE__ */ b.jsxs(
            "select",
            {
              className: Fl,
              value: Q,
              disabled: M,
              onChange: ($) => {
                W($.target.value), x(""), B(""), fl(!1);
              },
              children: [
                /* @__PURE__ */ b.jsx("option", { value: "", children: M ? "Loading makes…" : "Choose a make" }),
                r.map(($) => /* @__PURE__ */ b.jsx("option", { value: $.id, children: $.name }, $.id))
              ]
            }
          ),
          /* @__PURE__ */ b.jsx(ql, {})
        ] })
      ] }),
      /* @__PURE__ */ b.jsxs("label", { className: "block min-w-0", children: [
        /* @__PURE__ */ b.jsx("span", { className: "mb-2 block text-[11px] font-bold uppercase tracking-[0.14em] opacity-65", children: "02 — Model" }),
        /* @__PURE__ */ b.jsxs("span", { className: "relative block", children: [
          /* @__PURE__ */ b.jsxs(
            "select",
            {
              className: Fl,
              value: Z,
              disabled: !Q,
              onChange: ($) => {
                x($.target.value), B(""), fl(!1);
              },
              children: [
                /* @__PURE__ */ b.jsx("option", { value: "", children: "Choose a model" }),
                Rl.map(($) => /* @__PURE__ */ b.jsx("option", { value: $.id, children: $.name }, $.id))
              ]
            }
          ),
          /* @__PURE__ */ b.jsx(ql, {})
        ] })
      ] }),
      /* @__PURE__ */ b.jsxs("label", { className: "block min-w-0", children: [
        /* @__PURE__ */ b.jsx("span", { className: "mb-2 block text-[11px] font-bold uppercase tracking-[0.14em] opacity-65", children: "03 — Generation" }),
        /* @__PURE__ */ b.jsxs("span", { className: "relative block", children: [
          /* @__PURE__ */ b.jsxs(
            "select",
            {
              className: Fl,
              value: S,
              disabled: !Z,
              onChange: ($) => {
                B($.target.value), fl(!1);
              },
              children: [
                /* @__PURE__ */ b.jsx("option", { value: "", children: "Choose a generation" }),
                $l.map(({ generation: $, specification: Bl }) => /* @__PURE__ */ b.jsx("option", { value: Bl.id, children: Yd($, Bl) }, Bl.id))
              ]
            }
          ),
          /* @__PURE__ */ b.jsx(ql, {})
        ] })
      ] }),
      /* @__PURE__ */ b.jsx(
        "button",
        {
          className: "h-14 w-full whitespace-nowrap rounded-[var(--button-border-radius)] bg-[rgb(var(--primary-button-background))] px-7 text-xs font-bold uppercase tracking-[0.14em] text-[rgb(var(--primary-button-text-color))] transition-opacity hover:opacity-85 disabled:cursor-not-allowed disabled:opacity-40 lg:w-auto",
          type: "button",
          disabled: !zl,
          onClick: vt,
          children: ll ? "SAVED TO GARAGE" : "SAVE TO MY GARAGE"
        }
      )
    ] }),
    L && ul && ml && /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: "mt-3 flex flex-col items-start gap-1 rounded-[var(--block-border-radius-reduced)] border border-[rgb(var(--border-color))] bg-[rgb(var(--background))] px-4 py-3 sm:flex-row sm:items-center sm:gap-3 xl:col-span-2 xl:col-start-1",
        "aria-live": "polite",
        children: [
          /* @__PURE__ */ b.jsx("span", { className: "text-[10px] font-bold uppercase tracking-[0.16em] opacity-70", children: "Your vehicle" }),
          /* @__PURE__ */ b.jsxs("strong", { className: "[font-family:var(--heading-font-family)] text-base font-[var(--heading-font-weight)] uppercase tracking-wide", children: [
            ul.name,
            " ",
            ml.name
          ] }),
          /* @__PURE__ */ b.jsx("small", { className: "text-xs opacity-75 sm:ml-auto", children: zl ? Yd(
            L,
            zl
          ) : L.name }),
          /* @__PURE__ */ b.jsx(
            "button",
            {
              className: "mt-2 text-[10px] font-bold uppercase tracking-[0.14em] underline underline-offset-4 opacity-65 hover:opacity-100 sm:ml-3 sm:mt-0",
              type: "button",
              onClick: Ft,
              children: "Change vehicle"
            }
          )
        ]
      }
    )
  ] }) });
}
function Kn(d) {
  return `${d.make.name} ${d.model.name}`;
}
function Gd(d) {
  return `${window.location.pathname.match(
    /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i
  )?.[0] ?? ""}${kn(d)}`;
}
function Nv({
  selectorUrl: d = "/"
}) {
  const [_, D] = ol.useState(() => Ze()), [r, C] = ol.useState(!1), [Q, W] = ol.useState(72), Z = ol.useRef(null), x = ol.useRef(null), S = wn(_);
  ol.useEffect(() => {
    const X = (fl) => {
      D(fl.detail ?? Ze());
    }, R = () => D(Ze()), ll = (fl) => {
      Z.current?.contains(fl.target) || C(!1);
    };
    return window.addEventListener(zu, X), window.addEventListener("storage", R), document.addEventListener("mousedown", ll), () => {
      window.removeEventListener(zu, X), window.removeEventListener("storage", R), document.removeEventListener("mousedown", ll);
    };
  }, []), ol.useEffect(() => {
    if (!r) return;
    const X = () => {
      const R = x.current?.getBoundingClientRect().bottom;
      R !== void 0 && W(R + 8);
    };
    return X(), window.addEventListener("resize", X), window.addEventListener("scroll", X, !0), () => {
      window.removeEventListener("resize", X), window.removeEventListener("scroll", X, !0);
    };
  }, [r]);
  function B(X) {
    const R = { ..._, activeGenerationId: X }, ll = wn(R);
    Au(R), Tu(ll), C(!1), ll && window.location.assign(Gd(ll));
  }
  function M(X) {
    const R = _.vehicles.filter(
      (ul) => $n(ul) !== X
    ), ll = _.activeGenerationId === X ? R[0] ? $n(R[0]) : null : _.activeGenerationId, fl = { ..._, vehicles: R, activeGenerationId: ll };
    Au(fl), Tu(wn(fl));
  }
  function K() {
    C(!1);
    const X = document.querySelector("[data-motech-car-selector]");
    X ? X.scrollIntoView({ behavior: "smooth", block: "center" }) : window.location.assign(d);
  }
  return /* @__PURE__ */ b.jsxs("div", { ref: Z, className: "relative flex", children: [
    /* @__PURE__ */ b.jsxs(
      "button",
      {
        ref: x,
        type: "button",
        className: "relative flex h-11 items-center gap-2 border border-[rgba(var(--header-text-color),0.2)] px-3 text-[rgb(var(--header-text-color))] transition-colors hover:border-[rgba(var(--header-text-color),0.55)]",
        "aria-label": "My garage",
        "aria-expanded": r,
        onClick: () => C((X) => !X),
        children: [
          /* @__PURE__ */ b.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: "h-5 w-6",
              viewBox: "0 0 28 22",
              fill: "none",
              children: [
                /* @__PURE__ */ b.jsx(
                  "path",
                  {
                    d: "M4.5 14.5 6.8 8.8A3 3 0 0 1 9.6 7h8.8a3 3 0 0 1 2.8 1.8l2.3 5.7M3 14.5h22v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4Z",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinejoin: "round"
                  }
                ),
                /* @__PURE__ */ b.jsx(
                  "path",
                  {
                    d: "M7 17.5h2m10 0h2M7.5 7 9 3.5h10L20.5 7",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinecap: "round"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ b.jsxs("span", { className: "hidden max-w-36 text-left lg:block", children: [
            /* @__PURE__ */ b.jsx("span", { className: "block text-[8px] font-bold uppercase leading-none tracking-[0.16em] opacity-55", children: S ? "My vehicle" : "My garage" }),
            /* @__PURE__ */ b.jsx("span", { className: "mt-1 block truncate text-[10px] font-bold uppercase leading-none tracking-wide", children: S ? Kn(S) : "Add a vehicle" })
          ] }),
          _.vehicles.length > 0 && /* @__PURE__ */ b.jsx("span", { className: "absolute -right-1.5 -top-1.5 flex min-h-4 min-w-4 items-center justify-center rounded-full bg-[rgb(var(--primary-button-background))] px-1 text-[9px] font-bold leading-4 text-[rgb(var(--primary-button-text-color))]", children: _.vehicles.length })
        ]
      }
    ),
    r && /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: "motech-garage-panel z-[60] border border-[rgb(var(--border-color))] bg-[rgb(var(--background))] p-4 text-[rgb(var(--text-color))] shadow-2xl",
        style: { "--motech-garage-panel-top": `${Q}px` },
        children: [
          /* @__PURE__ */ b.jsxs("div", { className: "mb-3 flex items-center justify-between", children: [
            /* @__PURE__ */ b.jsx("h2", { className: "[font-family:var(--heading-font-family)] text-sm font-[var(--heading-font-weight)] uppercase tracking-[0.12em] text-[rgb(var(--heading-color))]", children: "My garage" }),
            /* @__PURE__ */ b.jsxs("span", { className: "text-[10px] uppercase tracking-widest opacity-55", children: [
              _.vehicles.length,
              " ",
              _.vehicles.length === 1 ? "car" : "cars"
            ] })
          ] }),
          _.vehicles.length === 0 ? /* @__PURE__ */ b.jsx("p", { className: "border-y border-[rgb(var(--border-color))] py-5 text-sm opacity-65", children: "No vehicles saved yet." }) : /* @__PURE__ */ b.jsx("ul", { className: "divide-y divide-[rgb(var(--border-color))] border-y border-[rgb(var(--border-color))]", children: _.vehicles.map((X) => {
            const R = $n(X), ll = R === _.activeGenerationId;
            return /* @__PURE__ */ b.jsxs("li", { className: "flex items-center gap-3 py-3", children: [
              /* @__PURE__ */ b.jsxs(
                "button",
                {
                  type: "button",
                  className: "min-w-0 flex-1 text-left",
                  onClick: () => B(R),
                  children: [
                    /* @__PURE__ */ b.jsxs("span", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ b.jsx("strong", { className: "truncate text-xs uppercase tracking-wide", children: Kn(X) }),
                      ll && /* @__PURE__ */ b.jsx("span", { className: "bg-[rgb(var(--primary-button-background))] px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-[rgb(var(--primary-button-text-color))]", children: "Active" })
                    ] }),
                    /* @__PURE__ */ b.jsx("span", { className: "mt-1 block truncate text-[11px] opacity-60", children: [
                      X.generation.name,
                      X.generation.code,
                      X.specification?.trim,
                      X.specification?.engineDisplacement
                    ].filter(Boolean).join(" · ") })
                  ]
                }
              ),
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  type: "button",
                  className: "p-2 text-[10px] uppercase tracking-wider opacity-50 hover:opacity-100",
                  "aria-label": `Remove ${Kn(X)}`,
                  onClick: () => M(R),
                  children: "Remove"
                }
              )
            ] }, R);
          }) }),
          /* @__PURE__ */ b.jsx(
            "button",
            {
              type: "button",
              className: "mt-4 h-10 w-full rounded-[var(--button-border-radius)] bg-[rgb(var(--primary-button-background))] px-4 text-[10px] font-bold uppercase tracking-[0.14em] text-[rgb(var(--primary-button-text-color))] hover:opacity-85",
              onClick: K,
              children: "Add another vehicle"
            }
          ),
          S && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
            /* @__PURE__ */ b.jsx(
              "a",
              {
                href: Gd(S),
                className: "mt-3 flex h-10 w-full items-center justify-center border border-[rgb(var(--border-color))] px-4 text-[10px] font-bold uppercase tracking-[0.14em] text-[rgb(var(--heading-color))] hover:border-[rgb(var(--heading-color))]",
                children: "Shop compatible parts"
              }
            ),
            /* @__PURE__ */ b.jsxs("p", { className: "mt-3 truncate text-center text-[10px] uppercase tracking-wider opacity-55", children: [
              "Shopping for ",
              Kn(S)
            ] })
          ] })
        ]
      }
    )
  ] });
}
const zf = "/collections/all", Xd = "[data-motech-clear-vehicle-filter-menu]";
function Ef(d) {
  return `${window.location.pathname.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i)?.[0] ?? ""}${d}`;
}
function Dv(d) {
  const _ = new URL(d.href, window.location.origin);
  return _.origin === window.location.origin && _.pathname.replace(/\/$/, "").endsWith(zf);
}
function Uv({ pageType: d }) {
  const [_, D] = ol.useState(() => Ze()), r = wn(_), C = window.location.pathname.replace(/\/$/, ""), Q = d === "collection" || d === "search", W = d === "search" || d === "collection" && C.endsWith(zf);
  if (ol.useEffect(() => {
    const x = (S) => D(S.detail ?? Ze());
    return window.addEventListener(zu, x), () => window.removeEventListener(zu, x);
  }, []), ol.useEffect(() => {
    const x = /* @__PURE__ */ new Set(), S = () => {
      document.querySelectorAll("a[href]").forEach((M) => {
        if (M.closest(Xd)) return;
        const K = M.dataset.motechCatalogHref ?? M.getAttribute("href");
        !K || !Dv(M) || (M.dataset.motechCatalogHref || (M.dataset.motechCatalogHref = K), M.setAttribute(
          "href",
          r ? Ef(kn(r)) : K
        ), x.add(M));
      });
    };
    S();
    const B = new MutationObserver(S);
    return B.observe(document.body, { childList: !0, subtree: !0 }), () => {
      B.disconnect(), x.forEach((M) => {
        const K = M.dataset.motechCatalogHref;
        K && (M.setAttribute("href", K), delete M.dataset.motechCatalogHref);
      });
    };
  }, [r]), ol.useEffect(() => {
    const x = (S) => {
      const B = S.target;
      if (!(B instanceof Element) || !B.closest(
        `${Xd} a[href]`
      )) return;
      const K = Ze();
      K.activeGenerationId !== null && (Au({ ...K, activeGenerationId: null }), Tu(null));
    };
    return document.addEventListener("click", x, !0), () => document.removeEventListener("click", x, !0);
  }, []), ol.useEffect(() => {
    if (!W || !r) return;
    const x = Ef(kn(r));
    window.location.pathname.replace(/\/$/, "") !== x && window.location.assign(x);
  }, [r, W]), !Q || !r) return null;
  function Z() {
    const x = { ..._, activeGenerationId: null };
    Au(x), Tu(null), W && window.location.assign(Ef(zf));
  }
  return /* @__PURE__ */ b.jsx("div", { className: "motech-compatibility-banner border-y border-[rgb(var(--border-color))] bg-[rgb(var(--secondary-background))] px-[var(--container-gutter)] py-3 text-[rgb(var(--text-color))] shadow-sm sm:py-3.5", children: /* @__PURE__ */ b.jsxs("div", { className: "flex items-center gap-3 sm:gap-4", children: [
    /* @__PURE__ */ b.jsx("span", { className: "flex size-10 shrink-0 items-center justify-center rounded-[var(--button-border-radius)] bg-[rgb(var(--primary-button-background))] text-[rgb(var(--primary-button-text-color))] sm:size-11", children: /* @__PURE__ */ b.jsxs("svg", { "aria-hidden": "true", className: "h-4 w-6", viewBox: "0 0 28 22", fill: "none", children: [
      /* @__PURE__ */ b.jsx("path", { d: "M4.5 14.5 6.8 8.8A3 3 0 0 1 9.6 7h8.8a3 3 0 0 1 2.8 1.8l2.3 5.7M3 14.5h22v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }),
      /* @__PURE__ */ b.jsx("path", { d: "M7 17.5h2m10 0h2M7.5 7 9 3.5h10L20.5 7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })
    ] }) }),
    /* @__PURE__ */ b.jsxs("span", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ b.jsx("span", { className: "block text-[9px] font-bold uppercase leading-none tracking-[0.16em] opacity-60 sm:text-[10px]", children: "Showing parts for" }),
      /* @__PURE__ */ b.jsxs("strong", { className: "mt-1.5 block truncate [font-family:var(--heading-font-family)] text-sm uppercase leading-none tracking-wide text-[rgb(var(--heading-color))] sm:text-base", children: [
        r.make.name,
        " ",
        r.model.name,
        " ",
        r.generation.name
      ] })
    ] }),
    /* @__PURE__ */ b.jsxs(
      "button",
      {
        type: "button",
        className: "flex h-10 shrink-0 items-center gap-2 rounded-[var(--button-border-radius)] border border-[rgb(var(--heading-color))] px-3 text-[9px] font-bold uppercase tracking-[0.12em] text-[rgb(var(--heading-color))] transition-colors hover:bg-[rgb(var(--heading-color))] hover:text-[rgb(var(--background))] sm:px-4 sm:text-[10px]",
        onClick: Z,
        children: [
          /* @__PURE__ */ b.jsx("svg", { "aria-hidden": "true", className: "size-3", viewBox: "0 0 12 12", fill: "none", children: /* @__PURE__ */ b.jsx("path", { d: "m2 2 8 8m0-8-8 8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }) }),
          /* @__PURE__ */ b.jsx("span", { className: "hidden min-[360px]:inline", children: "Clear filter" })
        ]
      }
    )
  ] }) });
}
function jv(d, _) {
  if (!d.options.some((D) => !_[D.name]))
    return d.variants.find(
      (D) => d.options.every(
        (r, C) => D.options[C] === _[r.name]
      )
    );
}
function Cv(d, _, D) {
  const r = d.options.findIndex((C) => C.name === _);
  return r < 0 ? /* @__PURE__ */ new Set() : new Set(
    d.variants.filter((C) => C.available ? d.options.every((Q, W) => {
      if (Q.name === _) return !0;
      const Z = D[Q.name];
      return !Z || C.options[W] === Z;
    }) : !1).map((C) => C.options[r])
  );
}
function Qd(d, _) {
  const D = [];
  for (const r of d.components) {
    const C = jv(r, _[String(r.id)] ?? {});
    if (!C?.available) return null;
    D.push({ component: r, variant: C });
  }
  return D;
}
function Hv(d) {
  return d.reduce(
    (_, { component: D, variant: r }) => _ + r.price * D.quantity,
    0
  );
}
function Rv(d, _) {
  return d.pricing ? d.pricing.type === "FIXED_DISCOUNT" ? Math.min(_, Math.max(0, Math.round(d.pricing.value * 100))) : Math.min(_, Math.max(0, Math.round(_ * d.pricing.value / 100))) : 0;
}
function qv() {
  return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : `bundle-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function Bv(d, _, D) {
  return _.map(({ component: r, variant: C }) => ({
    id: C.id,
    quantity: r.quantity,
    properties: {
      _motech_bundle_id: d.handle,
      _motech_bundle_key: d.handle,
      _motech_bundle_instance: D,
      _motech_bundle_role: r.role,
      _motech_bundle_parent_variant: `gid://shopify/ProductVariant/${d.parentVariantId}`,
      _motech_bundle_title: d.title
    }
  }));
}
function Yv({
  component: d,
  optionName: _,
  selections: D,
  onChange: r
}) {
  const C = d.options.find((Z) => Z.name === _);
  if (!C) return null;
  const Q = Cv(d, _, D), W = `bundle-${d.id}-${C.position}`;
  return /* @__PURE__ */ b.jsxs("label", { className: "motech-bundle-option", htmlFor: W, children: [
    /* @__PURE__ */ b.jsx("span", { className: "motech-bundle-option__label", children: C.name }),
    /* @__PURE__ */ b.jsxs("span", { className: "motech-bundle-option__select-wrap", children: [
      /* @__PURE__ */ b.jsxs(
        "select",
        {
          id: W,
          value: D[C.name] ?? "",
          onChange: (Z) => r(Z.target.value),
          children: [
            /* @__PURE__ */ b.jsxs("option", { value: "", children: [
              "Choose ",
              C.name.toLowerCase()
            ] }),
            C.values.map((Z) => /* @__PURE__ */ b.jsx("option", { value: Z, disabled: !Q.has(Z), children: Z }, Z))
          ]
        }
      ),
      /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", children: "⌄" })
    ] })
  ] });
}
function Jn(d, _) {
  return new Intl.NumberFormat(document.documentElement.lang || "en-GB", {
    style: "currency",
    currency: _
  }).format(d / 100);
}
function Gv({ bundle: d }) {
  const _ = window.Shopify?.routes?.root ?? "/", [D, r] = ol.useState({}), [C, Q] = ol.useState("idle"), [W, Z] = ol.useState(""), x = ol.useMemo(() => Qd(d, D), [d, D]), S = x ? Hv(x) : null, B = S === null ? 0 : Rv(d, S), M = S === null ? null : S - B, K = (R, ll, fl) => {
    Q("idle"), Z(""), r((ul) => ({
      ...ul,
      [String(R)]: {
        ...ul[String(R)] ?? {},
        [ll]: fl
      }
    }));
  }, X = async () => {
    if (!(!x || C === "adding")) {
      Q("adding"), Z("");
      try {
        const R = window.Shopify?.routes?.root ?? "/", ll = window.themeVariables?.routes?.cartAddUrl ?? `${R}cart/add`, fl = window.themeVariables?.routes?.cartUrl ?? `${R}cart`, ul = await fetch(`${ll}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({
            items: Bv(d, x, qv()),
            sections: ["mini-cart"]
          })
        }), Rl = await ul.json();
        if (!ul.ok) throw new Error(Rl.description || "The package could not be added.");
        if (d.discountCode && B > 0) {
          const $l = `${R}discount/${encodeURIComponent(d.discountCode)}?redirect=${encodeURIComponent(fl)}`;
          window.location.assign($l);
          return;
        }
        const Xl = await (await fetch(`${fl}.js`)).json();
        Xl.sections = Rl.sections, document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: Xl } })
        ), document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: !0,
            detail: {
              cart: Xl,
              openMiniCart: window.themeVariables?.settings?.cartType === "drawer"
            }
          })
        ), document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: !0,
            detail: { status: "success", error: "" }
          })
        ), Q("added");
      } catch (R) {
        const ll = R instanceof Error ? R.message : "The package could not be added.";
        Z(ll), Q("error");
      }
    }
  };
  return d.components.length === 0 ? /* @__PURE__ */ b.jsx("p", { className: "motech-bundle-error", children: "This package is temporarily unavailable." }) : /* @__PURE__ */ b.jsxs("div", { className: "motech-bundle-configurator", children: [
    /* @__PURE__ */ b.jsxs("header", { className: "motech-bundle-header", children: [
      /* @__PURE__ */ b.jsxs("p", { className: "motech-bundle-kicker", children: [
        /* @__PURE__ */ b.jsx("span", {}),
        " Configure your package"
      ] }),
      /* @__PURE__ */ b.jsx("h1", { children: d.title }),
      /* @__PURE__ */ b.jsxs("p", { className: "motech-bundle-header__meta", children: [
        d.components.length,
        " matched components · genuine Shopify inventory"
      ] })
    ] }),
    /* @__PURE__ */ b.jsx("div", { className: "motech-bundle-components", children: d.components.map((R, ll) => {
      const fl = D[String(R.id)] ?? {}, ul = Qd(
        { ...d, components: [R] },
        { [String(R.id)]: fl }
      )?.[0]?.variant;
      return /* @__PURE__ */ b.jsxs("section", { className: "motech-bundle-component", children: [
        /* @__PURE__ */ b.jsxs("div", { className: "motech-bundle-component__heading", children: [
          /* @__PURE__ */ b.jsxs("span", { className: "motech-bundle-component__number", children: [
            "0",
            ll + 1
          ] }),
          /* @__PURE__ */ b.jsx(
            "a",
            {
              className: "motech-bundle-component__image",
              href: `${_}products/${R.handle}`,
              "aria-label": `View ${R.title}`,
              children: R.image ? /* @__PURE__ */ b.jsx("img", { src: R.image, alt: "", loading: "lazy" }) : /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", children: R.title.slice(0, 1) })
            }
          ),
          /* @__PURE__ */ b.jsxs("div", { className: "motech-bundle-component__details", children: [
            /* @__PURE__ */ b.jsx("p", { children: "Included component" }),
            /* @__PURE__ */ b.jsx("h2", { children: /* @__PURE__ */ b.jsx("a", { href: `${_}products/${R.handle}`, children: R.title }) })
          ] }),
          ul && /* @__PURE__ */ b.jsx("span", { className: "motech-bundle-component__price", children: Jn(ul.price * R.quantity, d.currencyCode) })
        ] }),
        /* @__PURE__ */ b.jsx("div", { className: "motech-bundle-component__options", children: R.options.map((Rl) => /* @__PURE__ */ b.jsx(
          Yv,
          {
            component: R,
            optionName: Rl.name,
            selections: fl,
            onChange: (ml) => K(R.id, Rl.name, ml)
          },
          Rl.name
        )) })
      ] }, R.id);
    }) }),
    /* @__PURE__ */ b.jsxs("footer", { className: "motech-bundle-summary", children: [
      /* @__PURE__ */ b.jsxs("div", { children: [
        /* @__PURE__ */ b.jsx("span", { children: x ? "Package price" : "Configure to see total" }),
        /* @__PURE__ */ b.jsxs("div", { className: "motech-bundle-summary__prices", "aria-live": "polite", children: [
          /* @__PURE__ */ b.jsx("strong", { children: M === null ? "—" : Jn(M, d.currencyCode) }),
          S !== null && B > 0 && /* @__PURE__ */ b.jsx("s", { children: Jn(S, d.currencyCode) })
        ] }),
        B > 0 && /* @__PURE__ */ b.jsxs("em", { children: [
          "You save ",
          Jn(B, d.currencyCode)
        ] })
      ] }),
      /* @__PURE__ */ b.jsx("button", { type: "button", disabled: !x || C === "adding", onClick: X, children: C === "adding" ? "Adding package…" : C === "added" ? "Package added" : "Add package to cart" })
    ] }),
    W && /* @__PURE__ */ b.jsx("p", { className: "motech-bundle-error", role: "alert", children: W })
  ] });
}
const Xv = "https://api.motech-performance.com", Qv = "https://api-production-478fd.up.railway.app";
function Ld(d) {
  const _ = d.dataset.apiUrl?.replace(/\/$/, "");
  return !_ || _ === Qv ? Xv : _;
}
document.querySelectorAll("[data-motech-api-demo]").forEach((d) => {
  const _ = Ld(d), D = d.dataset.heading ?? "Products from our API", r = Number.parseInt(d.dataset.limit ?? "3", 10);
  _u.createRoot(d).render(
    /* @__PURE__ */ b.jsx(zv, { apiUrl: _, heading: D, limit: Number.isNaN(r) ? 3 : r })
  );
});
document.querySelectorAll("[data-motech-car-selector]").forEach((d) => {
  const _ = Ld(d), D = d.dataset.heading ?? "Choose your vehicle", r = d.dataset.subheading ?? "Select your car to find parts made to fit.";
  _u.createRoot(d).render(/* @__PURE__ */ b.jsx(Ov, { apiUrl: _, heading: D, subheading: r }));
});
document.querySelectorAll("[data-motech-garage-dropdown]").forEach((d) => {
  _u.createRoot(d).render(
    /* @__PURE__ */ b.jsx(
      Nv,
      {
        selectorUrl: d.dataset.selectorUrl
      }
    )
  );
});
document.querySelectorAll("[data-motech-compatibility-filter]").forEach((d) => {
  _u.createRoot(d).render(
    /* @__PURE__ */ b.jsx(
      Uv,
      {
        pageType: d.dataset.pageType ?? ""
      }
    )
  );
});
document.querySelectorAll("[data-motech-bundle-configurator]").forEach((d) => {
  const _ = d.querySelector("[data-motech-bundle-data]");
  if (_?.textContent)
    try {
      const D = JSON.parse(_.textContent);
      _u.createRoot(d).render(/* @__PURE__ */ b.jsx(Gv, { bundle: D }));
    } catch (D) {
      console.error("Unable to initialise Motech bundle configurator", D), d.insertAdjacentHTML(
        "beforeend",
        '<p class="motech-bundle-error">This package is temporarily unavailable.</p>'
      );
    }
});
